
import { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { checkbox_dom, inputdescribe_dom, partialtitle_dom, radiobtn_dom, title_dom } from '../Main/Planning/Invitationmaker/components/Commonelements/Commonelements';
import { Checkdevice, Etsydummypanel, Modcfm, Noti, Portalmodal, ScreenHeight, getCroppedImg } from '../../components';
import { ARROWLEFT_ICON, LOOKUPUNSTYLE_ICON, PLOBJ, e_fs, production, guestbookstub, DUMMY } from '../../config/constants';
import { Link } from 'react-router-dom';
import { Retrieve_personal_info, iconwrapper, pathsToImage } from '../../config/commonfunctions';
import { READ_DRAWBOOKEDIT, SAVE_DRAWBOOKSETTING, SAVE_DRAWBOOKGUESTVIEWPAGE, SAVE_DRAWBOOKGUESTVIEWPAGECOLOR, SAVE_DRAWBOOKOWNERVIEWPAGE, UPDATE_DRAWBOOKOWENREDITSINGLEENTRY, SAVE_DRAWBOOKOWNERPROPERTIES, SAVE_DRAWBOOKOWNERPROPERTIESANDSHAREDPROPERTIES, UPDATE_DRAWBOOKLOOKUPTYPE, DELETE_DRAWBOOKENTRY, ACTIVATE_GUESTBOOKPREMIUM, SAVE_DRAWBOOKGENERALSETTING, UPDATE_DRAWBOOKMAINIMGTOKEN, UPDATE_DRAWBOOKMAINIMGCFMSAVED } from '../../config/api';
import { CART_ICON, DOWNLOAD_ICON, IMAGES_ICON, LAPTOP_ICON, MOBILE_ICON, PLAY_ICON, PRINT_ICON, QUESTIONMARK_ICON, SETTING_ICON, TABLET_ICON, TRASH_ICON } from '../../config/svgicons';
import { Togglebutton } from '../../basic_components';
import { S3CLOUD_CLOUDFRONT } from '../../config/s3directories';
import { HexColorInput, HexColorPicker } from 'react-colorful';
import { getPresignedUrlsWithTokenWithLoad, notifyBackendUpload, uploadToS3 } from '../../config/uploadimgapis';
import Draganddropswap from './components/Draganddropswap/Draganddropswap';
import Cropper from 'react-easy-crop';
import Slider from 'rc-slider';
import pako from 'pako'
import axios from 'axios'
import * as d3 from 'd3';
import 'rc-slider/assets/index.css';
import './Guestbookedit.css';

const DEFAULT_COLORS = ["#000000", "#027a02", "#0000FF", "#FFFF00", "#FFC0CB"]
var QRCode = require('qrcode.react');

function DrawbookeditScatterPrintable_withcenterimage({
    guestdata,
    guestdataaddr,
    maxguestnum,

    dim,
    width = '100%',
    canvasRefs,
    zoomGroupRef,

    showpanel,
    scale,
    coord_x, setCoord_x,
    coord_y, setCoord_y,
    resetposition,
    setResetposition,

    cancelpanel, setCancelpanel,

    scatterallowimg,
    scatterallowimgcounter,
    scattercenterimg,

    mainimgsize,
    forcecenter_x,
    forcecenter_y,
    forcecollideradius,
    forcecharge,

}) {

    const vbwidth = 600;
    const vbheight = 800;

    const [nodeGroup, setNodeGroup] = useState(null)
    const [firsttime, setFirsttime] = useState(true)
    const [img, setImg] = useState('')

    const height = ScreenHeight()
    const svgRef = useRef();
    const zoomRef = useRef(); // <-- keep reference to zoom behavior
    const imagesCache = useRef({}) // Cache images in a ref so we don’t regenerate
    const simulationRef = useRef(null);

    const nodes = useMemo(() => {

        if (scatterallowimg) {
            return [
                {
                    id: "center_image",
                    r: dim, // Center node usually slightly larger
                    isCenter: true,
                    fx: vbwidth / 2,
                    fy: vbheight / 2,
                },
                ...Array.from({ length: Number(maxguestnum) }, (_, i) => {
                    const addr = guestdataaddr[i];
                    return addr
                        ? { id: addr, r: dim / 2, guest: guestdata[addr], isCenter: false }
                        : { id: "empty_" + i, r: 0, isCenter: false, empty: true };
                })
            ];
        }
        else {
            return Array.from({ length: Number(maxguestnum) }, (_, i) => {
                const addr = guestdataaddr[i];
                return addr
                    ? { id: addr, r: dim / 2, guest: guestdata[addr], empty: false }
                    : { id: "empty_" + i, r: 0, empty: true };
            });
        }


    }, [dim, scatterallowimg, guestdataaddr, guestdata, maxguestnum]);

    useEffect(() => {
        if (!guestdataaddr) return;

        // Pre-generate all images once
        guestdataaddr.forEach((id) => {
            const guest = guestdata[id];
            if (guest?.pathsarray?.length && !imagesCache.current[id]) {
                imagesCache.current[id] = guest.image
            }
        });

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove(); // clear previous SVG

        const defs = svg.append("defs");
        if (scatterallowimg) {

            defs.append("clipPath")
                .attr("id", "clip-center")
                .append("circle")
                .attr("cx", 0)
                .attr("cy", 0)
                .attr("r", mainimgsize);

            defs.append("clipPath")
                .attr("id", "clip-guest")
                .append("circle")
                .attr("cx", 0)
                .attr("cy", 0)
                .attr("r", mainimgsize / 2);

        }

        d3.select(svgRef.current).on("mousedown", async (e) => showpanel(e));

        // Create zoomable <g>
        const zoomGroup = svg.append("g");
        zoomGroupRef.current = zoomGroup;

        // Attach zoom/pan behavior and save ref
        // d3.zoomIdentity.translate(coord_x, coord_y, 1).scale(2);
        const zoom = d3.zoom()
            .scaleExtent([0.5, 5])
            .filter(() => d3.event.type === "mousedown" || d3.event.type === "mousemove") // ✅ allow only drag
            .on("zoom", () => {
                // Let D3 update the <g> live for smoothness
                zoomGroup.attr("transform", d3.event.transform);
            })
            .on("end", () => {
                // Only update parent state when user finishes interaction
                const { x = null, y = null } = d3.event.transform
                if (x) { setCoord_x(x) }
                if (y) { setCoord_y(y) }

            });


        zoomRef.current = zoom;
        svg.call(zoom);

        // FIX: Apply the initial state immediately upon creation
        const initialTransform = d3.zoomIdentity
            .translate(coord_x, coord_y)
            .scale(scale);

        svg.call(zoom.transform, initialTransform);

        // --- Draw nodes ---
        const nodeGroup = zoomGroup.selectAll("g")
            .data(nodes)
            .enter()
            .append("g")
            .style("cursor", d => (d.empty ? "default" : "pointer"))
            .each(function (d, i) { if (canvasRefs?.current) { canvasRefs.current[i] = this } });

        // Draw cached images and center image
        nodeGroup.each(function (d) {

            if (scatterallowimg) { // allow center image
                const el = d3.select(this);

                if (d.isCenter) { // center image

                    const size = mainimgsize * 2; // Diameter
                    el.append("image")
                        .attr("id", "center-image")   // 👈 add this
                        .attr("xlink:href", img)
                        .attr("x", -size / 2) // Center the image over the node center
                        .attr("y", -size / 2)
                        .attr("width", size)
                        .attr("height", size)
                        .attr("clip-path", "url(#clip-center)") // Apply the circular clip
                        .attr("preserveAspectRatio", "xMidYMid slice");

                }
                else if (!d.empty && imagesCache.current[d.id]) { // guest's doodle
                    const size = d.r
                    el.append("image")
                        .attr("xlink:href", imagesCache.current[d.id])
                        .attr("x", -size / 2)
                        .attr("y", -size / 2)
                        .attr("width", size)
                        .attr("height", size);
                }

            }
            else {
                if (!d.empty && imagesCache.current[d.id]) { // guest's doodle 
                    const size = d.r
                    d3.select(this)
                        .append("image")
                        .attr("xlink:href", imagesCache.current[d.id])
                        .attr("x", -d.r)
                        .attr("y", -d.r)
                        .attr("width", size)
                        .attr("height", size)
                }
            }

        });

        setNodeGroup(nodeGroup)

    }, [dim, scatterallowimg, guestdataaddr, guestdata, maxguestnum, scale, canvasRefs, img]);

    useEffect(() => {
        if (!nodeGroup) return;

        // STOP any existing simulation (important)
        simulationRef.current?.stop();

        simulationRef.current = d3.forceSimulation(nodes)
            .force("center", d3.forceCenter(vbwidth / forcecenter_x, vbheight / forcecenter_y))
            .force("collision", d3.forceCollide().radius(d => d.r + forcecollideradius))
            .force("charge", d3.forceManyBody().strength(forcecharge))
            .alphaDecay(0.01)
            .on("tick", () => {
                nodeGroup.attr("transform", d => {
                    // 🛑 BOUNDARY BOX LOGIC 🛑
                    // We constrain the x/y within the 0-800 and 0-600 range
                    // Subtracting/adding 'd.r' ensures the edge of the circle doesn't clip
                    d.x = Math.max(d.r, Math.min(vbwidth - d.r, d.x));
                    d.y = Math.max(d.r, Math.min(vbheight - d.r, d.y));
                    return `translate(${d.x},${d.y})`;
                });
            });

        return () => simulationRef.current?.stop();

    }, [dim, scatterallowimg, nodeGroup, nodes]); // ✅ ONLY structural deps

    useEffect(() => {

        if (!svgRef.current) return;
        if (scatterallowimg) {
            const svg = d3.select(svgRef.current);
            svg.select("#clip-center circle").attr("r", mainimgsize);
            svg.select("#clip-guest circle").attr("r", mainimgsize / 2);
        }

        if (!simulationRef.current) return;
        simulationRef.current
            .force("center", d3.forceCenter(vbwidth / forcecenter_x, vbheight / forcecenter_y))
            .force("collision", d3.forceCollide().radius(d => d.r + forcecollideradius))
            .force("charge", d3.forceManyBody().strength(forcecharge))
            .alpha(1) // reheat
            .restart();

    }, [dim, mainimgsize, forcecenter_x, forcecenter_y, forcecollideradius, forcecharge]);

    useEffect(() => { // zoom in and out
        if (zoomRef.current && svgRef.current && !firsttime) {
            const transform = d3.zoomIdentity
                .translate(vbwidth / 2, vbheight / 2) // zoom from center
                .scale(scale)
                .translate(-vbwidth / 2, -vbheight / 2);
            d3.select(svgRef.current).call(zoomRef.current.transform, transform);
        }
    }, [dim, scale]);

    useEffect(() => {
        // if (!resetposition || !zoomRef.current || !svgRef.current) return;

        // const svg = d3.select(svgRef.current);
        // const g = svg.select("g"); // your zoomGroupRef group

        // const bounds = g.node().getBBox();
        // const cx = bounds.x + bounds.width / 2;
        // const cy = bounds.y + bounds.height / 2;

        // const transform = d3.zoomIdentity
        //     .translate(vbwidth / 2, vbheight / 2)
        //     .scale(scale)
        //     .translate(-cx, -cy);

        // svg.transition()
        //     .duration(750)
        //     .call(zoomRef.current.transform, transform);

        // setResetposition(false);
        if (!resetposition || !zoomRef.current || !svgRef.current) return;

        const svg = d3.select(svgRef.current);

        const transform = d3.zoomIdentity
            .translate(vbwidth / 2, vbheight / 2) // zoom from center
            .scale(scale)
            .translate(-vbwidth / 2, -vbheight / 2);

        svg.transition()
            .duration(750)
            .call(zoomRef.current.transform, transform);

        setResetposition(false);
    }, [resetposition, scale]);

    useEffect(() => {
        if ((firsttime && scale) || cancelpanel) { // set the x and y during the firsttime
            let newTransform = d3.zoomIdentity.translate(coord_x, coord_y).scale(scale);
            d3.select(svgRef.current).call(zoomRef.current.transform, newTransform);
            setFirsttime(false)
        }
    }, [firsttime, svgRef, zoomRef, coord_x, coord_y, scale, cancelpanel])

    useEffect(() => { //  if user close the active panel, it will help rerender the svg
        if (cancelpanel) {
            const svg = d3.select(svgRef.current);
            let newTransform = d3.zoomIdentity.translate(coord_x, coord_y).scale(scale);
            svg.call(zoomRef.current.transform, newTransform);
            setCancelpanel(false)
        }
    }, [cancelpanel])

    useEffect(() => { // when enable disable image, center the svg // STOPPED HERE BEAR
        if (firsttime) return
        if (!resetposition || !zoomRef.current || !svgRef.current) return;

        const svg = d3.select(svgRef.current);
        const g = svg.select("g"); // your zoomGroupRef group

        const bounds = g.node().getBBox();
        const cx = bounds.x + bounds.width / 2;
        const cy = bounds.y + bounds.height / 2;

        const transform = d3.zoomIdentity
            .translate(vbwidth / 2, vbheight / 2)
            .scale(scale)
            .translate(-cx, -cy);

        svg.transition()
            .duration(750)
            .call(zoomRef.current.transform, transform);

        setResetposition(false);
    }, [img, scale,])

    useEffect(() => {
        if (scatterallowimgcounter > 0) {
            setTimeout(() => {
                const svg = d3.select(svgRef.current);
                const g = svg.select("g"); // your zoomGroupRef group

                const bounds = g.node().getBBox();
                const cx = bounds.x + bounds.width / 2;
                const cy = bounds.y + bounds.height / 2;

                const transform = d3.zoomIdentity
                    .translate(vbwidth / 2, vbheight / 2)
                    .scale(scale)
                    .translate(-cx, -cy);

                svg.transition()
                    .duration(750)
                    .call(zoomRef.current.transform, transform);

            }, 100)
        }
    }, [scatterallowimgcounter, scale])

    useEffect(() => {
        if (scattercenterimg.length !== 0) { setImg(scattercenterimg) }
    }, [scattercenterimg])

    return <svg
        ref={svgRef}
        className='Guestbookedit_printsvg'
        viewBox={`0 0 ${vbwidth} ${vbheight}`}
        style={{ width: width, height: height, display: "block", touchAction: "none" }}
    />

}

function DrawbookeditScatterPrintable_withoutcenterimage({
    guestdata,
    guestdataaddr,
    maxguestnum,

    dim,
    width = '100%',
    canvasRefs,
    zoomGroupRef,

    showpanel,
    scale,
    coord_x, setCoord_x,
    coord_y, setCoord_y,
    resetposition,
    setResetposition,
    cancelpanel,
    setCancelpanel,

    forcecenter_x,
    forcecenter_y,
    forcecollideradius,
    forcecharge,

    scatterallowimgcounter

}) {

    const vbwidth = 600;
    const vbheight = 800;

    const [nodeGroup, setNodeGroup] = useState(null)
    const [firsttime, setFirsttime] = useState(true)

    const height = ScreenHeight()
    const svgRef = useRef();
    const zoomRef = useRef(); // <-- keep reference to zoom behavior
    const imagesCache = useRef({}) // Cache images in a ref so we don’t regenerate
    const simulationRef = useRef(null);

    const nodes = useMemo(() => {

        return Array.from({ length: Number(maxguestnum) }, (_, i) => {
            const addr = guestdataaddr[i];
            return addr
                ? { id: addr, r: dim / 2, guest: guestdata[addr], empty: false }
                : { id: "empty_" + i, r: 0, empty: true };
        });

    }, [dim, guestdataaddr, guestdata, maxguestnum]);

    useEffect(() => {
        if (!guestdataaddr) return;

        // Pre-generate all images once
        guestdataaddr.forEach((id) => {
            const guest = guestdata[id];
            if (guest?.pathsarray?.length && !imagesCache.current[id]) {
                imagesCache.current[id] = guest.image
            }
        });

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove(); // clear previous SVG

        const defs = svg.append("defs");

        d3.select(svgRef.current).on("mousedown", async (e) => showpanel(e));

        // Create zoomable <g>
        const zoomGroup = svg.append("g");
        zoomGroupRef.current = zoomGroup;

        // Attach zoom/pan behavior and save ref
        d3.zoomIdentity.translate(coord_x, coord_y, 1).scale(2);
        const zoom = d3.zoom()
            .scaleExtent([0.5, 5])
            .filter(() => d3.event.type === "mousedown" || d3.event.type === "mousemove") // ✅ allow only drag
            .on("zoom", () => {
                // Let D3 update the <g> live for smoothness
                zoomGroup.attr("transform", d3.event.transform);
            })
            .on("end", () => {
                // Only update parent state when user finishes interaction
                const { x = null, y = null } = d3.event.transform
                if (x) { setCoord_x(x) }
                if (y) { setCoord_y(y) }

            });


        zoomRef.current = zoom;
        svg.call(zoom);

        // --- Draw nodes ---
        const nodeGroup = zoomGroup.selectAll("g")
            .data(nodes)
            .enter()
            .append("g")
            .style("cursor", d => (d.empty ? "default" : "pointer"))
            .each(function (d, i) { if (canvasRefs?.current) { canvasRefs.current[i] = this } });

        // Draw cached images and center image
        nodeGroup.each(function (d) {
            if (!d.empty && imagesCache.current[d.id]) { // guest's doodle 
                const size = d.r
                d3.select(this)
                    .append("image")
                    .attr("xlink:href", imagesCache.current[d.id])
                    .attr("x", -d.r)
                    .attr("y", -d.r)
                    .attr("width", size)
                    .attr("height", size)
            }
        });

        setNodeGroup(nodeGroup)

    }, [dim, guestdataaddr, guestdata, maxguestnum, scale, canvasRefs]);

    useEffect(() => {
        if (!nodeGroup) return;

        // STOP any existing simulation (important)
        simulationRef.current?.stop();

        simulationRef.current = d3.forceSimulation(nodes)
            .force("center", d3.forceCenter(vbwidth / forcecenter_x, vbheight / forcecenter_y))
            .force("collision", d3.forceCollide().radius(d => d.r + forcecollideradius))
            .force("charge", d3.forceManyBody().strength(forcecharge))
            .alphaDecay(0.01)
            .on("tick", () => {
                nodeGroup.attr("transform", d => {
                    // 🛑 BOUNDARY BOX LOGIC 🛑
                    // We constrain the x/y within the 0-800 and 0-600 range
                    // Subtracting/adding 'd.r' ensures the edge of the circle doesn't clip
                    d.x = Math.max(d.r, Math.min(vbwidth - d.r, d.x));
                    d.y = Math.max(d.r, Math.min(vbheight - d.r, d.y));
                    return `translate(${d.x},${d.y})`;
                });
            });

        return () => simulationRef.current?.stop();

    }, [dim, nodeGroup, nodes]); // ✅ ONLY structural deps

    useEffect(() => {
        if (!simulationRef.current) return;
        simulationRef.current
            .force("center", d3.forceCenter(vbwidth / forcecenter_x, vbheight / forcecenter_y))
            .force("collision", d3.forceCollide().radius(d => d.r + forcecollideradius))
            .force("charge", d3.forceManyBody().strength(forcecharge))
            .alpha(1) // reheat
            .restart();
    }, [dim, forcecenter_x, forcecenter_y, forcecollideradius, forcecharge]);

    useEffect(() => { // zoom in and out
        if (zoomRef.current && svgRef.current && !firsttime) {
            const transform = d3.zoomIdentity
                .translate(vbwidth / 2, vbheight / 2) // zoom from center
                .scale(scale)
                .translate(-vbwidth / 2, -vbheight / 2);
            d3.select(svgRef.current).call(zoomRef.current.transform, transform);
        }
    }, [dim, scale]);

    useEffect(() => {
        if (!resetposition || !zoomRef.current || !svgRef.current) return;

        const svg = d3.select(svgRef.current);
        const g = svg.select("g"); // your zoomGroupRef group

        const bounds = g.node().getBBox();
        const cx = bounds.x + bounds.width / 2;
        const cy = bounds.y + bounds.height / 2;

        const transform = d3.zoomIdentity
            .translate(vbwidth / 2, vbheight / 2)
            .scale(scale)
            .translate(-cx, -cy);

        svg.transition()
            .duration(750)
            .call(zoomRef.current.transform, transform);

        setResetposition(false);
    }, [resetposition, scale]);

    useEffect(() => {
        if ((firsttime && scale) || cancelpanel) { // set the x and y during the firsttime
            let newTransform = d3.zoomIdentity.translate(coord_x, coord_y).scale(scale);
            d3.select(svgRef.current).call(zoomRef.current.transform, newTransform);
            setFirsttime(false)
        }
    }, [firsttime, svgRef, zoomRef, coord_x, coord_y, scale, cancelpanel])

    useEffect(() => { //  if user close the active panel, it will help rerender the svg
        if (cancelpanel) {
            const svg = d3.select(svgRef.current);
            let newTransform = d3.zoomIdentity.translate(coord_x, coord_y).scale(scale);
            svg.call(zoomRef.current.transform, newTransform);
            setCancelpanel(false)
        }
    }, [cancelpanel])

    useEffect(() => {
        if (scatterallowimgcounter > 0) {
            setTimeout(() => {
                const svg = d3.select(svgRef.current);
                const g = svg.select("g"); // your zoomGroupRef group

                const bounds = g.node().getBBox();
                const cx = bounds.x + bounds.width / 2;
                const cy = bounds.y + bounds.height / 2;

                const transform = d3.zoomIdentity
                    .translate(vbwidth / 2, vbheight / 2)
                    .scale(scale)
                    .translate(-cx, -cy);

                svg.transition()
                    .duration(750)
                    .call(zoomRef.current.transform, transform);

            }, 100)
        }
    }, [scatterallowimgcounter])

    return <svg
        className='Guestbookedit_printsvg'
        ref={svgRef}
        viewBox={`0 0 ${vbwidth} ${vbheight}`}
        style={{ width: width, height: height, display: "block", touchAction: "none" }}
    />

}

function DrawbookeditScatterDevice({
    guestdata,
    guestdataaddr,
    maxguestnum,

    dim,
    width = "100%",
    height = ScreenHeight(),

    updateDisplay,
    canvasRefs,
    showpanel,

    scattercenterimg,
    scatterallowimg,
    scatterredirectlinks,
}) {
    const svgRef = useRef();
    const imagesCache = useRef({});

    const vbwidth = 800;
    const vbheight = 600;

    /* ------------------ NODES ------------------ */
    const nodes = useMemo(() => {
        if (!guestdataaddr) return [];

        if (scatterallowimg) {
            return [
                {
                    id: "center_image",
                    r: dim,
                    isCenter: true,
                    fx: vbwidth / 2,
                    fy: vbheight / 2,
                },
                ...Array.from({ length: Number(maxguestnum) }, (_, i) => {
                    const addr = guestdataaddr[i];
                    return addr
                        ? {
                            id: addr,
                            r: dim / 2,
                            guest: guestdata[addr],
                            isCenter: false,
                        }
                        : { id: "empty_" + i, r: 0, empty: true, isCenter: false };
                }),
            ];
        }

        return Array.from({ length: Number(maxguestnum) }, (_, i) => {
            const addr = guestdataaddr[i];
            return addr
                ? { id: addr, r: dim / 2, guest: guestdata[addr], empty: false }
                : { id: "empty_" + i, r: 0, empty: true };
        })

    }, [dim, scatterallowimg, guestdataaddr, guestdata, maxguestnum]);

    /* ------------------ EFFECT ------------------ */
    useEffect(() => {
        if (!svgRef.current || !nodes.length) return;

        /* ---- cache guest images ---- */
        guestdataaddr?.forEach((id) => {
            const guest = guestdata[id];
            if (guest?.image && !imagesCache.current[id]) {
                imagesCache.current[id] = guest.image;
            }
        });

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove();

        svg.on("mousedown", (e) => showpanel?.(e));

        /* ------------------ DEFS ------------------ */
        const defs = svg.append("defs");

        if (scatterallowimg) {
            defs
                .append("clipPath")
                .attr("id", "clip-center")
                .attr("clipPathUnits", "userSpaceOnUse")
                .append("circle")
                .attr("r", dim);

            defs
                .append("clipPath")
                .attr("id", "clip-guest")
                .attr("clipPathUnits", "userSpaceOnUse")
                .append("circle")
                .attr("r", dim / 2);
        }

        /* ------------------ ZOOM ------------------ */
        const zoomGroup = svg.append("g");

        const zoom = d3
            .zoom()
            .scaleExtent([0.5, 5])
            .on("zoom", () => {
                zoomGroup.attr("transform", d3.event.transform);
            });

        svg.call(zoom);

        /* ------------------ NODES ------------------ */
        const nodeGroup = zoomGroup
            .selectAll("g")
            .data(nodes)
            .enter()
            .append("g")
            .style("cursor", (d) => (d.empty ? "default" : "pointer"))
            .each(function (d, i) {
                if (canvasRefs?.current) canvasRefs.current[i] = this;
            })
            .on("click", function (event, d) {
                const { id, r } = event

                if (id === 'center_image') {

                }
                else if (r !== 0) {
                    updateDisplay(id);
                }



                // if (!d.empty) {
                //     // Example: log the clicked node


                //     // If you want to highlight it
                //     d3.select(this).select("circle")
                //         .attr("stroke", "red")
                //         .attr("stroke-width", 3);

                //     // Or trigger any React handler you pass down
                //     // onNodeClick?.(d);
                // }
            })


        /* ------------------ IMAGES ------------------ */
        nodeGroup.each(function (d) {
            const el = d3.select(this);

            if (d.isCenter) {
                const size = d.r * 2; // Diameter

                el.append("image")
                    .attr("xlink:href", scattercenterimg)
                    .attr("x", -size / 2) // Center the image over the node center
                    .attr("y", -size / 2)
                    .attr("width", size)
                    .attr("height", size)
                    .attr("clip-path", "url(#clip-center)") // Apply the circular clip
                    .attr("preserveAspectRatio", "xMidYMid slice")


            } else if (!d.empty && imagesCache.current[d.id]) {
                const size = d.r * 1.3;
                el.append("image")
                    .attr("xlink:href", imagesCache.current[d.id])
                    .attr("x", -size / 2)
                    .attr("y", -size / 2)
                    .attr("width", size)
                    .attr("height", size);
                // No clip path applied to guests as per request
            }
        });

        /* ------------------ FORCE ------------------ */
        const simulation = d3
            .forceSimulation(nodes)
            .force("center", d3.forceCenter(vbwidth / 2, vbheight / 2))
            .force("collision", d3.forceCollide().radius((d) => d.r + 4))
            .on("tick", () => {
                nodeGroup.attr(
                    "transform",
                    (d) =>
                        `translate(${d.x != null ? d.x : d.fx}, ${d.y != null ? d.y : d.fy
                        })`
                );
            });

        return () => simulation.stop();
    }, [nodes, guestdata, guestdataaddr, dim, scattercenterimg]);

    /* ------------------ SVG ------------------ */
    return (
        <svg
            className="Guestbookedit_printsvg Guestbookedit_printsvgdisplay"
            ref={svgRef}
            viewBox={`0 0 ${vbwidth} ${vbheight}`}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{
                width,
                height,
                display: "block",
                touchAction: "none",
            }}
        />
    );
}

function DrawbookeditScatterDevice_({
    guestdata,
    guestdataaddr,
    maxguestnum,

    dim,
    width = '100%',
    height = ScreenHeight(),

    updateDisplay,

    canvasRefs,

    showpanel,

    scattercenterimg,
    scatterallowimg,
    scatterredirectlinks,

}) {
    const svgRef = useRef();
    const vbwidth = 800;
    const vbheight = 600;

    const img = 'https://images.unsplash.com/photo-1621621667797-e06afc217fb0?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';

    // Cache images in a ref so we don’t regenerate
    const imagesCache = useRef({});

    const nodes = useMemo(() => {

        if (scatterallowimg) {
            return [
                {
                    id: "center_image",
                    r: dim, // Center node usually slightly larger
                    isCenter: true,
                    fx: vbwidth / 2,
                    fy: vbheight / 2,
                },
                ...Array.from({ length: Number(maxguestnum) }, (_, i) => {
                    const addr = guestdataaddr[i];
                    return addr
                        ? { id: addr, r: dim / 2, guest: guestdata[addr], isCenter: false }
                        : { id: "empty_" + i, r: 0, isCenter: false, empty: true };
                })
            ];
        }
        else {
            return Array.from({ length: Number(maxguestnum) }, (_, i) => {
                const addr = guestdataaddr[i];
                return addr
                    ? { id: addr, r: dim / 2, guest: guestdata[addr], empty: false }
                    : { id: "empty_" + i, r: 0, empty: true };
            });
        }

    }, [dim, scatterallowimg, guestdataaddr, guestdata, maxguestnum]);

    useEffect(() => {
        if (!guestdataaddr) return;

        // Pre-generate all images once
        guestdataaddr.forEach((id) => {
            const guest = guestdata[id];
            if (guest?.pathsarray?.length && !imagesCache.current[id]) {
                imagesCache.current[id] = guest.image
            }
        });

        d3.select(svgRef.current).on("mousedown", async (e) => showpanel());

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove(); // clear previous

        const defs = svg.append("defs");

        if (scatterallowimg) {

            defs.append("clipPath")
                .attr("id", "clip-center")
                .append("circle")
                .attr("cx", 0)
                .attr("cy", 0)
                .attr("r", 1);

            defs.append("clipPath")
                .attr("id", "clip-guest")
                .append("circle")
                .attr("cx", 0)
                .attr("cy", 0)
                .attr("r", 1 / 2);

        }


        // Create zoomable <g>
        const zoomGroup = svg.append("g");

        // Attach zoom/pan behavior (D3 v5 style: use d3.event)
        const zoom = d3.zoom()
            .scaleExtent([0.5, 5])
            .on("zoom", () => {
                zoomGroup.attr("transform", d3.event.transform);
            });

        svg.call(zoom);

        const nodeGroup = zoomGroup.selectAll("g")
            .data(nodes)
            .enter()
            .append("g")
            .style("cursor", d => (d.empty ? "default" : "pointer"))
            .each(function (d, i) {
                if (canvasRefs?.current) canvasRefs.current[i] = this;
            })
            .on("click", function (event, d) {
                const { id, r } = event
                if (r !== 0) {
                    updateDisplay(id);
                }
            })

        // 2. Draw the images
        nodeGroup.each(function (d) {
            const el = d3.select(this);

            if (d.isCenter) {
                const size = d.r * 2; // Diameter

                el.append("image")
                    .attr("xlink:href", img)
                    .attr("x", -size / 2) // Center the image over the node center
                    .attr("y", -size / 2)
                    .attr("width", size)
                    .attr("height", size)
                    .attr("clip-path", "url(#clip-center)") // Apply the circular clip
                    .attr("preserveAspectRatio", "xMidYMid slice");

            } else if (!d.empty && imagesCache.current[d.id]) {
                const size = d.r * 1.3;
                el.append("image")
                    .attr("xlink:href", imagesCache.current[d.id])
                    .attr("x", -size / 2)
                    .attr("y", -size / 2)
                    .attr("width", size)
                    .attr("height", size);
                // No clip path applied to guests as per request
            }
        });

        // Force simulation
        d3.forceSimulation(nodes)
            .force("center", d3.forceCenter(vbwidth / 2, vbheight / 2))
            .force("collision", d3.forceCollide().radius(d => d.r + 2))
            .on("tick", () => {
                nodeGroup.attr("transform", d => `translate(${d.x},${d.y})`);
            });


    }, [guestdata, guestdataaddr, maxguestnum, dim, canvasRefs, img]);

    return (
        <svg
            className='Guestbookedit_printsvg Guestbookedit_printsvgdisplay'
            ref={svgRef}
            viewBox={`0 0 ${vbwidth} ${vbheight}`
            }
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{
                width: width,
                height: height,
                display: "block",
                touchAction: "none" // important for mobile drag/zoom
            }}
        />
    );
}

function DrawbookeditScatterDevice_old({
    guestdata,
    guestdataaddr,
    maxguestnum,

    width = '100%',
    height = ScreenHeight(),

    updateDisplay,

    canvasRefs,

    showpanel,

    scatterallowimgcounter,
    dim,
    scattercenterimg,
    scatterallowimg,
    scatterredirectlinks,

}) {
    const svgRef = useRef();
    const vbwidth = 800;
    const vbheight = 600;

    // Cache images in a ref so we don’t regenerate
    const imagesCache = useRef({});

    const nodes = useMemo(() => {
        return Array.from({ length: Number(maxguestnum) }, (_, i) => {
            const addr = guestdataaddr[i];
            return addr
                ? { id: addr, r: dim / 2, guest: guestdata[guestdataaddr[i]], empty: false }
                : { id: "empty_" + i, r: 0, empty: true };
        });
    }, [guestdataaddr, maxguestnum, dim, guestdata]);

    useEffect(() => {
        if (!guestdataaddr) return;

        // Pre-generate all images once
        guestdataaddr.forEach((id) => {
            const guest = guestdata[id];
            if (guest?.pathsarray?.length && !imagesCache.current[id]) {
                imagesCache.current[id] = guest.image
            }
        });

        d3.select(svgRef.current).on("mousedown", async (e) => showpanel());

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove(); // clear previous

        // Create zoomable <g>
        const zoomGroup = svg.append("g");

        // Attach zoom/pan behavior (D3 v5 style: use d3.event)
        const zoom = d3.zoom()
            .scaleExtent([0.5, 5])
            .on("zoom", () => {
                zoomGroup.attr("transform", d3.event.transform);
            });

        svg.call(zoom);

        const nodeGroup = zoomGroup.selectAll("g")
            .data(nodes)
            .enter()
            .append("g")
            .style("cursor", d => (d.empty ? "default" : "pointer"))
            .each(function (d, i) {
                if (canvasRefs?.current) canvasRefs.current[i] = this;
            })
            .on("click", function (event, d) {
                const { id, r } = event
                if (r !== 0) {
                    updateDisplay(id);
                }
                // if (!d.empty) {
                //     // Example: log the clicked node


                //     // If you want to highlight it
                //     d3.select(this).select("circle")
                //         .attr("stroke", "red")
                //         .attr("stroke-width", 3);

                //     // Or trigger any React handler you pass down
                //     // onNodeClick?.(d);
                // }
            })

        // Draw cached images
        nodeGroup.each(function (d) {
            if (!d.empty && imagesCache.current[d.id]) {
                const size = d.r * 1.3;
                d3.select(this)
                    .append("image")
                    .attr("xlink:href", imagesCache.current[d.id])
                    .attr("x", -d.r)
                    .attr("y", -d.r)
                    .attr("width", size)
                    .attr("height", size)
            }
        });

        // nodeGroup.append("clipPath")
        //     .attr("id", d => "clip-" + d.id)
        //     .append("circle")
        //     .attr("r", d => d.r);

        // nodeGroup.append("circle")
        //     .attr("class", "border-circle") // important for selection
        //     .attr("r", d => d.r)
        //     .attr("fill", "transparent")
        //     .attr("stroke", "transparent")
        //     .attr('stroke-width', 1)

        // // Draw paths inside bubble
        // nodeGroup.append("g")
        //     .attr("clip-path", d => `url(#clip-${d.id})`)
        //     .each(function (d) {
        //         if (!d.empty && d.guest && d.guest.pathsarray) {
        //             const scale = (d.r * 2) / 400;
        //             const offset = -dim / 2;

        //             d3.select(this)
        //                 .append("g")
        //                 .attr("transform", `scale(${scale}) translate(${offset},${offset}) translate(-100,-100)`)
        //                 .selectAll("path")
        //                 .data(d.guest.pathsarray)
        //                 .enter()
        //                 .append("path")
        //                 .attr("d", p => p.points)
        //                 .attr("stroke", p => p.color || "black")
        //                 .attr("fill", "none")
        //                 .attr("stroke-width", 1 / scale);
        //         }
        //     });

        // Force simulation
        d3.forceSimulation(nodes)
            .force("center", d3.forceCenter(vbwidth / 2, vbheight / 2))
            .force("collision", d3.forceCollide().radius(d => d.r + 2))
            .on("tick", () => {
                nodeGroup.attr("transform", d => `translate(${d.x},${d.y})`);
            });

    }, [guestdata, guestdataaddr, maxguestnum, dim, canvasRefs]);

    return (
        <svg
            className='Guestbookedit_printsvg Guestbookedit_printsvgdisplay'
            ref={svgRef}
            viewBox={`0 0 ${vbwidth} ${vbheight}`}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{
                width: width,
                height: height,
                display: "block",
                touchAction: "none" // important for mobile drag/zoom
            }}
        />
    );
}

function LoooongGuestbook(props) { // split
    const {
        device,
        mainscale,
        bgcolor,
        guestdata,
        guestdataaddr,
        downloadablesegmentRefs,
        svgRef,
        warpwidthpx
    } = props;


    function estimateTextHeight(
        msg,
        fontSize = 40,
        maxWidth = 300,
        fontFamily = "Lato",
        lineHeight = 1.1
    ) {
        if (!msg) return 0;

        // Create an offscreen div
        const div = document.createElement("div");
        div.style.position = "absolute";      // remove from layout flow
        div.style.visibility = "hidden";      // invisible
        div.style.width = `${maxWidth}px`;    // set container width
        div.style.fontSize = `${fontSize}px`;
        div.style.fontFamily = fontFamily;
        div.style.lineHeight = lineHeight;
        div.style.whiteSpace = "pre-line";    // respect line breaks
        div.style.wordWrap = "break-word";    // wrap long words
        div.style.padding = "0";              // no extra spacing
        div.style.margin = "0";

        div.innerText = msg;                  // insert text

        document.body.appendChild(div);
        const height = div.scrollHeight;      // measure rendered height
        document.body.removeChild(div);       // cleanup

        return height + 20;
    }

    // const wt = 1748
    // const ht = 2480 // 7 tweets

    // const mainwt = 2480
    // const mainht = 1748
    const mainwt = 1748
    const mainht = 2480
    const denominator = 2

    const [segments, setSegments] = useState([])
    const [newguestdata, setNewguestdata] = useState({})

    useEffect(() => {

        if (guestdata) {

            let newguestdata = JSON.parse(JSON.stringify(guestdata))
            let NUM_REMAINDER = guestdataaddr.length % denominator
            let NUM_SEGMENT = parseInt(guestdataaddr.length / denominator) + (NUM_REMAINDER > 0 ? 1 : 0)
            let segments = [] // guestdataaddr divided into segments based on NUM_SEGMENT

            for (let i = 0; i < NUM_SEGMENT; i++) {
                segments.push([])
            }

            let j = 0;
            for (let i = 0; i < segments.length; i++) {
                for (let k = 0; k < denominator && j < guestdataaddr.length; k++, j++) {
                    segments[i].push(guestdataaddr[j])
                }
            }

            setSegments(JSON.parse(JSON.stringify(segments)))

            for (let i = 0; i < guestdataaddr.length; i++) {
                const { pathsarray } = newguestdata[guestdataaddr[i]]
                let new_paths = pathsarray.slice()

                newguestdata[guestdataaddr[i]]['paths'] = new_paths

                const { msg, name, img } = newguestdata[guestdataaddr[i]]

                const nameht = estimateTextHeight(name, 45, 1300)
                const msght = estimateTextHeight(msg, 45, 1300)

                newguestdata[guestdataaddr[i]]['current_name_pos'] = 0
                newguestdata[guestdataaddr[i]]['current_msg_pos'] = nameht
                newguestdata[guestdataaddr[i]]['current_img_pos'] = msg.length > 0 ? (msght + nameht + 100) : 0

                newguestdata[guestdataaddr[i]]['current_name_ht'] = name.length > 0 ? nameht : 0
                newguestdata[guestdataaddr[i]]['current_msg_ht'] = msg.length > 0 ? msght : 0
                newguestdata[guestdataaddr[i]]['current_img_ht'] = img.length > 0 ? 900 : 500

                if (i === 0) {
                    newguestdata[guestdataaddr[i]]['posY'] = 0
                }
                else if (i > 0) {
                    const { current_name_ht, current_msg_ht, current_img_ht, posY } = newguestdata[guestdataaddr[i - 1]] // get the previous item heights
                    newguestdata[guestdataaddr[i]]['posY'] = posY + current_name_ht + current_msg_ht + current_img_ht
                }

            }

            setNewguestdata(JSON.parse(JSON.stringify(newguestdata)))

            // const { current_name_ht, current_msg_ht, current_img_ht, posY } = newguestdata[guestdataaddr[guestdataaddr.length - 1]]
            // let elemht = current_name_ht + current_msg_ht + current_img_ht + posY

        }

    }, [guestdata, guestdataaddr])

    const [default_svg_properties] = useState({
        WEB: { width: 400, height: 150 },
        TABLET: { width: 350, height: 150 },
        MOBILE: { width: 300, height: 150 },
        PRINT: { width: 1748, height: 2480 },
    });

    const SYSTEM_DEVICE = Checkdevice();

    // convert point arrays into SVG path string
    const pointsToPath = (points) => {
        if (!points || points.length === 0) return "";
        return points
            .map((pt, i) => (i === 0 ? `M${pt.x},${pt.y}` : `L${pt.x},${pt.y}`))
            .join(" ");
    };

    if (!guestdata) return null;

    return <div
        ref={svgRef}
        style={{
            transform: `scale(${mainscale})`,
            display: "flex",
            position: "relative",
            flexDirection: "column",
            width:
                SYSTEM_DEVICE === "WEB"
                    ? "100%"
                    : default_svg_properties[device]?.width || "100%",
        }}
    >

        {segments.map((keys, index_segment) => {
            return <div
                key={'segment' + index_segment}
                style={{
                    display: "flex",
                    position: "relative",
                    marginBottom: 100,
                    boxShadow: "rgba(0, 0, 0, 0.15) 1px 5px 15px 0px",
                    width: "max-content",
                    flexDirection: 'column'
                }}
            >
                < svg
                    ref={(el) => {
                        if (downloadablesegmentRefs?.current) {
                            downloadablesegmentRefs.current[index_segment] = el;
                        }
                    }}
                    width={mainwt}
                    height={mainht}
                    viewBox={`0 0 ${mainwt} ${mainht}`}
                    style={{ backgroundColor: bgcolor, position: "relative" }}
                >
                    {keys.map((key, index_key) => {
                        const guest = newguestdata[key]

                        const profileimgX = 50
                        const rightX = 350 + profileimgX

                        const profileimgY = ((mainht / denominator) * index_key) + 50
                        const guestnameY = ((mainht / denominator) * index_key) + 80
                        const msgY = ((mainht / denominator) * index_key) + 100
                        const guestimgY = ((mainht / denominator) * index_key) + guest.current_msg_ht + 100

                        {/* Guest Drawing */ }
                        const guestdrawing_dom = <g transform={`translate(${profileimgX}, ${profileimgY})`}>
                            {guest.paths &&
                                guest.paths.map((p, i) => {
                                    const d = pointsToPath(p.points);
                                    if (!d) return null;
                                    return (
                                        <path
                                            key={i}
                                            d={d}
                                            stroke={p.color || "black"}
                                            strokeWidth={5}
                                            fill="none"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    );
                                })}
                        </g>

                        {/* Guest image */ }
                        const img_dom = guest.img.length > 0 && <g transform={`translate(${rightX}, ${guestimgY})`}>
                            <image
                                xlinkHref={S3CLOUD_CLOUDFRONT + guest.img}
                                x={0}
                                y={0}
                                width={500}
                                height={500}
                                preserveAspectRatio="xMinYMin meet" // fit inside, keep full image
                                onError={(e) => {
                                    console.error("SVG image failed:", e.currentTarget.href.baseVal);
                                }}
                            />
                        </g>

                        {/* Name */ }
                        const name_dom = <g transform={`translate(${rightX}, ${guestnameY})`}>
                            {guest.name && (
                                <text
                                    x={0}
                                    y={0}
                                    fontSize={36}
                                    fontWeight="bold"
                                    fill="#000"
                                    style={{ fontFamily: "Lato" }}
                                >
                                    {guest.name}
                                </text>
                            )}
                        </g>










                        {/* Guest message */ }
                        const msg_dom_old = <g transform={`translate(${rightX}, ${msgY})`}>
                            {guest.msg && (
                                <foreignObject width={1300} height={guest.current_msg_ht}>
                                    <div
                                        xmlns="http://www.w3.org/1999/xhtml"
                                        style={{
                                            fontSize: "36px",
                                            fontFamily: "Lato",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            overflow: "hidden",
                                            whiteSpace: 'pre-wrap'
                                        }}>
                                        {guest.msg}
                                    </div>
                                </foreignObject>
                            )}
                        </g>











                        /**
                         * Accurately measures the width of a string in pixels using a 2D Canvas context.
                         * The font must match the styling used in the SVG <text> element.
                         * @param {string} text - The string to measure.
                         * @param {string} font - The CSS font string (e.g., "36px Lato").
                         * @returns {number} The width of the text in pixels.
                         */
                        const getTextWidth = (text, font) => {
                            // Uses a memoized canvas context for efficiency.
                            const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
                            const context = canvas.getContext("2d");

                            context.font = font;
                            const metrics = context.measureText(text);
                            return metrics.width;
                        };



                        // --- Define Constants ---
                        const FONT_STYLE = "36px Lato"; // Must match your JSX attributes
                        const LINE_HEIGHT = 40; // Vertical spacing between lines
                        // ------------------------

                        /**
                         * Splits text into lines based on a specified pixel width using accurate measurement.
                         * The 'font' parameter is essential for measurement accuracy.
                         */
                        const wrapText = (text, maxWidth, font) => {
                            if (!text) return [];

                            // Split EXACTLY by raw newline, preserving blanks
                            const paragraphs = text.split(/\n/);

                            let finalLines = [];

                            for (let para of paragraphs) {
                                // CASE 1: literal blank line (e.g., two consecutive \n\n) → output empty row
                                if (para === "") {
                                    finalLines.push("");
                                    continue;
                                }

                                // CASE 2: wrap a normal paragraph
                                const words = para.split(/\s+/).filter(word => word.length > 0);
                                if (words.length === 0) {
                                    finalLines.push("");
                                    continue;
                                }

                                let currentLine = "";

                                for (let word of words) {
                                    const testString = currentLine ? `${currentLine} ${word}` : word;
                                    const testWidth = getTextWidth(testString, font);

                                    if (testWidth <= maxWidth) {
                                        currentLine = testString;
                                    } else {
                                        finalLines.push(currentLine);
                                        currentLine = word;
                                    }
                                }

                                // PUSH THE LAST LINE OF THE PARAGRAPH.
                                if (currentLine) {
                                    finalLines.push(currentLine);
                                }
                            }

                            // 💡 THE FIX: Replace truly empty strings with a Non-Breaking Space
                            // This forces the <tspan> to render and respect the LINE_HEIGHT 'dy' value.
                            const renderedLines = finalLines.map(line => line === "" ? "\u00A0" : line);

                            return renderedLines;
                        };

                        // --- Rendering Block ---

                        // 1. Call the new function using the actual pixel width and font style
                        const textLines = wrapText(guest.msg, warpwidthpx, FONT_STYLE);

                        const msg_dom = (
                            <g transform={`translate(${rightX}, ${msgY})`}>
                                {guest.msg && (
                                    <text
                                        x={0}
                                        y={0}
                                        // These attributes MUST match FONT_STYLE used in wrapText/getTextWidth
                                        fontSize={36}
                                        fill={'black'}
                                        fontFamily="Lato"
                                        dominantBaseline="hanging"
                                    >
                                        {/* Map the array of calculated lines to <tspan> elements */}
                                        {textLines.map((line, index) => (
                                            <tspan
                                                key={index}
                                                x={0}
                                                // This remains correct, applying the LINE_HEIGHT shift
                                                dy={index === 0 ? 0 : LINE_HEIGHT}
                                            >
                                                {/* line now contains either text or "\u00A0" */}
                                                {line}
                                            </tspan>
                                        ))}
                                    </text>
                                )}
                            </g>
                        );












                        return <g key={'segmentcontent' + index_key} >
                            {guestdrawing_dom}
                            {name_dom}
                            {img_dom}
                            {msg_dom}
                            {/* {msg_dom_old} */}
                        </g>


                    })}
                </svg>
            </div>
        })}

    </div>


    // return <div
    //     ref={svgRef}
    //     style={{
    //         transform: `scale(${mainscale})`,
    //         display: "flex",
    //         position: "relative",
    //         flexDirection: "column",
    //         width:
    //             SYSTEM_DEVICE === "WEB"
    //                 ? "100%"
    //                 : default_svg_properties[device]?.width || "100%",
    //     }}
    // >
    //     {segments.map((keys, index_segment) => {
    //         return <div
    //             key={'segment' + index_segment}
    //             style={{
    //                 display: "flex",
    //                 position: "relative",
    //                 marginBottom: 100,
    //                 boxShadow: "rgba(0, 0, 0, 0.15) 1px 5px 15px 0px",
    //                 width: "max-content",
    //                 flexDirection: 'column'
    //             }}
    //         >
    //             < svg
    //                 ref={(el) => {
    //                     if (downloadablesegmentRefs?.current) {
    //                         downloadablesegmentRefs.current[index_segment] = el;
    //                     }
    //                 }}
    //                 width={mainwt}
    //                 height={mainht}
    //                 // viewBox="0 0 1748 2480"
    //                 viewBox={`0 0 ${mainwt} ${mainht}`}
    //                 style={{ backgroundColor: bgcolor, position: "relative" }}
    //             >
    //                 {keys.map((key, index_key) => {
    //                     const guest = newguestdata[key]

    //                     const profileimgX = 50
    //                     const rightX = 350 + profileimgX

    //                     const profileimgY = ((mainht / denominator) * index_key) + 50
    //                     const guestnameY = ((mainht / denominator) * index_key) + 80
    //                     const msgY = ((mainht / denominator) * index_key) + 100
    //                     const guestimgY = ((mainht / denominator) * index_key) + guest.current_msg_ht + 100

    //                     {/* Guest Drawing */ }
    //                     const guestdrawing_dom = <g transform={`translate(${profileimgX}, ${profileimgY})`}>
    //                         {guest.paths &&
    //                             guest.paths.map((p, i) => {
    //                                 const d = pointsToPath(p.points);
    //                                 if (!d) return null;

    //                                 return (
    //                                     <path
    //                                         key={i}
    //                                         d={d}
    //                                         stroke={p.color || "black"}
    //                                         strokeWidth={2}
    //                                         fill="none"
    //                                         strokeLinecap="round"
    //                                         strokeLinejoin="round"
    //                                     />
    //                                 );
    //                             })}
    //                     </g>

    //                     {/* Guest image */ }
    //                     const img_dom = guest.img.length > 0 && <g transform={`translate(${rightX}, ${guestimgY})`}>
    //                         <image
    //                             xlinkHref={S3CLOUD_CLOUDFRONT + guest.img}
    //                             x={0}
    //                             y={0}
    //                             width={500}
    //                             height={500}
    //                             preserveAspectRatio="xMinYMin meet" // fit inside, keep full image
    //                             onError={(e) => {
    //                                 console.error("SVG image failed:", e.currentTarget.href.baseVal);
    //                             }}
    //                         />
    //                     </g>

    //                     {/* Name */ }
    //                     const name_dom = <g transform={`translate(${rightX}, ${guestnameY})`}>
    //                         {guest.name && (
    //                             <text
    //                                 x={0}
    //                                 y={0}
    //                                 fontSize={36}
    //                                 fontWeight="bold"
    //                                 fill="#000"
    //                                 style={{ fontFamily: "Lato" }}
    //                             >
    //                                 {guest.name} Name
    //                             </text>
    //                         )}
    //                     </g>

    //                     {/* Guest message */ }
    //                     const msg_dom = <g transform={`translate(${rightX}, ${msgY})`}>
    //                         {guest.msg && (
    //                             <foreignObject width={1300} height={guest.current_msg_ht}>
    //                                 <div xmlns="http://www.w3.org/1999/xhtml"
    //                                     style={{
    //                                         fontSize: "36px",
    //                                         fontFamily: "Lato",
    //                                         whiteSpace: "normal",
    //                                         wordWrap: "break-word",
    //                                         overflow: "hidden",
    //                                         whiteSpace: 'pre-wrap'
    //                                     }}>
    //                                     {guest.msg}
    //                                 </div>
    //                             </foreignObject>
    //                         )}
    //                     </g>

    //                     return <g key={'segmentcontent' + index_key} >
    //                         {guestdrawing_dom}
    //                         {name_dom}
    //                         {msg_dom}
    //                         {img_dom}
    //                     </g>

    //                 })}
    //             </svg>
    //         </div>
    //     })}
    // </div>


}

function UploadImage() {
    // this will directly upload image to backend
    return <div>

    </div>
}

const _0_instruction_page = 0
const _1_drawing_page = 1
const _2_writesomething_page = 2
const _3_success_page = 3
const _4_addimageornot_page = 4
const _6_success_page = 6
const _7_redirect_page = 7

const DraggablePanel = ({ children, initialPosition = { x: 200, y: 100 } }) => {

    const [position, setPosition] = useState(initialPosition)
    const [dragging, setDragging] = useState(false)
    const dragStart = useRef({ mouseX: 0, mouseY: 0, panelX: 0, panelY: 0 })

    const onMouseDown = (e) => {
        dragStart.current = {
            mouseX: e.clientX,
            mouseY: e.clientY,
            panelX: position.x,
            panelY: position.y,
        }
        setDragging(true)
    }

    const onMouseMove = (e) => {
        if (!dragging) return
        const dx = e.clientX - dragStart.current.mouseX
        const dy = e.clientY - dragStart.current.mouseY
        setPosition({
            x: dragStart.current.panelX + dx,
            y: dragStart.current.panelY + dy,
        })
    }

    const onMouseUp = () => {
        setDragging(false)
    }

    useEffect(() => {
        if (dragging) {
            window.addEventListener('mousemove', onMouseMove)
            window.addEventListener('mouseup', onMouseUp)
        }
        else {
            window.removeEventListener('mousemove', onMouseMove)
            window.removeEventListener('mouseup', onMouseUp)
        }
        return () => {
            window.removeEventListener('mousemove', onMouseMove)
            window.removeEventListener('mouseup', onMouseUp)
        }
    }, [dragging])

    return (
        <div className='Drawbookedit_dragpanelroot' style={position ? { left: position.x, top: position.y } : {}}>
            <button className='Drawbookedit_dragpaneldragbutton' onMouseDown={onMouseDown}>⠿</button>
            {children}
        </div>
    )
}

function GuestbookeditGriddataDisplay({ displaydata, playactive, drawbookid, urlhandler, passcode, setSavetxt, updateEntry, token, purchase, guestdata, guestdataaddr, setGuestdataaddr, nowshowing, setNowshowing, backupguestdataaddr, setBackupguestdataaddr }) {
    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [msg, setMsg] = useState('');
    const [paths, setPaths] = useState([]);
    const [img, setImg] = useState('')
    const [isPlaying, setIsPlaying] = useState(false);
    const [editcontent, setEditcontent] = useState(false)

    const [backupname, setBackupname] = useState('')
    const [backupmsg, setBackupmsg] = useState('')

    const [newname, setNewname] = useState('')
    const [newmsg, setNewmsg] = useState('')

    const canvasRef = useRef(null);
    const animationRef = useRef(null);
    const device = Checkdevice();

    useEffect(() => {
        if (displaydata) {

            const { name, msg, pathsarray = [], id, img } = displaydata;
            setName(name);
            setMsg(msg);
            setImg(img)
            let new_paths = pathsarray.slice()
            setPaths(new_paths);
            setId(id);
            setIsPlaying(false); // Reset playactive button when data changes

            const canvas = canvasRef.current;
            if (canvas) {
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }

            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        }
        else {
            setId('')
            setName('');
            setMsg('');
            setImg('')
            setPaths([])
            setIsPlaying(false)
            setNowshowing('DRAWING')
        }
    }, [displaydata, nowshowing]);

    const drawAnimated = () => {
        const canvas = canvasRef.current;
        if (!canvas || paths.length === 0) return;

        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        setIsPlaying(true);

        let pathIndex = 0;
        let pointIndex = 0;
        const POINTS_PER_FRAME = playactive ? 10000 : 10;

        const drawStep = () => {
            if (pathIndex >= paths.length) {
                return;
            }

            const path = paths[pathIndex];
            if (!path || path.points.length < 2) {
                pathIndex++;
                pointIndex = 0;
                animationRef.current = requestAnimationFrame(drawStep);
                return;
            }

            ctx.strokeStyle = path.color || 'black';
            ctx.lineWidth = 8;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';

            if (pointIndex === 0) {
                ctx.beginPath();
                ctx.moveTo(path.points[0].x, path.points[0].y);
                pointIndex++;
            }

            for (let i = 0; i < POINTS_PER_FRAME && pointIndex < path.points.length; i++) {
                const pt = path.points[pointIndex];
                ctx.lineTo(pt.x, pt.y);
                ctx.stroke();
                pointIndex++;
            }

            if (pointIndex >= path.points.length) {
                pathIndex++;
                pointIndex = 0;
            }

            animationRef.current = requestAnimationFrame(drawStep);
        };

        animationRef.current = requestAnimationFrame(drawStep);
    };

    useEffect(() => {
        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (playactive && paths.length > 0 && document.getElementsByClassName('Drawbookedit_play') && document.getElementsByClassName('Drawbookedit_play')[0]) {
            document.getElementsByClassName('Drawbookedit_play')[0].click()
        }
    }, [playactive, paths])

    const canvasSize = {
        WEB: 300,
        TABLET: 300,
        MOBILE: 175
    }[device] || 300;

    const canvasRatio = {
        WEB: 1,
        TABLET: 0.85,
        MOBILE: 0.85
    }[device] || 1;

    const changeGridcanvaview = (e) => {

        try {
            if (e.target.value !== 'SWAP' && nowshowing === 'SWAP') {
                // backupguestdataaddr={backupguestdataaddr}
                // setBackupguestdataaddr={setBackupguestdataaddr}
                // document.querySelector(".Draganddropswap_cancel").click();
                setGuestdataaddr(backupguestdataaddr.slice())
                setBackupguestdataaddr([])
            }
            else {

            }
        }
        catch (e) { }

        const { value } = e.target
        setNowshowing(value)

    }
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>

            {displaydata
                ? <div className='Drawingbookedit_darworimgbtnroot'>
                    <button className='Drawingbookedit_darworimgbtn' style={{ borderRight: 'none', borderRadius: '5px 0px 0px 5px', backgroundColor: nowshowing === 'DRAWING' ? 'var(--maindark)' : '#FFFFFF', color: nowshowing === 'DRAWING' ? '#FFFFFF' : 'var(--maindark)' }} onClick={changeGridcanvaview} value={'DRAWING'}>Drawing</button>
                    <button className='Drawingbookedit_darworimgbtn' style={{ borderRadius: '0px 5px 5px 0px', backgroundColor: nowshowing === 'IMAGE' ? 'var(--maindark)' : '#FFFFFF', color: nowshowing === 'IMAGE' ? '#FFFFFF' : 'var(--maindark)' }} onClick={changeGridcanvaview} value={'IMAGE'}>Image</button>
                    <button onClick={changeGridcanvaview} value={'SWAP'} style={{ marginLeft: 5, borderRadius: 5, fontSize: 12, border: '1px solid var(--subgrey)', backgroundColor: nowshowing === 'SWAP' ? 'var(--maindark)' : '#FFFFFF', color: nowshowing === 'SWAP' ? '#FFFFFF' : 'var(--maindark)' }}>Swap</button>
                </div>
                : null}

            <div style={{ width: '100%', display: 'flex', placeContent: 'center', backgroundColor: nowshowing === 'IMAGE' ? 'black' : '' }}>

                {(nowshowing === 'DRAWING' && paths && paths.length > 0)
                    ? <canvas
                        id={id}
                        ref={canvasRef}
                        width={canvasSize}
                        height={canvasSize}
                        style={{ transform: `scale(${canvasRatio})`, }}
                    />
                    : null}


                {/* style={{
                                transform: `scale(${dim / canvaswt})`,
                                transformOrigin: 'top left',
                                display: 'block',
                                backgroundColor: bgcolor
                            }} */}

                {/* {(nowshowing === 'DRAWING' && paths && paths.length > 0)
                    ? <canvas
                        id={id}
                        ref={canvasRef}
                        width={canvasSize}
                        height={canvasSize}
                    />
                    : null} */}

                {nowshowing === 'DRAWING'
                    ? <div style={{ textAlign: 'center', width: canvasSize, height: canvasSize, placeContent: 'center', display: 'flex', placeItems: 'center', top: 101, position: 'absolute', padding: 10, }}>
                        {(!isPlaying && paths && paths.length > 0)
                            ? <button className='Drawbookedit_play' onClick={drawAnimated}>
                                {iconwrapper(PLAY_ICON, { width: 30, height: 30, display: 'flex', placeContent: 'center' })}
                            </button>
                            : null}
                    </div>
                    : null}

                {(nowshowing === 'IMAGE' && img && img.length > 0)
                    ? <img src={S3CLOUD_CLOUDFRONT + img} width={canvasSize} height={canvasSize} style={{ objectFit: 'contain', }} />
                    : null}

            </div>

            {/* USER NOT EDITING */}
            {(nowshowing === 'DRAWING' || nowshowing === 'IMAGE') && !editcontent && name.length > 0 && msg.length > 0
                ? <div className='Drawbookedit_displaycontentroot'>
                    {inputdescribe_dom('Name', {})}
                    <div className='Drawbookedit_displayname' style={{ marginTop: 0 }}>{name}</div>
                    {inputdescribe_dom('Message', { marginTop: 10 })}
                    <div className='Drawbookedit_displaymsg' style={{ marginTop: 0 }}>{msg}</div>
                </div>
                : null}

            {/* USER NOT EDITING */}
            {(nowshowing === 'DRAWING' && nowshowing === 'IMAGE') && !editcontent && name.length > 0 && msg.length > 0 && purchase.status === 'BOUGHT'
                ? <button className='Drawbookedit_editcontentbtn' onClick={() => {

                    setEditcontent(true)

                    setBackupname(name)
                    setBackupmsg(msg)

                    setNewname(name)
                    setNewmsg(msg)

                }}>Edit</button>
                : null}


            {/* USER EDITING */}
            {(nowshowing === 'DRAWING' && nowshowing === 'IMAGE') && editcontent && name.length > 0 && msg.length > 0
                ? <div className='Drawbookedit_displaycontentroot'>
                    {inputdescribe_dom('Name', {})}
                    <input className='Drawbookedit_displayname' style={{ marginTop: 0, border: '1px solid var(--subgrey)', borderRadius: 5 }} value={newname} onChange={(e) => { setNewname(e.target.value) }} />
                    {inputdescribe_dom('Message', { marginTop: 10 })}
                    <textarea className='Drawbookedit_displaymsg' style={{ marginTop: 0, border: '1px solid var(--subgrey)', borderRadius: 5, height: '100%', resize: 'vertical' }} value={newmsg} onChange={(e) => { setNewmsg(e.target.value) }} />
                </div>
                : null}

            {/* USER EDITING */}
            {(nowshowing === 'DRAWING' && nowshowing === 'IMAGE') && editcontent && name.length > 0 && msg.length > 0
                ? <div className='Drawbookedit_editcontenttrue'>

                    <button
                        className='Drawbookedit_editcontentbtn'
                        style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: 'none', width: '30%' }}
                        onClick={() => {
                            setEditcontent(false)

                            setMsg(backupmsg)
                            setName(backupname)

                            setNewmsg('')
                            setNewname('')

                            setBackupname('')
                            setBackupmsg('')
                        }}>
                        Cancel
                    </button>

                    <button
                        className='Drawbookedit_editcontentbtn'
                        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, }}
                        onClick={() => {

                            axios({
                                method: 'POST',
                                url: UPDATE_DRAWBOOKOWENREDITSINGLEENTRY,
                                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                                data: { _id: drawbookid, urlhandler, passcode, newname, newmsg, entryid: id }
                            })
                                .then((item) => {
                                    const { message } = item.data
                                    if (message === 'SUCCESS') {
                                        setSavetxt('Saved!')
                                        updateEntry(newname, newmsg, id)
                                        setName(newname)
                                        setMsg(newmsg)
                                        setTimeout(() => {
                                            setSavetxt('')
                                            setNewmsg('')
                                            setNewname('')
                                            setBackupname('')
                                            setBackupmsg('')
                                            setEditcontent(false)
                                        }, 1000)
                                    }
                                })
                                .catch((e) => { })

                        }}>Save</button>

                </div>
                : null}

            {nowshowing === 'SWAP'
                ? <Draganddropswap
                    entryid={id}
                    guestdata={guestdata}
                    guestdataaddr={guestdataaddr}
                    setGuestdataaddr={setGuestdataaddr}

                    _id={drawbookid}
                    urlhandler={urlhandler}
                    token={token}

                    setSavetxt={setSavetxt}

                    backupguestdataaddr={backupguestdataaddr}
                    setBackupguestdataaddr={setBackupguestdataaddr}

                />
                : null}

        </div>
    );
}

const TextTitle = (props) => {
    return null
}

const OwnerArcTitle = (props) => {
    const {
        device,
        default_svg_properties, titledata,
        ownergridtitletopbool, updateOwnertitletopbool,
        ownergridsubtitletopbool, updateOwnersubtitletopbool,
        updatetitledata, updateTitletext,
        updatesubtitledata, updateSubtitletext,
        backuptitle, backupsubtitle,
        savetitle, savesubtitle,
        canceltitle, cancelsubtitle,
        gridactive,
        panelPosition,
        updatePanelAppearPosition
    } = props

    return <div style={{
        display: 'flex', position: 'relative', flexDirection: 'column', placeSelf: 'center',
        height: default_svg_properties[device].height,
        width: default_svg_properties[device].width,
    }}>

        <svg
            width={default_svg_properties[device].width}
            height={default_svg_properties[device].height}
            viewBox={"0 0 " + default_svg_properties[device].width + " " + default_svg_properties[device].height}
        >

            <defs>
                <path
                    id="topArc"
                    fill="transparent"
                    d={`
                        M 
                        ${titledata['title'][device]['style']['arc'].startX}, 
                        ${titledata['title'][device]['style']['arc'].startY} 
                        A 
                        ${titledata['title'][device]['style']['arc'].rx}, 
                        ${titledata['title'][device]['style']['arc'].ry} 
                        ${titledata['title'][device]['style']['arc']['x-axis-rotation']} 
                        ${titledata['title'][device]['style']['arc']['large-arc-flag']} 
                        ${titledata['title'][device]['style']['arc']['sweep-flag']} 
                        ${titledata['title'][device]['style']['arc'].endX}, 
                        ${titledata['title'][device]['style']['arc'].endY}
                        `}
                />
                <path
                    id="bottomArc"
                    d={`
                        M
                        ${titledata['subtitle'][device]['style']['arc'].startX},  
                        ${titledata['subtitle'][device]['style']['arc'].startY} 
                        A 
                        ${titledata['subtitle'][device]['style']['arc'].rx}, 
                        ${titledata['subtitle'][device]['style']['arc'].ry} 
                        ${titledata['subtitle'][device]['style']['arc']['x-axis-rotation']} 
                        ${titledata['subtitle'][device]['style']['arc']['large-arc-flag']} 
                        ${titledata['subtitle'][device]['style']['arc']['sweep-flag']} 
                        ${titledata['subtitle'][device]['style']['arc'].endX}, 
                        ${titledata['subtitle'][device]['style']['arc'].endY}
                    `}
                    fill="transparent"
                />
            </defs>

            <text
                fontSize={titledata['title'][device]['style']['arc'].fontSize}
                fill={titledata['title'][device]['style']['arc'].color}
                fontFamily={titledata['title'][device]['style']['arc'].fontFamily}
                dy={titledata['title'][device]['style']['arc'].dy}
                transform={`scale(${titledata['title'][device]['style']['arc'].scale})`}
                onClick={(e) => {
                    updatePanelAppearPosition(e)
                    updateOwnertitletopbool(e)
                    backuptitle(titledata['title'][device]['style']['arc'], titledata['title']['text'])
                }}
                style={{ cursor: 'pointer', width: titledata['title'][device]['style']['arc'].width }}
            >
                <textPath href="#topArc" startOffset="50%" textAnchor="middle">
                    {titledata['title']['text']}
                </textPath>
            </text>

            <text
                fontSize={titledata['subtitle'][device]['style']['arc'].fontSize}
                fill={titledata['subtitle'][device]['style']['arc'].color}
                fontFamily={titledata['subtitle'][device]['style']['arc'].fontFamily}
                dy={titledata['subtitle'][device]['style']['arc'].dy}
                transform={`scale(${titledata['subtitle'][device]['style']['arc'].scale})`}

                onClick={(e) => {
                    updatePanelAppearPosition(e)
                    updateOwnersubtitletopbool(e)
                    backupsubtitle(titledata['subtitle'][device]['style']['arc'], titledata['subtitle']['text'], device)
                }}
                style={{ cursor: 'pointer', width: titledata['subtitle'][device]['style']['arc'].width }}
            >
                <textPath href="#bottomArc" startOffset="50%" textAnchor="middle">
                    {titledata['subtitle']['text']}
                </textPath>
            </text>


            {/* Vertical center line */}
            {gridactive && <line
                x1={default_svg_properties[device].width / 2}
                y1={0}
                x2={default_svg_properties[device].width / 2}
                y2={default_svg_properties[device].height}
                stroke="#7c7c7c"
                strokeWidth={1}
                strokeDasharray="4 2"  // ← makes it dashed
            />}

            {/* Horizontal center line */}
            {gridactive && <line
                x1={0}
                y1={default_svg_properties[device].height / 2}
                x2={default_svg_properties[device].width}
                y2={default_svg_properties[device].height / 2}
                stroke="#7c7c7c"
                strokeWidth={1}
                strokeDasharray="4 2"  // ← makes it dashed
            />}

            {/* SVG Border */}
            {gridactive && <rect
                x={0}
                y={0}
                width={default_svg_properties[device].width}
                height={default_svg_properties[device].height}
                fill="none"
                stroke="#7c7c7c"
                strokeWidth={1}
                strokeDasharray="4 2"  // ← makes it dashed
            />}

        </svg>

    </div>

}

function DrawbookeditGrid({ bgcolor, guestdata, guestdataaddr, maxguestnum, updateDisplay }) {

    const imagesCache = useRef({}); // store image URLs or base64 strings

    useEffect(() => {
        guestdataaddr?.forEach((id) => {
            const guest = guestdata[id];
            if (guest?.image && !imagesCache.current[id]) {
                imagesCache.current[id] = guest.image; // cache the image
            }
        });
    }, [guestdataaddr, guestdata]);

    let dimroot = 100
    let dim = 60;

    return (
        <div
            className="Drawbookedit_grid"
            style={{
                gridTemplateColumns: `repeat(auto-fill, minmax(${maxguestnum === 30 ? 100 : dimroot}px, 1fr))`,
                marginTop: '1.5%',
                width:'100%',
            }}
        >
            {Array.from({ length: Number(maxguestnum) }).map((_, i) => {
                const id = guestdataaddr[i];

                let newdimroot = 0
                let newdim = 0

                if (maxguestnum === 30) {
                    newdimroot = 100
                    newdim = 100
                }
                else {
                    newdimroot = dimroot
                    newdim = dim
                }

                if (id) {
                    const imgSrc =
                        imagesCache.current[id] ||
                        guestdata[id]?.image ||
                        null;

                    return (
                        <div
                            key={id + '_' + i}
                            style={{
                                width: newdimroot,
                                height: newdimroot,
                                backgroundColor: bgcolor,
                                overflow: 'hidden',
                                position: 'relative',
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                placeContent:'center',
                                placeSelf:'center'
                            }}
                            onClick={() => updateDisplay(id)}
                        >
                            {imgSrc
                                ? <img
                                    src={imgSrc}
                                    alt=""
                                    style={{
                                        width: newdim,
                                        height: newdim,
                                        objectFit: "contain",
                                        display: "block",
                                    }}
                                />
                                : <div
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: bgcolor,
                                    }}
                                />}
                        </div>
                    );
                }

                // Empty slot
                return (
                    <div
                        key={"empty_" + i}
                        style={{
                            width: dim,
                            height: dim,
                            overflow: "hidden",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {guestbookstub}
                    </div>
                );
            })}
        </div>
    );
}

function OwnerArcTitleSVG(props) {
    const {
        device, bgcolor,
        title_svg_properties, titledata,
        ownergridtitletopbool, updateOwnertitletopbool,
        ownergridsubtitletopbool, updateOwnersubtitletopbool,
        updatetitledata, updateTitletext,
        updatesubtitledata, updateSubtitletext,
        backuptitle, backupsubtitle,
        savetitle, savesubtitle,
        canceltitle, cancelsubtitle,
        gridactive,
        updatePanelAppearPosition,
        downloadtransparent
    } = props

    return <svg
        width={title_svg_properties[device].width}
        height={title_svg_properties[device].height}
        viewBox={"0 0 " + title_svg_properties[device].width + " " + title_svg_properties[device].height}
    >
        <rect
            width="100%"
            height="100%"
            fill={!downloadtransparent ? bgcolor : 'none'} // your background color
        />

        <defs>
            <path
                id="topArc"
                d={`
                        M 
                        ${titledata['title'][device]['style']['arc'].startX}, 
                        ${titledata['title'][device]['style']['arc'].startY} 
                        A 
                        ${titledata['title'][device]['style']['arc'].rx}, 
                        ${titledata['title'][device]['style']['arc'].ry} 
                        ${titledata['title'][device]['style']['arc']['x-axis-rotation']} 
                        ${titledata['title'][device]['style']['arc']['large-arc-flag']} 
                        ${titledata['title'][device]['style']['arc']['sweep-flag']} 
                        ${titledata['title'][device]['style']['arc'].endX}, 
                        ${titledata['title'][device]['style']['arc'].endY}
                        `}
            />
            <path
                id="bottomArc"
                d={`
                        M
                        ${titledata['subtitle'][device]['style']['arc'].startX},  
                        ${titledata['subtitle'][device]['style']['arc'].startY} 
                        A 
                        ${titledata['subtitle'][device]['style']['arc'].rx}, 
                        ${titledata['subtitle'][device]['style']['arc'].ry} 
                        ${titledata['subtitle'][device]['style']['arc']['x-axis-rotation']} 
                        ${titledata['subtitle'][device]['style']['arc']['large-arc-flag']} 
                        ${titledata['subtitle'][device]['style']['arc']['sweep-flag']} 
                        ${titledata['subtitle'][device]['style']['arc'].endX}, 
                        ${titledata['subtitle'][device]['style']['arc'].endY}
                    `}
            />
        </defs>

        <text
            fontSize={titledata['title'][device]['style']['arc'].fontSize}
            fill={titledata['title'][device]['style']['arc'].color}
            fontFamily={titledata['title'][device]['style']['arc'].fontFamily}
            dy={titledata['title'][device]['style']['arc'].dy}
            transform={`scale(${titledata['title'][device]['style']['arc'].scale})`}
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
                backuptitle(titledata['title'][device]['style']['arc'], titledata['title']['text'])
                updatePanelAppearPosition(e)
                updateOwnertitletopbool(e)
            }}
        >
            <textPath href="#topArc" startOffset="50%" textAnchor="middle">
                {titledata['title']['text']}
            </textPath>
        </text>

        <text
            fontSize={titledata['subtitle'][device]['style']['arc'].fontSize}
            fill={titledata['subtitle'][device]['style']['arc'].color}
            fontFamily={titledata['subtitle'][device]['style']['arc'].fontFamily}
            dy={titledata['subtitle'][device]['style']['arc'].dy}
            transform={`scale(${titledata['subtitle'][device]['style']['arc'].scale})`}
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
                backupsubtitle(titledata['subtitle'][device]['style']['arc'], titledata['subtitle']['text'], device)
                updatePanelAppearPosition(e)
                updateOwnersubtitletopbool(e)
            }}
        >
            <textPath href="#bottomArc" startOffset="50%" textAnchor="middle">
                {titledata['subtitle']['text']}
            </textPath>
        </text>

        {/* Vertical center line */}
        {gridactive && <line
            x1={title_svg_properties[device].width / 2}
            y1={0}
            x2={title_svg_properties[device].width / 2}
            y2={title_svg_properties[device].height}
            stroke="#7c7c7c"
            strokeWidth={1}
            strokeDasharray="4 2"  // ← makes it dashed
        />}

        {/* Horizontal center line */}
        {gridactive && <line
            x1={0}
            y1={title_svg_properties[device].height / 2}
            x2={title_svg_properties[device].width}
            y2={title_svg_properties[device].height / 2}
            stroke="#7c7c7c"
            strokeWidth={1}
            strokeDasharray="4 2"  // ← makes it dashed
        />}

        {/* SVG Border */}
        {gridactive && <rect
            x={0}
            y={0}
            width={title_svg_properties[device].width}
            height={title_svg_properties[device].height}
            fill="none"
            stroke="#7c7c7c"
            strokeWidth={1}
            strokeDasharray="4 2"  // ← makes it dashed
        />}

    </svg>


}

function DrawbookeditGridSVG_old(props) {

    const {
        properties,
        default_svg_properties,
        title_svg_properties,
        bgcolor,
        device,
        guestdata,
        guestdataaddr,
        maxguestnum,
        updateDisplay,
        titleactive,
        placeholderactive,
        downloadtransparent
    } = props;

    const { sprite_root_scalefactor = 1, sprite_root_y = 0, sprite_dim = 50 } = properties?.PRINT?.GRID || {};
    const baseSize = 300; // the coordinate system of the images (300x300)

    const svgWidth = default_svg_properties[device].width;
    const svgHeight = default_svg_properties[device].height - (titleactive ? title_svg_properties[device].height : 0);

    // how many columns fit
    const cols = Math.floor(svgWidth / sprite_dim);

    const extraspace = svgWidth - cols * sprite_dim;
    const spacing = extraspace > 0 ? extraspace / cols : 0;

    const items = Array.from({ length: Number(maxguestnum) });

    const scale = (sprite_dim + spacing) / baseSize;

    const dx = (svgWidth * (1 - sprite_root_scalefactor)) / 2;
    const dy = (svgHeight * (1 - sprite_root_scalefactor)) / 2;

    const totalRows = Math.ceil(items.length / cols);
    const gridHeight = totalRows * (sprite_dim + spacing);

    return (
        <g transform={`translate(${dx}, ${dy + sprite_root_y}) scale(${sprite_root_scalefactor})`}>
            <svg
                // width={svgWidth}
                // height={svgHeight}
                width={svgWidth}
                height={gridHeight} // Change this from svgHeight to gridHeight
                viewBox={`0 0 ${default_svg_properties[device].width} ${cols * baseSize}`}

                // viewBox={`0 0 ${svgWidth} ${svgHeight}`}
                xmlns="http://www.w3.org/2000/svg"
                fill={!downloadtransparent ? bgcolor : "none"}
            >o
                {items.map((_, i) => {
                    const id = guestdataaddr[i];
                    const col = i % cols;
                    const row = Math.floor(i / cols);
                    const x = col * (sprite_dim + spacing);
                    const y = row * (sprite_dim + spacing);

                    const imgSrc = id ? guestdata[id]?.image : null;

                    return (
                        <g
                            key={id + "_" + i}
                            transform={`translate(${x}, ${y}) scale(${scale})`}
                            onClick={() => id && updateDisplay(id)}
                            style={{ cursor: id ? "pointer" : "default" }}
                        >
                            {/* background hit area */}
                            <rect width={baseSize} height={baseSize} fill="none" />

                            {imgSrc /* If guest has image, show it */
                                // ? <image href={imgSrc} x="0" y="0" width={baseSize} height={baseSize} preserveAspectRatio="xMidYMid meet" />
                                ? <image
                                    href={imgSrc}
                                    x={(baseSize - sprite_dim) / 2}
                                    y={(baseSize - sprite_dim) / 2}
                                    width={sprite_dim}
                                    height={sprite_dim}
                                    preserveAspectRatio="xMidYMid meet"
                                />
                                : placeholderactive
                                    ? <text // Otherwise show placeholder icon/text
                                        x={baseSize / 2}
                                        y={baseSize / 2}
                                        textAnchor="middle"
                                        dominantBaseline="middle"
                                        fill="black"
                                        fontSize={50}
                                        lengthAdjust="spacingAndGlyphs"
                                    >
                                        {guestbookstub}
                                    </text>
                                    : <text
                                        x={baseSize / 2}
                                        y={baseSize / 2}
                                        textAnchor="middle"
                                        dominantBaseline="middle"
                                        fill="black"
                                        fontSize={50}
                                        lengthAdjust="spacingAndGlyphs"

                                    />}
                        </g>
                    );
                })}
            </svg>
        </g>
    );
}

function DrawbookeditGridSVG(props) {
    const {
        properties,
        default_svg_properties,
        title_svg_properties,
        bgcolor,
        device,
        guestdata,
        guestdataaddr,
        maxguestnum,
        updateDisplay,
        titleactive,
        placeholderactive,
        downloadtransparent
    } = props;

    const {
        sprite_root_scalefactor = 1,
        sprite_root_y = 0,
        sprite_dim = 50
    } = properties?.PRINT?.GRID || {};

    const baseSize = 300; // intrinsic sprite coordinate system

    // --- SVG viewport size ---
    const svgWidth = default_svg_properties[device].width;
    const svgHeight =
        default_svg_properties[device].height -
        (titleactive ? title_svg_properties[device].height : 0);

    // --- Grid layout ---
    const cols = Math.max(1, Math.floor(svgWidth / sprite_dim));
    const extraspace = svgWidth - cols * sprite_dim;
    const spacing = extraspace > 0 ? extraspace / cols : 0;

    const items = Array.from({ length: Number(maxguestnum) });

    const totalRows = Math.ceil(items.length / cols);
    const gridHeight = totalRows * (sprite_dim + spacing);

    // --- Scaling ---
    const spriteScale = (sprite_dim + spacing) / baseSize;
    const scaledGridHeight = gridHeight * sprite_root_scalefactor;

    // --- Centering math ---
    const dx = (svgWidth * (1 - sprite_root_scalefactor)) / 2;

    const dy = Math.max(
        (svgHeight - scaledGridHeight) / 2,
        0
    );

    return (
        <g
            transform={`translate(${dx}, ${dy + sprite_root_y}) scale(${sprite_root_scalefactor})`}
        >
            <svg
                width={svgWidth}
                height={gridHeight}
                viewBox={`0 0 ${svgWidth} ${gridHeight}`}
                xmlns="http://www.w3.org/2000/svg"
                fill={!downloadtransparent ? bgcolor : "none"}
            >
                {items.map((_, i) => {
                    const id = guestdataaddr[i];
                    const col = i % cols;
                    const row = Math.floor(i / cols);

                    const x = col * (sprite_dim + spacing);
                    const y = row * (sprite_dim + spacing);

                    const imgSrc = id ? guestdata[id]?.image : null;

                    return (
                        <g
                            key={`${id}_${i}`}
                            transform={`translate(${x}, ${y}) scale(${spriteScale})`}
                            onClick={() => id && updateDisplay(id)}
                            style={{ cursor: id ? "pointer" : "default" }}
                        >
                            {/* background hit area */}
                            <rect
                                width={baseSize}
                                height={baseSize}
                                fill="none"
                            />

                            {imgSrc ? (
                                <image
                                    href={imgSrc}
                                    x={(baseSize - sprite_dim) / 2}
                                    y={(baseSize - sprite_dim) / 2}
                                    width={sprite_dim}
                                    height={sprite_dim}
                                    preserveAspectRatio="xMidYMid meet"
                                />
                            ) : placeholderactive ? (
                                <text
                                    x={baseSize / 2}
                                    y={baseSize / 2}
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                    fill="black"
                                    fontSize={50}
                                >
                                    {guestbookstub}
                                </text>
                            ) : null}
                        </g>
                    );
                })}
            </svg>
        </g>
    );
}

function Guestbookedit(props) {

    const { token } = Retrieve_personal_info()

    const [drawbookid, setDrawbookid] = useState('')
    const [page, setPage] = useState(''); // SELECTGUESTNUM, GUESTACTIVE, OWNERACTIVE
    const [mode, setMode] = useState('') // DEFAULT, BROADCASTNFT,DEFAULT_AND_BROADCASTNFT
    const [returnhome, setReturnhome] = useState(false)
    const [savetxt, setSavetxt] = useState('')
    const [questionmarkmodal, setQuestionmarkmodal] = useState(false) // for purchase, show advance modal
    const [purchasemodal, setPurchasemodal] = useState(false) // for purchase, show advance modal
    const [purchasecode, setPurchasecode] = useState('')
    const [shownftcounter, setShownftcounter] = useState(0) // if reach 20 it will show the option to switch it to nft type guestbook

    const [settingbool, setSettingbool] = useState(false)
    const [printbool, setPrintbool] = useState(false)

    const [savefrom, setSavefrom] = useState('') // GUEST_SAVE_TITLE, GUEST_SAVE_SUBTITLE, OWNER_SAVE_GRID_ANYDEVICE_TITLE, OWNER_SAVE_GRID_SUBTITLE, OWNER_SAVE_SCATTER_PRINT_TITLE
    const [guestsavebool, setGuestsavebool] = useState(false)
    const [ownersavebool, setOwnersavebool] = useState(false)

    // data display on right empty space. only when page is GUEST
    const [displaydata, setDisplaydata] = useState(null)

    // edit print qr code
    const [ownerprintqrbool, setOwnerprintqrbool] = useState(false)

    const [ownerscattertitletopbool, setOwnerscattertitletopbool] = useState(false)

    // Owner title and subtitle modal
    const [ownergridtitletopbool, setOwnergridtitletopbool] = useState(false);
    const [ownergridsubtitletopbool, setOwnergridsubtitletopbool] = useState(false);

    // Scatter print modal
    const [ownerscatterprintbool, setOwnerscatterprintbool] = useState(false);

    // Scatter web,tablet,mobile modal
    const [ownerscatterotherdevicebool, setOwnerscatterotherdevicebool] = useState(false);

    // Owner spriteroot modal
    const [ownergridspriterootbool, setOwnergridspriterootbool] = useState(false)

    // properties of non-title stuff, like sprite
    const [properties, setProperties] = useState({})
    const [sharedproperties, setSharedproperties] = useState({})

    // sharedproperties, for scatter, once data change, is shared among all devices, including print.
    const [scatterallowimgcounter, setScatterallowimgcounter] = useState(0)

    // Owner backupdata
    const [backupproperties, setBackupproperties] = useState({})

    const [backupsharedproperties, setBackupsharedproperties] = useState({})

    // Owner arc title backup data
    const [backuptitledata, setBackuptitledata] = useState({})
    const [backupsubtitledata, setBackupsubtitledata] = useState({})

    // Guest input backup
    const [guestinputbackup, setGuestinputbackup] = useState({})

    const [backupguestdataaddr, setBackupguestdataaddr] = useState([])

    // Guest - Entry Page modal
    const [editentrytitletop, setEditentrytitletop] = useState(false); // guest top title pop up
    const [editentrytitlebtm, setEditentrytitlebtm] = useState(false); // guest subtitle pop up
    const [editentrytextarea, setEditentrytextarea] = useState(false); // guest textarea pop up

    // Guest - Draw Page
    const [editcolorbool, setEditcolorbool] = useState(false)
    const [editdrawguidebool, setEditdrawguidebool] = useState(false)

    // Guest - REDIRECT LINK PAGE
    const [editredirectbool, setEditredirectbool] = useState(false)

    // Guest - PANEL for guest's name and guest's message placeholder panel
    const [editmessagebool, setEditmessagebool] = useState(false)

    // Guest - Panel for successfully update drawing and guest name and msg posts
    const [editsuccessdrawingbool, setEditsuccessdrawingbool] = useState(false)

    // Guest - Panel for placeholder of page, guest want upload image or not
    const [edituploadimageornotbool, setEdituploadimageornotbool] = useState(false)

    // Guest - Panel for successfully update success text
    const [editsuccessuploadimagebool, setEditsuccessuploadimagebool] = useState(false)

    // SETTING
    const [allowimgupload, setAllowimgupload] = useState(false)

    const [backupactive, setBackupactive] = useState({ gridactive: false, playactive: true, titleactive: true, qractive: true, placeholderactive: true, mode: '' })
    const [gridactive, setGridactive] = useState(false)
    const [playactive, setPlayactive] = useState(true)
    const [titleactive, setTitleactive] = useState(true)
    const [qractive, setQractive] = useState(true)
    const [placeholderactive, setPlaceholderactive] = useState(true)

    // Background color
    const [colorbool, setColorbool] = useState(false)
    const [bgcolor, setBgcolor] = useState(null)
    const [fontcolor, setFontcolor] = useState(null)
    const [colorbackup, setColorbackup] = useState('')

    // scale the print, allow user to zoom out to before doing other edits
    const [gridmainscale, setGridmainscale] = useState(0.23)
    const [scattermainscale, setScattermainscale] = useState(0.23)

    const [device, setDevice] = useState('PRINT') // WEB, TABLET, MOBILE, PRINT

    // for device : PRINT only
    const [currentprint, setCurrentprint] = useState('SPRITE') // SPRITE, GUESTBOOK

    const [downloadtransparent, setDownloadtransparent] = useState(false) // transparent if is true, for download

    const [titledata, setTitledata] = useState(null)

    const [lookuptype, setLookuptype] = useState('SCATTER')// GRID, SCATTER
    const [gtpp, setGtpp] = useState(null)// got purchase
    const [dbtype, setDbtype] = useState(null)// wedding, birthday etc
    const [guestdataaddr, setGuestdataaddr] = useState([]) // order of guestdata
    const [nowshowing, setNowshowing] = useState('DRAWING') // grid data showing what content now
    const [guestdata, setGuestdata] = useState({}) // the object of guestdata based on unique id
    const [maxguestnum, setMaxguestnum] = useState(null)
    const [modcontact, setModcontact] = useState(null)
    const [passcode, setPasscode] = useState(null)
    const [passcodemod, setPasscodemod] = useState(null)
    const [purchase, setPurchase] = useState(null)
    const [uId, setUId] = useState(null)
    const [urlhandler, setUrlhandler] = useState(null)

    const [selectedguestpage, setSelectedguestpage] = useState(0) // GUEST page 1, and GUEST page 2
    const [guestpages, setGuestpages] = useState([])

    const [panelPosition, setPanelPosition] = useState({ x: 200, y: 100 })

    const [entrydeletecmodal, setEntrydeletecmodal] = useState(false)

    const [resetposition, setResetposition] = useState(false)
    const [cancelpanel, setCancelpanel] = useState(false)


    // for cropping image
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [tempmainaspectratio, setTempmainimgaspectratio] = useState(-1)
    const [tempmainimg, setTempmainimg] = useState(null)
    const [tempmainimginfo, setTempmainimginfo] = useState(null)
    const [tempcroppedimg, setTempcroppedimg] = useState(null)
    const [neededit, setNeededit] = useState(false)
    const [uploadstate, setUploadstate] = useState('WAITING') // WAITING, UPLOADING
    const [status, setStatus] = useState('')


    // for currentprint = 'GUESTBOOK', control the text width of the guestbook
    const [warpwidthpx, setWarpwidthpx] = useState(1222)

    const svgRef = useRef(null);

    const canvasRefs = useRef([]);

    const zoomGroupRef = useRef(); // store zoom group for slider control

    const downloadablesegmentRefs = useRef([])

    const imginputref = useRef(null)

    const [availablecolors, setAvailablecolors] = useState([])
    const [currhexcolor, setCurrhexcolor] = useState('')

    const SYSTEM_DEVICE = Checkdevice()

    useEffect(() => {
        props.hidetopbar(true);
        var id = props.match.params.id

        axios({
            method: 'POST',
            url: READ_DRAWBOOKEDIT,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
            data: { _id: id }
        })
            .then(async (item) => {
                const { message, result } = item.data
                if (message === 'SUCCESS') {
                    const {
                        _id,
                        gtpp, dbtype, guestdataaddr, guestdata, mode,
                        maxguestnum, bgcolor, modcontact, passcode, passcodemod,
                        purchase, titledata, u_id, urlhandler, guestpages,
                        properties, allowimgupload, lookuptype,
                        firststart,
                        titleactive, qractive, gridactive, playactive, placeholderactive,
                        availablecolors,
                        sharedproperties
                    } = result

                    setDrawbookid(_id)
                    setTitledata(JSON.parse(JSON.stringify(titledata))) // safe copy
                    setGuestpages(JSON.parse(JSON.stringify(guestpages)))
                    setProperties(JSON.parse(JSON.stringify(properties)))
                    setSharedproperties(JSON.parse(JSON.stringify(sharedproperties)))

                    // PRINT SCATTER 
                    const { mainimgsize, forcecenter_x, forcecenter_y, forcecollideradius, forcecharge } = properties['PRINT']['SCATTER']
                    setLookuptype(lookuptype)
                    setGtpp(gtpp)
                    setDbtype(dbtype)
                    setAvailablecolors(availablecolors)

                    function expandguestdataTo300(data) {
                        const result = { ...data };                          // keep original
                        const keys = Object.keys(data);                      // original UUIDs
                        const targetCount = 300;

                        // If already >= 300, just return first 300
                        if (keys.length >= targetCount) return Object.fromEntries(
                            keys.slice(0, targetCount).map(k => [k, result[k]])
                        );

                        // Helper for generating UUIDs
                        const genId = () => crypto.randomUUID();

                        let i = keys.length;
                        let loopIndex = 0;

                        while (i < targetCount) {
                            const originalId = keys[loopIndex % keys.length];  // rotate through originals
                            const newId = genId();

                            result[newId] = {
                                ...data[originalId],
                                duplicateOf: originalId,  // (optional: mark original source)
                            };

                            i++;
                            loopIndex++;
                        }
                        return result;
                    }

                    let local_guestdata
                    let local_guestdataaddr

                    if (false) {
                        local_guestdata = expandguestdataTo300(guestdata)
                        local_guestdataaddr = Object.keys(local_guestdata)

                        const seenPaths = new Set();
                        const pathCache = {};

                        for (let i = 0; i < local_guestdataaddr.length; i++) {
                            const idx = local_guestdataaddr[i];
                            const item = local_guestdata[idx];

                            if (item && typeof item.paths === "string") {

                                // 🔥 If this path was already handled before
                                if (seenPaths.has(item.paths)) {
                                    console.log(`♻️ Reusing pathsarray for ${idx}`);

                                    // reuse from cache
                                    local_guestdata[idx].pathsarray = pathCache[item.paths];
                                    continue;
                                }

                                try {
                                    const fullURL = S3CLOUD_CLOUDFRONT + item.paths;

                                    const response = await fetch(fullURL);
                                    if (!response.ok) throw new Error(`HTTP ${response.status}`);

                                    const arrayBuffer = await response.arrayBuffer();
                                    const compressed = new Uint8Array(arrayBuffer);

                                    const jsonString = pako.ungzip(compressed, { to: "string" });
                                    const parsedPaths = JSON.parse(jsonString);

                                    // store
                                    local_guestdata[idx].pathsarray = parsedPaths;

                                    // 🔥 Add to global tracking
                                    seenPaths.add(item.paths);
                                    pathCache[item.paths] = parsedPaths;

                                    console.log(`✅ Decompressed new paths for key ${idx}`);
                                }
                                catch (error) {
                                    console.error(`❌ Failed to decompress paths for key ${idx}`, error);
                                    local_guestdata[idx].paths = "";
                                }
                            }
                        }
                    }
                    else {
                        local_guestdata = JSON.parse(JSON.stringify(guestdata))
                        // console.log('local_guestdata', local_guestdata)
                        local_guestdataaddr = guestdataaddr.slice()

                        for (let i = 0; i < local_guestdataaddr.length; i++) {
                            const idx = local_guestdataaddr[i];


                            const item = JSON.parse(JSON.stringify(guestdata[idx]));

                            if (item && typeof item.paths === 'string') {
                                try {
                                    const fullURL = S3CLOUD_CLOUDFRONT + item.paths;

                                    const response = await fetch(fullURL);
                                    if (!response.ok) throw new Error(`HTTP ${response.status}`);

                                    const arrayBuffer = await response.arrayBuffer(); // ✅ binary, not text
                                    const compressed = new Uint8Array(arrayBuffer);   // ✅ no atob

                                    const jsonString = pako.ungzip(compressed, { to: 'string' }); // ✅ decompress
                                    const parsedPaths = JSON.parse(jsonString);                   // ✅ parse JSON

                                    // guestdata[idx].paths = parsedPaths;
                                    local_guestdata[idx].pathsarray = parsedPaths;

                                    console.log(`✅ Decompressed paths for index ${idx}`);

                                }
                                catch (error) {
                                    console.error(`❌ Failed to decompress paths for key ${idx}`, error);
                                    // local_guestdata[idx].paths = '';
                                }
                            }
                        }

                    }



                    // Convert paths to images for all guests
                    Object.keys(local_guestdata).forEach((key) => {
                        const guest = local_guestdata[key];
                        if (guest.pathsarray && guest.pathsarray.length > 0) {
                            // Generate image from paths
                            guest.image = pathsToImage(guest.pathsarray, 140); // 400px canvas, adjust if needed
                        }
                        else {
                            guest.image = null; // fallback
                        }
                    });

                    setGuestdata(local_guestdata)
                    setGuestdataaddr(local_guestdataaddr || [])
                    setMaxguestnum(maxguestnum)
                    setBgcolor(bgcolor)
                    setModcontact(modcontact)
                    setPasscode(passcode)
                    setPasscodemod(passcodemod)
                    setPurchase(purchase)
                    setUId(u_id)
                    setUrlhandler(urlhandler)
                    setAllowimgupload(allowimgupload)
                    setPage(firststart ? 'SELECTGUESTNUM' : 'GUESTACTIVE') // if user already selected bgcolor and maxguestnum
                    setMode(mode)
                    setGridactive(gridactive)
                    setPlayactive(playactive)
                    setTitleactive(titleactive)
                    setQractive(qractive)
                    setPlaceholderactive(placeholderactive)

                    setBackupactive({
                        gridactive: gridactive,
                        playactive: playactive,
                        titleactive: titleactive,
                        qractive: qractive,
                        placeholderactive: placeholderactive,
                        mode: mode
                    })

                    setAvailablecolors(availablecolors)



                }
            })
            .catch((e) => {
                // props.history.push('/') 
            })

        return () => props.hidetopbar(false);
    }, []);

    useEffect(() => {
        // Disable scroll
        document.documentElement.style.overflow = 'hidden';

        return () => {
            // clearTimeout(timer);
            document.documentElement.style.overflow = 'auto'; // clean up on unmount
        };
    }, []);

    useEffect(() => {
        // change of page will auto scroll to the top
        if (page === 'GUESTACTIVE' && selectedguestpage === 0) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [page, selectedguestpage])

    useEffect(() => {
        if (guestsavebool) {
            var id = props.match.params.id
            if (savefrom === 'GUEST_SAVE_COLOR_PALETTE') {
                axios({
                    method: 'POST',
                    url: SAVE_DRAWBOOKGUESTVIEWPAGECOLOR,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                    data: { _id: id, urlhandler, passcode, guestpages, availablecolors }
                })
                    .then((item) => {
                        const { message } = item.data
                        if (message === 'SUCCESS') {
                            setSavetxt('Saved!')
                            setTimeout(() => {
                                setSavetxt('')
                                setGuestsavebool(false)
                                setSavefrom('')
                            }, 1000)
                        }
                    })
                    .catch((e) => { })
            }
            else {
                axios({
                    method: 'POST',
                    url: SAVE_DRAWBOOKGUESTVIEWPAGE,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                    data: { _id: id, urlhandler, passcode, guestpages }
                })
                    .then((item) => {
                        const { message } = item.data
                        if (message === 'SUCCESS') {
                            setSavetxt('Saved!')
                            setTimeout(() => {
                                setSavetxt('')
                                setGuestsavebool(false)
                                if (savefrom === 'GUEST_SAVE_TITLE') {
                                    setEditentrytitletop(false)
                                }
                                else if (savefrom === 'GUEST_SAVE_SUBTITLE') {
                                    setEditentrytitlebtm(false)
                                }
                            }, 1000)
                        }
                    })
                    .catch((e) => { })
            }

        }
    }, [guestsavebool])

    useEffect(() => {
        if (ownersavebool) {
            if (savefrom === 'OWNER_SAVE_PROPERTIES') {
                var id = props.match.params.id

                setProperties((properties) => {
                    properties
                    return properties
                })
                axios({
                    method: 'POST',
                    url: SAVE_DRAWBOOKOWNERPROPERTIES,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                    data: { _id: id, urlhandler, passcode, properties }
                })
                    .then((item) => {
                        const { message } = item.data
                        if (message === 'SUCCESS') {
                            setSavetxt('Saved!')
                            setTimeout(() => {
                                setSavetxt('')
                                setOwnersavebool(false)
                                if (savefrom === 'OWNER_SAVE_PROPERTIES') {
                                    setOwnergridspriterootbool(false)
                                    setOwnerscatterprintbool(false)
                                    setOwnerscatterotherdevicebool(false)
                                }
                            }, 1000)
                        }
                    })
                    .catch((e) => { })
            }

            if (savefrom === 'OWNER_SAVE_GRID_ANYDEVICE_TITLE' || savefrom === 'OWNER_SAVE_GRID_SUBTITLE' || savefrom === 'OWNER_SAVE_SCATTER_PRINT_TITLE' || savefrom === 'OWNER_SAVE_SCATTER_PRINT_QR') {
                var id = props.match.params.id
                axios({
                    method: 'POST',
                    url: SAVE_DRAWBOOKOWNERVIEWPAGE,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                    data: { _id: id, urlhandler, passcode, titledata }
                })
                    .then((item) => {
                        const { message } = item.data
                        if (message === 'SUCCESS') {
                            setSavetxt('Saved!')
                            setTimeout(() => {
                                setSavetxt('')
                                setOwnersavebool(false)
                                if (savefrom === 'OWNER_SAVE_GRID_ANYDEVICE_TITLE') {
                                    setOwnergridtitletopbool(false)
                                }
                                else if (savefrom === 'OWNER_SAVE_GRID_SUBTITLE') {
                                    setOwnergridsubtitletopbool(false)
                                }
                                else if (savefrom === 'OWNER_SAVE_SCATTER_PRINT_TITLE') {
                                    setOwnerscattertitletopbool(false)
                                }
                                else if (savefrom === 'OWNER_SAVE_SCATTER_PRINT_QR') {
                                    setOwnerprintqrbool(false)
                                }
                            }, 1000)
                        }
                    })
                    .catch((e) => { })
            }

            if (savefrom === 'OWNER_PRINT_SCATTER_PROPERTY_SAVE') {
                setProperties((properties) => {
                    var id = props.match.params.id
                    axios({
                        method: 'POST',
                        url: SAVE_DRAWBOOKOWNERPROPERTIESANDSHAREDPROPERTIES,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                        data: { _id: id, urlhandler, passcode, properties: JSON.parse(JSON.stringify(properties)), sharedproperties: JSON.parse(JSON.stringify(sharedproperties)) }
                    })
                        .then((item) => {
                            const { message } = item.data
                            if (message === 'SUCCESS') {
                                setSavetxt('Saved!')
                                setTimeout(() => {
                                    setSavetxt('')
                                    setSavefrom('')
                                    setOwnersavebool(false)
                                    setOwnerscatterprintbool(false)
                                    setOwnerscatterotherdevicebool(false)
                                }, 1000)
                            }
                        })
                        .catch((e) => { })

                    return properties
                })
            }



        }

    }, [ownersavebool])

    useEffect(() => {
        if (svgRef.current && device === "PRINT") {
            requestAnimationFrame(() => {
                svgRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center",
                });
            });
        }
    }, [svgRef, device, lookuptype, currentprint]);

    // for print scatter panel, if its open, do backup

    const cropcomplete = useCallback((croppedArea, croppedAreaPixels) => {
        setTempcroppedimg(croppedAreaPixels)
    }, [])

    const cropcancel = () => {
        setTempmainimg(null)
        setTempmainimginfo(null)
        setTempcroppedimg(null)
        setNeededit(false)
    }

    const updatePanelAppearPosition = (e) => {
        if (e) {
            if (e.pageX > 0 && e.pageY > 0) {
                setPanelPosition({ x: e.pageX, y: e.pageY })
            }
        }
    }

    const guestNumselect = (e) => {
        setMaxguestnum(parseInt(e.target.value))
    };

    const bgcolorSelect = (e) => {
        setBgcolor(e.target.value)
    }

    const fontcolorSelect = (e) => {
        setFontcolor(e.target.value)
    }

    const A3_BLEED = 35

    const default_svg_properties = (device && device.length > 0)
        ? {
            'WEB': { width: 400, height: 150, startX: 10, startY: 80, endX: 290, endY: 80 },
            'TABLET': { width: 350, height: 150, },
            'MOBILE': { width: 300, height: 150, },
            'PRINT': { width: 1748, height: 2480, startX: 10, startY: 80, endX: 290, endY: 80 },
        }
        : {}

    const title_svg_properties = (device && device.length > 0)
        ? {
            'WEB': { width: 400, height: 150, startX: 10, startY: 80, endX: 290, endY: 80 },
            'TABLET': { width: 350, height: 150, },
            'MOBILE': { width: 300, height: 150, },
            'PRINT': { width: 1748, height: 400, startX: 10, startY: 80, endX: 290, endY: 80 },
        }
        : {}

    const preview = () => {
        document.getElementById('iepreview_btninvisible').click()
    }

    // top bar start
    // const bar_wt_dom = <div style={{ width: '100%', borderBottom: '1px solid #dddddd', padding: 10, flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1040, backgroundColor: '#ffffff' }}>
    //     <div style={{ display: 'flex', flexDirection: 'row', fontSize: e_fs, alignItems: 'center', pointerEvents: 'none', userSelect: 'none', opacity: 0 }}></div>
    //     <button className="planning_backicon" style={{ position: 'absolute', left: 10, }} onClick={() => { setReturnhome(true) }}>{ARROWLEFT_ICON}</button>
    //     <div style={{ display: 'flex', flexDirection: 'row', fontSize: e_fs, alignItems: 'center' }}></div>
    //     <div className="ie_previewbtn_root" style={{ position: 'relative', height: 'max-content', margin: 0, right: 0 }}>
    //         <button className="iepreview_btn" style={{ margin: 0 }} onClick={preview}>
    //             {LOOKUPUNSTYLE_ICON} Preview
    //             <Link id="iepreview_btninvisible" to={'/guestbook/' + urlhandler + '/' + passcode} target="_blank" />
    //         </button>
    //     </div>
    // </div>

    // top bar start
    const bar_wt_dom = <div style={{ width: '100%', borderBottom: '1px solid #dddddd', padding: 10, flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1040, backgroundColor: '#ffffff' }}>

        <div style={{ display: 'flex', flexDirection: 'row', fontSize: e_fs, alignItems: 'center', pointerEvents: 'none', userSelect: 'none', opacity: 0 }}></div>

        <button className="planning_backicon" style={{ position: 'absolute', left: 10, }} onClick={() => { setReturnhome(true) }}>{ARROWLEFT_ICON}</button>

        <div style={{ display: 'flex', flexDirection: 'row', fontSize: e_fs, alignItems: 'center' }}></div>

        <div className="ie_previewbtn_root" style={{ position: 'relative', height: 'max-content', margin: 0, right: 0 }}>

            <button
                className='Drawbookedit_settingbtn'
                style={{ display: 'flex', color: 'var(--maindark)', fill: 'var(--maindark)', overflow: 'hidden' }}
                onClick={() => { setQuestionmarkmodal(true) }}
            >
                {iconwrapper(QUESTIONMARK_ICON, { width: 18, height: 18, display: 'flex', placeItems: 'center', placeSelf: 'center', userSelect: 'none' })}
            </button>

            <button
                className='Drawbookedit_settingbtn'
                style={{ display: 'flex', color: 'var(--maindark)', fill: 'var(--maindark)', overflow: 'hidden' }}
                onClick={() => { setPurchasemodal(true) }}
            >
                {iconwrapper(CART_ICON, { width: 25, height: 25, display: 'flex', placeItems: 'center', placeSelf: 'center', marginTop: 3, marginRight: 3, userSelect: 'none' })}
            </button>

            <button
                className="iepreview_btn"
                style={{ margin: 0, padding: '0px 15px', width: 90, display: 'flex', flexDirection: 'column', lineHeight: '1.1em', placeContent: 'center', marginRight: 5 }}
                onClick={() => {
                    document.getElementsByClassName('invisibleguestbook')[0].click()
                }}>
                <div>Guestbook</div>
                <Link id="iepreview_btninvisible" className="invisibleguestbook" to={'/guestbook/' + (mode === 'DEFAULT' ? '' : 'crypto/') + urlhandler + '/' + passcode} target="_blank" />
            </button>

            <button
                className="iepreview_btn"
                style={{ margin: 0, padding: '0px 15px', width: 90, display: 'flex', flexDirection: 'column', lineHeight: '1.1em', placeContent: 'center' }}
                onClick={() => {
                    document.getElementsByClassName('invisibleguestbooklookup')[0].click()
                }}>
                <div>Lookup</div>
                <Link id="iepreview_btninvisible" className='invisibleguestbooklookup' to={'/guestbooklookup/' + urlhandler + '/' + passcodemod} target="_blank" />
            </button>

        </div>

    </div>

    const bar_m_dom = <div style={{ display: 'flex', flexDirection: 'column', width: '100%', overflow: 'hidden' }}>
        <div style={{ width: '100%', padding: '0px 10px', height: 60, borderBottom: '1px solid #dddddd', flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 'max-content', userSelect: 'none', backgroundColor: '#ffffff' }}>
            <button className="planning_backicon" onClick={() => { setReturnhome(true) }}>{ARROWLEFT_ICON}</button>
            <button className="iepreview_btn" style={{ margin: 0, fontFamily: 'Lato' }} onClick={() => { document.getElementById('iepreview_btninvisible').click() }}>
                {LOOKUPUNSTYLE_ICON} Preview
                <Link id="iepreview_btninvisible" to={'/guestbook/' + urlhandler + '/' + passcode} target="_blank" />
            </button>
        </div>
    </div>

    const topbar = { 'WEB': bar_wt_dom, 'TABLET': bar_wt_dom, 'MOBILE': bar_m_dom, 'PRINT': bar_wt_dom }[SYSTEM_DEVICE]

    // home modcfm start
    const home_mod = returnhome
        // ? <Modcfm
        //     onHide={() => { setReturnhome(false) }}
        //     onOk={() => { props.history.push(PLOBJ['guestbook']['toolurl']) }}
        //     onNo={() => { setReturnhome(false) }}
        //     txt={'You are returning to planning tools menu.'}
        // />

        ? <Modcfm
            onHide={() => { setReturnhome(false) }}
            onOk={() => { props.history.push(PLOBJ['guestbook']['toolurl']) }}
            onNo={() => { setReturnhome(false) }}
            txt={'You are returning to planning tools menu.'}
        />

        : null

    const color_content = <>

        {partialtitle_dom('Background Color', { marginTop: 10 })}
        {inputdescribe_dom(`The primary color of your guestbook.`)}
        <div className="Drawbookedit_row Drawbookedit_colorroot">
            {[
                { name: 'White', color: '#ffffff' },
                { name: '', color: '#FBFBFB' },
                { name: 'Beige', color: '#fffef6' },
                { name: '', color: '#fff4f1' },
            ].map(({ name, color }) => (
                <button
                    key={color}
                    value={color}
                    className={`Drawbookedit_bgcolor ${bgcolor === color ? 'Drawbookedit_bgcolorselected' : ''}`}
                    style={{ backgroundColor: color }}
                    onClick={bgcolorSelect}
                />
            ))}
        </div>

        {partialtitle_dom('Font Color', { marginTop: 10 })}
        {inputdescribe_dom(`The primary font color used in your Guestbook.`)}
        <div className="Drawbookedit_row Drawbookedit_colorroot">
            {[
                { name: '', color: '#333333' },
            ].map(({ name, color }) => (
                <button
                    key={color}
                    value={color}
                    className={`Drawbookedit_bgcolor Drawbookedit_bgcolorselected`}
                    onClick={fontcolorSelect}
                    style={{ backgroundColor: color }}
                />
            ))}
        </div>

    </>

    const setting_dom = <>
        {title_dom('Settings', { padding: 0, margin: 0 })}

        {/* {partialtitle_dom('Guest Counts', {})}
        {inputdescribe_dom(`How many entry do you need?`)}
        <div className="Drawbookedit_row">
            {[100, 200, 300, 400, 500].map((num) => (
                <button
                    key={num}
                    className={`Drawbookedit_guestnum ${maxguestnum === num ? 'Drawbookedit_guestnumselected' : ''}`}
                    onClick={guestNumselect}
                    value={num}
                >
                    {num}
                </button>
            ))}
        </div> */}

        {color_content}
    </>

    const reset = () => {

        // - - - - - - - - - - - DRAWINGS - - - - - - - - - - - 

        if (ownerscatterotherdevicebool || ownerscatterprintbool) { // SCATTER - WEB/TABLET/MOBILE

            setBackupproperties((backupproperties) => {
                setProperties(() => {
                    let new_backupproperties = JSON.parse(JSON.stringify(backupproperties));
                    return new_backupproperties;
                })
                return backupproperties
            })

            setBackupsharedproperties((backupsharedproperties) => {
                setSharedproperties(() => {
                    let new_sharedproperties = JSON.parse(JSON.stringify(backupsharedproperties));
                    return new_sharedproperties;
                })
                return backupsharedproperties
            })

        }

        if (ownerscattertitletopbool) {
            setBackuptitledata((backuptitledata) => {
                setTitledata((titledata) => {
                    let new_titledata = JSON.parse(JSON.stringify(titledata))
                    new_titledata['title'][device]['style']['normaltext'] = backuptitledata['title'][device]['style']['normaltext']
                    new_titledata['title']['text'] = backuptitledata['title']['text']
                    return new_titledata
                })
                return backuptitledata
            })
        }

        if (ownergridspriterootbool) { // GRID-PRINT
            setBackupproperties((backupproperties) => {
                setProperties(() => {
                    let local_backupproperties = JSON.parse(JSON.stringify(backupproperties));
                    return local_backupproperties;
                })
                return backupproperties
            })
        }

        if (ownergridtitletopbool) { // GRID-WEB/TABLET/MOBILE title
            setBackuptitledata((backuptitledata) => {
                setTitledata((titledata) => {
                    let new_titledata = JSON.parse(JSON.stringify(titledata))
                    new_titledata['title'][device]['style']['arc'] = backuptitledata['title'][device]['style']['arc']
                    new_titledata['title'][device]['style']['normaltext'] = backuptitledata['title'][device]['style']['normaltext']
                    new_titledata['title']['text'] = backuptitledata['title']['text']
                    return new_titledata
                })
                return backuptitledata
            })
        }

        if (ownergridsubtitletopbool) { // GRID-WEB/TABLET/MOBILE subtitle
            setBackupsubtitledata((backupsubtitledata) => {
                setTitledata((titledata) => {
                    let new_titledata = JSON.parse(JSON.stringify(titledata))
                    new_titledata['subtitle'][device]['style']['arc'] = backupsubtitledata['subtitle'][device]['style']['arc']
                    new_titledata['subtitle'][device]['style']['normaltext'] = backupsubtitledata['subtitle'][device]['style']['normaltext']
                    new_titledata['subtitle']['text'] = backupsubtitledata['subtitle']['text']
                    return new_titledata
                })
                return backupsubtitledata
            })
        }

        if (ownerprintqrbool) {
            setBackuptitledata((backuptitledata) => {
                setTitledata((titledata) => {
                    let new_titledata = JSON.parse(JSON.stringify(titledata))
                    new_titledata['qr'][device] = backuptitledata['qr'][device]
                    new_titledata['qr']['url'] = backuptitledata['qr']['url']
                    return new_titledata
                })
                return backuptitledata
            })
        }

        // - - - - - - - - - - - PAGE - - - - - - - - - - - 


        if (editentrytitletop) {
            setGuestinputbackup((guestinputbackup) => {
                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                setGuestpages((guestpages) => {
                    let new_guestpages = guestpages.slice()
                    new_guestpages[_0_instruction_page]['title'] = JSON.parse(JSON.stringify(guestinputbackup['GUEST_ARC_TITLE']))
                    delete new_guestinputbackup['GUEST_ARC_TITLE']
                    return new_guestpages
                })
                return guestinputbackup
            })
        }

        if (editentrytitlebtm) {
            setGuestinputbackup((guestinputbackup) => {
                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                setGuestpages((guestpages) => {
                    let new_guestpages = guestpages.slice()
                    new_guestpages[_0_instruction_page]['subtitle'] = JSON.parse(JSON.stringify(guestinputbackup['GUEST_ARC_SUBTITLE']))
                    delete new_guestinputbackup['GUEST_ARC_SUBTITLE']
                    return new_guestpages
                })
                return guestinputbackup
            })
        }

        if (editentrytextarea) {
            setGuestinputbackup((guestinputbackup) => {
                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                setGuestpages((guestpages) => {
                    let new_guestpages = guestpages.slice()
                    new_guestpages[_0_instruction_page]['guide'] = JSON.parse(JSON.stringify(guestinputbackup['GUEST_THREE_TEXTS']))
                    delete new_guestinputbackup['GUEST_THREE_TEXTS']
                    return new_guestpages
                })
                return guestinputbackup
            })
        }

        if (editmessagebool) {
            setGuestinputbackup((guestinputbackup) => {
                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                setGuestpages((guestpages) => {
                    let new_guestpages = guestpages.slice()
                    new_guestpages[_2_writesomething_page]['nameplaceholder'] = JSON.parse(JSON.stringify(guestinputbackup['GUEST_DETAILS_NAME_PLACEHOLDER']))
                    new_guestpages[_2_writesomething_page]['messageplaceholder'] = JSON.parse(JSON.stringify(guestinputbackup['GUEST_DETAILS_MSG_PLACEHOLDER']))
                    delete new_guestinputbackup['GUEST_DETAILS_NAME_PLACEHOLDER']
                    delete new_guestinputbackup['GUEST_DETAILS_MSG_PLACEHOLDER']
                    return new_guestpages
                })
                return guestinputbackup
            })
        }

        if (editsuccessdrawingbool) {
            setGuestinputbackup((guestinputbackup) => {
                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                setGuestpages((guestpages) => {
                    let new_guestpages = guestpages.slice()
                    new_guestpages[_3_success_page]['messageplaceholder'] = JSON.parse(JSON.stringify(guestinputbackup['GUEST_DETAILS_SUCCESS_UPLOAD_DRAWINGANDMSG']))
                    delete new_guestinputbackup['GUEST_DETAILS_SUCCESS_UPLOAD_DRAWINGANDMSG']
                    return new_guestpages
                })
                return guestinputbackup
            })
        }

        if (edituploadimageornotbool) {
            setGuestinputbackup((guestinputbackup) => {
                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                setGuestpages((guestpages) => {
                    let new_guestpages = guestpages.slice()
                    new_guestpages[_4_addimageornot_page]['messageplaceholder'] = JSON.parse(JSON.stringify(guestinputbackup['GUEST_DETAILS_UPLOADIMGORNOT_PLACEHOLDER']))
                    delete new_guestinputbackup['GUEST_DETAILS_UPLOADIMGORNOT_PLACEHOLDER']
                    return new_guestpages
                })
                return guestinputbackup
            })
        }

        if (editsuccessuploadimagebool) {
            setGuestinputbackup((guestinputbackup) => {
                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                setGuestpages((guestpages) => {
                    let new_guestpages = guestpages.slice()
                    new_guestpages[_6_success_page]['messageplaceholder'] = JSON.parse(JSON.stringify(guestinputbackup['GUEST_DETAILS_SUCCESS_UPLOAD_IMG']))
                    delete new_guestinputbackup['GUEST_DETAILS_SUCCESS_UPLOAD_IMG']
                    return new_guestpages
                })
                return guestinputbackup
            })
        }

        if (editcolorbool) {
            setGuestinputbackup((guestinputbackup) => {
                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                setGuestpages((guestpages) => {
                    let new_guestpages = guestpages.slice()
                    new_guestpages[_1_drawing_page]['colors'] = guestinputbackup['GUEST_PALETTE'].slice()
                    setAvailablecolors(guestinputbackup['GUEST_AVAILABLE_COLORS'].slice())
                    delete new_guestinputbackup['GUEST_PALETTE']
                    delete new_guestinputbackup['GUEST_AVAILABLE_COLORS']
                    return new_guestpages
                })
                return guestinputbackup
            })
        }

        if (editdrawguidebool) {
            setGuestinputbackup((guestinputbackup) => {
                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                setGuestpages((guestpages) => {
                    let new_guestpages = guestpages.slice()
                    new_guestpages[_1_drawing_page]['drawguide'] = new_guestinputbackup['DRAW_GUIDE'].slice()
                    delete new_guestinputbackup['DRAW_GUIDE']
                    return new_guestpages
                })
                return guestinputbackup
            })
        }

        if (editredirectbool) {
            setGuestinputbackup((guestinputbackup) => {
                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                setGuestpages((guestpages) => {
                    let new_guestpages = guestpages.slice()
                    new_guestpages[_7_redirect_page] = new_guestinputbackup['GUEST_REDIRECT_PAGE']
                    delete new_guestinputbackup['GUEST_REDIRECT_PAGE']
                    return new_guestpages
                })
                return guestinputbackup
            })
        }

        try { // If user editing single guestbook content, and terminate half way, remember to clear the guestdataaddr to original
            if (nowshowing === 'SWAP' && backupguestdataaddr && backupguestdataaddr.length > 0) {
                setGuestdataaddr(backupguestdataaddr.slice())
                setBackupguestdataaddr([])
            }
        }
        catch (e) { }



        setSavefrom('')
        setGuestsavebool(false)
        setOwnersavebool(false)
        setDisplaydata(null)

        setOwnergridtitletopbool(false)
        setOwnergridsubtitletopbool(false)
        setOwnergridspriterootbool(false)

        setOwnerscatterprintbool(false)

        setOwnerscatterotherdevicebool(false)

        setOwnerprintqrbool(false)

        setOwnerscattertitletopbool(false)

        setBackupproperties({})
        setBackupsharedproperties({})
        setBackuptitledata({})
        setBackupsubtitledata({})


        setGuestinputbackup({})


        setEditentrytitletop(false)
        setEditentrytitlebtm(false)
        setEditentrytextarea(false)
        setEditmessagebool(false)
        setEditsuccessdrawingbool(false)
        setEditsuccessuploadimagebool(false)
        setEdituploadimageornotbool(false)
        setEditcolorbool(false)
        setEditdrawguidebool(false)
        setEditredirectbool(false)






    }

    const GUEST_OWNER_BTN = <div className='Drawbookedit_active_side'>
        <button
            className={`Drawbookedit_guestnum ${page === 'GUESTACTIVE' ? 'Drawbookedit_guestnumselected' : ''}`}
            onClick={(e) => {
                setPage(e.target.value)
                reset()
                setDevice('WEB')
            }}
            style={{ placeContent: 'center', isplay: 'flex', flexDirection: 'column', height: 40, width: 90, borderRadius: 5, padding: '0px 15px', lineHeight: '1.1em', fontSize: 14, margin: '0px 5px 0px 0px', }}
            value={'GUESTACTIVE'}
        >
            <div style={{ pointerEvents: 'none', display: 'flex', textWrap: 'nowrap' }}>Guestbook</div>
            <div style={{ pointerEvents: 'none' }}>Settings</div>
        </button>
        <button
            className={`Drawbookedit_guestnum ${page === 'OWNERACTIVE' ? 'Drawbookedit_guestnumselected' : ''}`}
            onClick={(e) => {
                setPage(e.target.value)
                reset()
                setDevice('WEB')
            }}
            style={{ placeContent: 'center', placeItems: 'center', display: 'flex', flexDirection: 'column', height: 40, width: 90, borderRadius: 5, padding: '0px 15px', lineHeight: '1.1em', fontSize: 14, margin: 0, }}
            value={'OWNERACTIVE'}
        >
            <div style={{ pointerEvents: 'none' }}>Lookup</div>
            <div style={{ pointerEvents: 'none' }}>Settings</div>
        </button>
    </div>


    // OWNER POINT OF VIEW - START --------------------------------------------------------------------
    const DEVICE_SELECTION_DOM = <div className={`itineraryedit_devicebtns${SYSTEM_DEVICE}`} style={device === 'PRINT' ? { zIndex: 2, width: 'calc( 100% - 35px )' } : { zIndex: 2 }}>

        {GUEST_OWNER_BTN}
        {lookuptype === 'SCATTER'
            ? <Togglebutton
                singlebtnstyle={{ width: 40, height: 40, minWidth: 'max-content' }}
                funcs={[
                    () => {
                        setDevice('WEB')
                        reset()
                    },
                    () => {
                        setDevice('PRINT')
                        reset()
                    },
                ]}
                txts={[
                    <div style={{ display: 'flex', flexDirection: 'row', width: 122, placeContent: 'space-between' }}>
                        {iconwrapper(LAPTOP_ICON, { width: 25, height: 25 })}
                        {iconwrapper(TABLET_ICON, { width: 25, height: 25 })}
                        {iconwrapper(MOBILE_ICON, { width: 25, height: 25 })}
                    </div>,
                    <div style={{ display: 'flex', placeContent: 'center' }}>{iconwrapper(PRINT_ICON, { width: 25, height: 25 })}</div>
                ]}
                btnselected={{ 'WEB': 0, 'PRINT': 1 }[device]}
            />
            : <Togglebutton
                singlebtnstyle={{ width: 40, height: 40, minWidth: 'max-content' }}
                funcs={[
                    () => {
                        setDevice('WEB')
                        reset()
                    },
                    () => {
                        setDevice('TABLET')
                        reset()
                    },
                    () => {
                        setDevice('MOBILE')
                        reset()
                    },
                    () => {
                        setDevice('PRINT')
                        reset()
                    },
                ]}
                txts={[
                    iconwrapper(LAPTOP_ICON, { width: 25, height: 25 }),
                    iconwrapper(TABLET_ICON, { width: 25, height: 25 }),
                    iconwrapper(MOBILE_ICON, { width: 25, height: 25 }),
                    iconwrapper(PRINT_ICON, { width: 25, height: 25 })
                ]}
                btnselected={{ 'WEB': 0, 'TABLET': 1, 'MOBILE': 2, 'PRINT': 3 }[device]}
            />}


        <div className='Drawbookedit_active_side'>

            {device === 'PRINT'
                ? <button className='Drawbookedit_settingbtn' onClick={() => { setPrintbool(true); }}>
                    {iconwrapper(DOWNLOAD_ICON, { width: 25, height: 25, userSelect: 'none' })}
                </button>
                : null}

            <button
                className='Drawbookedit_settingbtn'
                style={{ width: 40, height: 40, fontSize: 8 }}
                onClick={() => {

                    setLookuptype((v) => {
                        const updatebackend = (lookuptype) => {
                            axios({
                                method: 'POST',
                                url: UPDATE_DRAWBOOKLOOKUPTYPE,
                                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                                data: { _id: drawbookid, lookuptype, urlhandler, passcode }
                            })
                                .then((item) => {
                                    const { message } = item.data
                                })

                        }
                        if (v === 'SCATTER') {
                            setDevice('WEB')
                            updatebackend('GRID')
                            reset()
                            return 'GRID'
                        }
                        else {
                            if (purchase.status === 'BOUGHT') {
                                setDevice('WEB')
                                updatebackend('SCATTER')
                                reset()
                                return 'SCATTER'
                            }
                            else {
                                // setDevice('WEB')
                                // updatebackend('GRID')
                                // reset()
                                return 'GRID'
                            }

                        }
                    })

                }}
            >
                {lookuptype}
            </button>

            <button
                className='Drawbookedit_settingbtn'
                style={{ width: 40, height: 40, backgroundColor: bgcolor }}
                onClick={() => {
                    setColorbool(true)
                    setColorbackup(bgcolor)
                }}
            />


            <button className='Drawbookedit_settingbtn' onClick={() => {
                setSettingbool(true)
                setBackupactive({
                    playactive: playactive,
                    gridactive: gridactive,
                    qractive: qractive,
                    titleactive: titleactive,
                    placeholderactive: placeholderactive,
                    mode: mode
                })
            }}>
                {iconwrapper(SETTING_ICON, { width: 25, height: 25 })}
            </button>
            <div className='Drawbookedit_numberlabel'>{guestdataaddr.length + ' / ' + maxguestnum}</div>
        </div>


    </div>

    // component functions
    const updatetitledata = (css_key, value, comp_key = 'arc') => {

        setTitledata((titledata) => {
            let new_titledata = JSON.parse(JSON.stringify(titledata))
            if (css_key === 'rx' || css_key === 'ry') {
                new_titledata['title'][device]['style'][comp_key]['rx'] = value
                new_titledata['title'][device]['style'][comp_key]['ry'] = value
            }
            else if (css_key === 'startX' || css_key === 'endX') {
                new_titledata['title'][device]['style'][comp_key]['endX'] += value - new_titledata['title'][device]['style'][comp_key]['startX']
                new_titledata['title'][device]['style'][comp_key]['startX'] = value
            }
            else if (css_key === 'startY' || css_key === 'endY') {
                new_titledata['title'][device]['style'][comp_key]['endY'] += value - new_titledata['title'][device]['style'][comp_key]['startY']
                new_titledata['title'][device]['style'][comp_key]['startY'] = value
            }
            else {
                new_titledata['title'][device]['style'][comp_key][css_key] = value
            }
            return new_titledata
        })
    }
    const updateTitletext = (value) => {
        setTitledata((titledata) => {
            let new_titledata = JSON.parse(JSON.stringify(titledata))
            new_titledata['title']['text'] = value
            return new_titledata
        })
    }
    const updatesubtitledata = (css_key, value) => {
        setTitledata((titledata) => {
            let new_titledata = JSON.parse(JSON.stringify(titledata))
            if (css_key === 'rx' || css_key === 'ry') {
                new_titledata['subtitle'][device]['style']['arc']['rx'] = value
                new_titledata['subtitle'][device]['style']['arc']['ry'] = value
            }
            else if (css_key === 'startX' || css_key === 'endX') {
                new_titledata['subtitle'][device]['style']['arc']['endX'] += value - new_titledata['subtitle'][device]['style']['arc']['startX']
                new_titledata['subtitle'][device]['style']['arc']['startX'] = value
            }
            else if (css_key === 'startY' || css_key === 'endY') {
                new_titledata['subtitle'][device]['style']['arc']['endY'] += value - new_titledata['subtitle'][device]['style']['arc']['startY']
                new_titledata['subtitle'][device]['style']['arc']['startY'] = value
            }
            else {
                new_titledata['subtitle'][device]['style']['arc'][css_key] = value
            }
            return new_titledata
        })
    }
    const updateSubtitletext = (value) => {
        setTitledata((titledata) => {
            let new_titledata = JSON.parse(JSON.stringify(titledata))
            new_titledata['subtitle']['text'] = value
            return new_titledata
        })
    }
    const updateQr = (css_key, value) => {

        // 'qr':{
        //     "url": "https://wwww.weavebliss.com",
        //     "PRINT":{
        //         "style":{
        //             "fgColor":"#000000",
        //             "bgColor":"#ffffff",
        //             "size":125
        //         }
        //     }
        // }

        // onChange={(value) => { updateQr('size', value, 'qr') }}


        setTitledata((titledata) => {
            let new_titledata = JSON.parse(JSON.stringify(titledata))
            new_titledata['qr'][device]['style'][css_key] = value
            return new_titledata
        })

    }
    const updateQrurl = (value) => {

    }
    const savetitle = () => {
        setOwnersavebool(true)
        setSavefrom('OWNER_SAVE_GRID_ANYDEVICE_TITLE')
    }
    const saveprintscattertitle = () => {
        setOwnersavebool(true)
        setSavefrom('OWNER_SAVE_SCATTER_PRINT_TITLE')
    }
    const saveprintqr = () => {
        setOwnersavebool(true)
        setSavefrom('OWNER_SAVE_SCATTER_PRINT_QR')
    }
    const savesubtitle = () => {
        setOwnersavebool(true)
        setSavefrom('OWNER_SAVE_GRID_SUBTITLE')
    }
    const crosstitle = () => {
        setBackuptitledata((backuptitledata) => {
            setTitledata((titledata) => {
                let new_titledata = JSON.parse(JSON.stringify(titledata))
                new_titledata['title'][device] = JSON.parse(JSON.stringify(backuptitledata['title'][device]))
                new_titledata['title']['text'] = backuptitledata['title']['text']
                return new_titledata
            })
            return {}
        })
        setOwnergridtitletopbool(false)
        setOwnerscattertitletopbool(false)
    }
    const crosssubtitle = () => {
        setBackupsubtitledata((backupsubtitledata) => {
            setTitledata((titledata) => {
                console.log('cross titledata', titledata)
                console.log('device', device)
                let new_titledata = JSON.parse(JSON.stringify(titledata))
                new_titledata['subtitle'][device] = JSON.parse(JSON.stringify(backupsubtitledata['subtitle'][device]))
                new_titledata['subtitle']['text'] = backupsubtitledata['subtitle']['text']
                return new_titledata
            })
            return {}
        })
        setOwnergridsubtitletopbool(false)
    }
    const deleteentry = (displaydata) => {
        const { id, paths, img } = displaydata
        axios({
            method: 'POST',
            url: DELETE_DRAWBOOKENTRY,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
            data: { _id: drawbookid, entryid: id, urlhandler, passcode, paths, img }
        })
            .then((item) => {
                const { message } = item.data
                if (message === 'SUCCESS') {
                    setEntrydeletecmodal(false)
                    setSavetxt('Entry Deleted')
                    setDisplaydata(null)
                    setTimeout(() => {
                        setGuestdata((guestdata) => {
                            const updated = { ...guestdata };
                            delete updated[id];
                            return updated
                        });
                        setGuestdataaddr((guestdataaddr) => {
                            let new_guestdataaddr = guestdataaddr.slice()
                            new_guestdataaddr.splice(guestdataaddr.indexOf(id), 1)
                            return new_guestdataaddr
                        })
                        setSavetxt('')
                    }, 1000)
                }
            }).catch((e) => {
                // props.history.push('/') 
            })
    }

    const spriteorguestbookpages = (e) => {

        setCurrentprint(e.target.value);

        if (ownerscatterprintbool) {

            setBackupproperties((backupproperties) => {
                setProperties(() => {
                    let local_backupproperties = JSON.parse(JSON.stringify(backupproperties));
                    return local_backupproperties;
                })
            })

            setBackupsharedproperties((backupsharedproperties) => {
                setSharedproperties(() => {
                    let local_backupsharedproperties = JSON.parse(JSON.stringify(backupsharedproperties));
                    return local_backupsharedproperties;
                })
            })

            setBackuptitledata({})
            setOwnerscatterprintbool(false)
        }

        if (ownerscattertitletopbool) {
            setTitledata((titledata) => {
                let new_titledata = JSON.parse(JSON.stringify(titledata))
                new_titledata['title'][device] = backuptitledata['title'][device]
                new_titledata['title']['text'] = backuptitledata['title']['text']
                return new_titledata
            })
            setBackuptitledata({})
            setOwnerscattertitletopbool(false)
        }

        if (ownergridspriterootbool) {
            setBackupproperties((backupproperties) => {
                setProperties(() => {
                    let local_backupproperties = JSON.parse(JSON.stringify(backupproperties));
                    return local_backupproperties;
                })
            })
            setOwnergridspriterootbool(false)
        }

        if (ownergridtitletopbool) {
            setTitledata((titledata) => {
                let new_titledata = JSON.parse(JSON.stringify(titledata))
                new_titledata['title'][device]['style']['arc'] = backuptitledata['title'][device]['style']['arc']
                new_titledata['title']['text'] = backuptitledata['title']['text']
                return new_titledata
            })
            setBackuptitledata({})
            setOwnergridtitletopbool(false)
        }

        if (ownergridsubtitletopbool) {
            setTitledata((titledata) => {
                let new_titledata = JSON.parse(JSON.stringify(titledata))
                new_titledata['subtitle'][device]['style']['arc'] = backupsubtitledata['subtitle'][device]['style']['arc']
                new_titledata['subtitle']['text'] = backupsubtitledata['subtitle']['text']
                return new_titledata
            })
            setBackupsubtitledata({})
            setOwnergridsubtitletopbool(false)
        }

        if (ownerprintqrbool) {
            setTitledata((titledata) => {
                let new_titledata = JSON.parse(JSON.stringify(titledata))
                new_titledata['qr'][device] = backuptitledata['qr'][device]
                new_titledata['qr']['url'] = backuptitledata['qr']['url']
                return new_titledata
            })
            setBackuptitledata({})
            setOwnerprintqrbool(false)
        }

        if (editentrytitletop) {
            setEditentrytitletop(false)
            setGuestpages((guestpages) => {
                let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                new_guestpages[0]['title'] = guestinputbackup['GUEST_ARC_TITLE']
                return new_guestpages
            })
        }

        if (editentrytitletop) {
            setEditentrytitletop(false)
            setGuestpages((guestpages) => {
                let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                new_guestpages[0]['title'] = guestinputbackup['GUEST_ARC_TITLE']
                return new_guestpages
            })
        }


    }

    const PRINT_SELECTION = <div className='Drawbookedit_canvaroot'>
        <button
            className={`Drawbookedit_canvaselectitem ${currentprint === 'SPRITE' ? 'Drawbookedit_canvaselectitemselected' : ''}`}
            onClick={spriteorguestbookpages}
            value='SPRITE'
        >
            Sprite Drawing
        </button>
        <button
            className={`Drawbookedit_canvaselectitem ${currentprint === 'GUESTBOOK' ? 'Drawbookedit_canvaselectitemselected' : ''}`}
            onClick={spriteorguestbookpages}
            value='GUESTBOOK'
        >
            Guestbook Pages
        </button>
    </div>

    const qrdom = qractive && device === 'PRINT' && titledata && Object.keys(titledata).length > 0
        ? <g
            transform={`translate(
            ${default_svg_properties[device].width - titledata['qr'][device]['style'].size - A3_BLEED - 10},
            ${default_svg_properties[device].height - titledata['qr'][device]['style'].size - A3_BLEED - 10} )`}
            onClick={() => {
                setBackuptitledata((curr_backuptitledata) => {
                    if (!curr_backuptitledata || Object.keys(curr_backuptitledata).length === 0) {
                        let new_backuptitledata = JSON.parse(JSON.stringify(titledata))
                        new_backuptitledata['qr'][device] = titledata['qr'][device]
                        return new_backuptitledata

                    }
                    else {
                        let new_backuptitledata = JSON.parse(JSON.stringify(curr_backuptitledata))
                        new_backuptitledata['qr'] = titledata['qr']
                        return new_backuptitledata
                    }
                })
                setOwnerprintqrbool(true)
            }}
        >

            <QRCode
                // value={`${WEBSITE_URL}/guestbooklookup/` + urlhandler}
                // value={`${production ? 'https' : 'http'}://${WEBSITE_URL}/guestbooklookup/` + urlhandler + '/' + passcodemod}
                value={titledata['qr']['url']}
                size={titledata['qr']['PRINT']['style'].size}
                renderAs="svg" // important
                fgColor={titledata['qr']['PRINT']['style'].fgColor}
                bgColor={titledata['qr']['PRINT']['style'].bgColor}
            />
        </g>
        : null

    const LONGGUESTBOOK_EDITBTN = currentprint === 'GUESTBOOK'
        ? <div className='Drawbookedit_guestbookpagestextrow'>
            <button
                className='Drawbookedit_guestbookpagestextadddeduct'
                onClick={() => {
                    setWarpwidthpx((wt) => {
                        return wt - 100
                    })
                }}>-</button>
            {warpwidthpx}
            <button
                className='Drawbookedit_guestbookpagestextadddeduct'
                onClick={() => {
                    setWarpwidthpx((wt) => {
                        return wt + 100
                    })
                }}>+</button>

        </div>
        : null


    const OWNER_POV_WEBTABLET = titledata && Object.keys(titledata).length > 0
        ? <div className="Drawbookedit_active" style={{ minHeight: 'calc( 100vh - 61px )' }}>

            {device === 'WEB' || device === 'TABLET' || device === 'MOBILE'
                ? <>
                    {/* LEFT */}
                    <div
                        className={`Drawbookedit_active_left_${SYSTEM_DEVICE} sketchbg`}
                        style={{
                            overflowY: lookuptype === 'SCATTER' ? 'hidden' : 'scroll',
                            borderRight: lookuptype === 'SCATTER' ? '1px solid #dddddd' : ''
                        }}
                    >

                        {/* Device Selection */}
                        {DEVICE_SELECTION_DOM}

                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: maxguestnum === 30 ? '100%' : '', backgroundColor: bgcolor, marginTop: 70, padding: 10, }}>
                            {{
                                'GRID': <>

                                    {{
                                        'ARC': <OwnerArcTitle
                                            gridactive={gridactive}
                                            device={device}
                                            default_svg_properties={default_svg_properties}
                                            titledata={titledata}
                                            updateTitledata={(titledata) => setTitledata(JSON.parse(JSON.stringify(titledata)))}
                                            ownergridtitletopbool={ownergridtitletopbool} updateOwnertitletopbool={(e) => { setOwnergridtitletopbool(true); }}
                                            ownergridsubtitletopbool={ownergridsubtitletopbool} updateOwnersubtitletopbool={(e) => { setOwnergridsubtitletopbool(true); }}
                                            updatePanelAppearPosition={updatePanelAppearPosition}
                                            updatetitledata={(css_key, value) => {
                                                setTitledata((titledata) => {
                                                    let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                    if (css_key === 'rx' || css_key === 'ry') {
                                                        new_titledata['title'][device]['style']['arc']['rx'] = value
                                                        new_titledata['title'][device]['style']['arc']['ry'] = value
                                                    }
                                                    else if (css_key === 'startX' || css_key === 'endX') {
                                                        new_titledata['title'][device]['style']['arc']['endX'] += value - new_titledata['title'][device]['style']['arc']['startX']
                                                        new_titledata['title'][device]['style']['arc']['startX'] = value
                                                    }
                                                    else if (css_key === 'startY' || css_key === 'endY') {
                                                        new_titledata['title'][device]['style']['arc']['endY'] += value - new_titledata['title'][device]['style']['arc']['startY']
                                                        new_titledata['title'][device]['style']['arc']['startY'] = value
                                                    }
                                                    else {
                                                        new_titledata['title'][device]['style']['arc'][css_key] = value
                                                    }
                                                    return new_titledata
                                                })
                                            }}
                                            updateTitletext={(value) => {
                                                setTitledata((titledata) => {
                                                    let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                    new_titledata['title']['text'] = value
                                                    return new_titledata
                                                })
                                            }}
                                            updatesubtitledata={(css_key, value) => {
                                                setTitledata((titledata) => {
                                                    let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                    if (css_key === 'rx' || css_key === 'ry') {
                                                        new_titledata['subtitle'][device]['style']['arc']['rx'] = value
                                                        new_titledata['subtitle'][device]['style']['arc']['ry'] = value
                                                    }
                                                    else if (css_key === 'startX' || css_key === 'endX') {
                                                        new_titledata['subtitle'][device]['style']['arc']['endX'] += value - new_titledata['subtitle'][device]['style']['arc']['startX']
                                                        new_titledata['subtitle'][device]['style']['arc']['startX'] = value
                                                    }
                                                    else if (css_key === 'startY' || css_key === 'endY') {
                                                        new_titledata['subtitle'][device]['style']['arc']['endY'] += value - new_titledata['subtitle'][device]['style']['arc']['startY']
                                                        new_titledata['subtitle'][device]['style']['arc']['startY'] = value
                                                    }
                                                    else {
                                                        new_titledata['subtitle'][device]['style']['arc'][css_key] = value
                                                    }
                                                    return new_titledata
                                                })
                                            }}
                                            updateSubtitletext={(value) => {
                                                setTitledata((titledata) => {
                                                    let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                    new_titledata['subtitle']['text'] = value
                                                    return new_titledata
                                                })
                                            }}
                                            backuptitle={(arcdata, text) => {
                                                setTitledata((titledata) => {
                                                    setBackuptitledata(() => {
                                                        let new_backuptitledata = JSON.parse(JSON.stringify(titledata))
                                                        new_backuptitledata['title'][device]['style']['arc'] = arcdata
                                                        new_backuptitledata['title']['text'] = text
                                                        return new_backuptitledata
                                                    })
                                                    return titledata
                                                })

                                            }}
                                            backupsubtitle={(arcdata, text) => {
                                                setTitledata((titledata) => {
                                                    setBackupsubtitledata(() => {
                                                        let new_backupsubtitledata = JSON.parse(JSON.stringify(titledata))
                                                        new_backupsubtitledata['subtitle'][device]['style']['arc'] = arcdata
                                                        new_backupsubtitledata['subtitle']['text'] = text
                                                        return new_backupsubtitledata
                                                    })
                                                    return titledata
                                                })
                                            }}
                                            canceltitle={() => {
                                                setBackuptitledata((backuptitledata) => {
                                                    setTitledata((titledata) => {
                                                        let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                        new_titledata['title'][device]['style']['arc'] = backuptitledata['title'][device]['style']['arc']
                                                        new_titledata['title'][device]['style']['normaltext'] = backuptitledata['title'][device]['style']['normaltext']
                                                        new_titledata['title']['text'] = backuptitledata['title']['text']
                                                        return new_titledata
                                                    })
                                                    return {}
                                                })
                                                setOwnergridtitletopbool(false)
                                            }}
                                            cancelsubtitle={() => {
                                                setBackupsubtitledata((backupsubtitledata) => {
                                                    setTitledata((titledata) => {
                                                        let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                        new_titledata['subtitle'][device]['style']['arc'] = backupsubtitledata['subtitle'][device]['style']['arc']
                                                        new_titledata['subtitle']['text'] = backupsubtitledata['subtitle']['text']
                                                        return new_titledata
                                                    })
                                                    return {}
                                                })
                                                setOwnergridsubtitletopbool(false)
                                            }}
                                            savetitle={() => {
                                                setOwnersavebool(true)
                                                setSavefrom('OWNER_SAVE_GRID_ANYDEVICE_TITLE')
                                            }}
                                            savesubtitle={() => {
                                                setOwnersavebool(true)
                                                setSavefrom('OWNER_SAVE_GRID_SUBTITLE')
                                            }}
                                        />,
                                        'TEXT': <></>
                                    }[titledata['type']]}

                                    <DrawbookeditGrid
                                        bgcolor={bgcolor}
                                        guestdataaddr={guestdataaddr}
                                        guestdata={guestdata}
                                        maxguestnum={maxguestnum}
                                        device={device}
                                        updateDisplay={(id) => {
                                            const curr_item = JSON.parse(JSON.stringify(guestdata[id]))
                                            setDisplaydata({ ...curr_item, id: id })
                                        }}
                                    />

                                </>,
                                'SCATTER': properties && properties[device]
                                    ? <DrawbookeditScatterDevice
                                        guestdata={guestdata}
                                        guestdataaddr={guestdataaddr}
                                        maxguestnum={maxguestnum}
                                        canvasRefs={canvasRefs}
                                        showpanel={(e) => {
                                            updatePanelAppearPosition(e);
                                            setBackupproperties(JSON.parse(JSON.stringify(properties)))
                                            setBackupsharedproperties(JSON.parse(JSON.stringify(sharedproperties)))
                                            setOwnerscatterotherdevicebool(true);
                                        }}
                                        updateDisplay={(id) => {
                                            const curr_item = JSON.parse(JSON.stringify(guestdata[id]))
                                            setDisplaydata({ ...curr_item, id: id })
                                        }}

                                        scatterallowimgcounter={scatterallowimgcounter}
                                        scattercenterimg={S3CLOUD_CLOUDFRONT + sharedproperties['SCATTER'].img}
                                        dim={60}
                                        scatterallowimg={sharedproperties['SCATTER'].allowimg}
                                        scatterredirectlinks={sharedproperties['SCATTER'].redirects}
                                    />
                                    : null
                            }[lookuptype]}



                        </div>

                    </div>

                    {/* RIGHT */}
                    <div className={`Drawbookedit_active_right_${SYSTEM_DEVICE}`} style={{ height: 'calc(-61px + 100vh)' }}>
                        <div className='Drawbookedit_active_rightroot' style={{ height: '100%', overflowY: 'auto' }} >
                            <GuestbookeditGriddataDisplay
                                purchase={purchase}
                                displaydata={displaydata}
                                playactive={playactive}
                                drawbookid={drawbookid}
                                urlhandler={urlhandler}
                                passcode={passcode}
                                token={token}
                                savetxt={savetxt}
                                setSavetxt={setSavetxt}
                                updateEntry={(newname, newmsg, entryid) => {
                                    setGuestdata((guestdata) => {
                                        let new_guestdata = JSON.parse(JSON.stringify(guestdata))
                                        new_guestdata[entryid].name = newname
                                        new_guestdata[entryid].msg = newmsg
                                        return new_guestdata
                                    })

                                    setDisplaydata((displaydata) => {
                                        let new_displaydata = JSON.parse(JSON.stringify(displaydata))
                                        new_displaydata.name = newname
                                        new_displaydata.msg = newmsg
                                        return new_displaydata
                                    })
                                }}

                                guestdata={guestdata}
                                guestdataaddr={guestdataaddr}
                                setGuestdataaddr={setGuestdataaddr}
                                nowshowing={nowshowing}
                                setNowshowing={setNowshowing}

                                backupguestdataaddr={backupguestdataaddr}
                                setBackupguestdataaddr={setBackupguestdataaddr}

                            />
                        </div>
                        {nowshowing !== 'SWAP'
                            ? <button className='Drawbookedit_deletebtn' onClick={() => { setEntrydeletecmodal(true) }}>
                                {iconwrapper(TRASH_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center', placeItems: 'center', position: 'absolute', bottom: 0, right: 0, margin: 10, pointerEvents: 'none' })}
                            </button>
                            : null}

                        {!production
                            ? <button className='Drawbookedit_deletebtn' style={{ right: 40 }} onClick={() => {
                                // reference https://www.optimism.io/
                                const { pathsarray, paths } = displaydata
                                console.log(displaydata)



                                const textToCopy = JSON.stringify(pathsarray);

                                // Try modern clipboard API
                                if (navigator.clipboard && navigator.clipboard.writeText) {
                                    navigator.clipboard.writeText(textToCopy)
                                        .then(() => console.log("Copied!"))
                                        .catch(() => fallbackCopy(textToCopy));
                                } else {
                                    fallbackCopy(textToCopy);
                                }

                                function fallbackCopy(text) {
                                    const textarea = document.createElement("textarea");
                                    textarea.value = text;
                                    document.body.appendChild(textarea);
                                    textarea.select();
                                    document.execCommand("copy");
                                    document.body.removeChild(textarea);
                                    console.log("Copied using fallback!");
                                }

                            }}>
                                Copy
                            </button>
                            : null}
                    </div>

                </>
                : null}

            {device === 'PRINT' && properties && properties[device]
                ? {
                    'GRID': <div
                        className={`Drawbookedit_active_left_${SYSTEM_DEVICE} sketchbg`}
                        style={{
                            width: '100%',
                        }}
                    >

                        {DEVICE_SELECTION_DOM} {/* Device Selection */}

                        {{ // SPRITE ( wall art ) or GUESTBOOK ( the traditional guestbook )
                            'SPRITE': <div
                                className='Drawbookedit_spriteroot'
                                style={{
                                    'WEB': { transform: `scale(${gridmainscale})`, display: 'flex', position: 'relative', placeItems: 'center', flexDirection: 'column', width: { 'WEB': '100%', 'TABLET': default_svg_properties[device].width }[SYSTEM_DEVICE] },
                                    'TABLET': { transform: `scale(${gridmainscale})`, display: 'flex', position: 'relative', placeContent: 'flex-start', flexDirection: 'column', width: { 'WEB': '100%', 'TABLET': default_svg_properties[device].width }[SYSTEM_DEVICE] },
                                }[SYSTEM_DEVICE]}
                            >
                                <div style={{ display: 'flex', position: 'relative', marginTop: 140, marginBottom: 70, boxShadow: 'rgba(0, 0, 0, 0.15) 1px 5px 15px 0px', width: 'max-content' }}>
                                    <svg
                                        ref={svgRef}
                                        width={default_svg_properties[device].width}
                                        height={default_svg_properties[device].height}
                                        viewBox={`0 0 ${default_svg_properties[device].width} ${default_svg_properties[device].height}`}
                                        style={{ backgroundColor: bgcolor, position: 'relative' }}
                                    >

                                        {/* Group for OwnerArcTitleSVG */}
                                        {titleactive ? <g>
                                            <OwnerArcTitleSVG
                                                bgcolor={bgcolor}
                                                gridactive={gridactive}
                                                device={device}
                                                title_svg_properties={title_svg_properties}
                                                downloadtransparent={downloadtransparent}
                                                titledata={titledata}
                                                updateTitledata={(titledata) => setTitledata(JSON.parse(JSON.stringify(titledata)))}
                                                ownergridtitletopbool={ownergridtitletopbool}
                                                updateOwnertitletopbool={(e) => { setOwnergridtitletopbool(true); }}
                                                ownergridsubtitletopbool={ownergridsubtitletopbool}
                                                updateOwnersubtitletopbool={(e) => { setOwnergridsubtitletopbool(true); }}
                                                updatePanelAppearPosition={updatePanelAppearPosition}
                                                updatetitledata={(css_key, value) => {
                                                    setTitledata((titledata) => {
                                                        let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                        if (css_key === 'rx' || css_key === 'ry') {
                                                            new_titledata['title'][device]['style']['arc']['rx'] = value
                                                            new_titledata['title'][device]['style']['arc']['ry'] = value
                                                        }
                                                        else if (css_key === 'startX' || css_key === 'endX') {
                                                            new_titledata['title'][device]['style']['arc']['endX'] += value - new_titledata['title'][device]['style']['arc']['startX']
                                                            new_titledata['title'][device]['style']['arc']['startX'] = value
                                                        }
                                                        else if (css_key === 'startY' || css_key === 'endY') {
                                                            new_titledata['title'][device]['style']['arc']['endY'] += value - new_titledata['title'][device]['style']['arc']['startY']
                                                            new_titledata['title'][device]['style']['arc']['startY'] = value
                                                        }
                                                        else {
                                                            new_titledata['title'][device]['style']['arc'][css_key] = value
                                                        }
                                                        return new_titledata
                                                    })
                                                }}
                                                updateTitletext={(value) => {
                                                    setTitledata((titledata) => {
                                                        let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                        new_titledata['title']['text'] = value
                                                        return new_titledata
                                                    })
                                                }}
                                                updatesubtitledata={(css_key, value) => {
                                                    setTitledata((titledata) => {
                                                        let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                        if (css_key === 'rx' || css_key === 'ry') {
                                                            new_titledata['subtitle'][device]['style']['arc']['rx'] = value
                                                            new_titledata['subtitle'][device]['style']['arc']['ry'] = value
                                                        }
                                                        else if (css_key === 'startX' || css_key === 'endX') {
                                                            new_titledata['subtitle'][device]['style']['arc']['endX'] += value - new_titledata['subtitle'][device]['style']['arc']['startX']
                                                            new_titledata['subtitle'][device]['style']['arc']['startX'] = value
                                                        }
                                                        else if (css_key === 'startY' || css_key === 'endY') {
                                                            new_titledata['subtitle'][device]['style']['arc']['endY'] += value - new_titledata['subtitle'][device]['style']['arc']['startY']
                                                            new_titledata['subtitle'][device]['style']['arc']['startY'] = value
                                                        }
                                                        else {
                                                            new_titledata['subtitle'][device]['style']['arc'][css_key] = value
                                                        }
                                                        return new_titledata
                                                    })
                                                }}
                                                updateSubtitletext={(value) => {
                                                    setTitledata((titledata) => {
                                                        let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                        new_titledata['subtitle']['text'] = value
                                                        return new_titledata
                                                    })
                                                }}
                                                backuptitle={(arcdata, text) => {
                                                    setTitledata((titledata) => {
                                                        setBackuptitledata(() => {
                                                            let new_backuptitledata = JSON.parse(JSON.stringify(titledata))
                                                            new_backuptitledata['title'][device]['style']['arc'] = arcdata
                                                            new_backuptitledata['title']['text'] = text
                                                            return new_backuptitledata
                                                        })
                                                        return titledata
                                                    })
                                                }}
                                                backupsubtitle={(arcdata, text) => {
                                                    setTitledata((titledata) => {
                                                        setBackupsubtitledata(() => {
                                                            let new_backupsubtitledata = JSON.parse(JSON.stringify(titledata))
                                                            new_backupsubtitledata['subtitle'][device]['style']['arc'] = arcdata
                                                            new_backupsubtitledata['subtitle']['text'] = text
                                                            return new_backupsubtitledata
                                                        })
                                                        return titledata
                                                    })
                                                }}
                                                canceltitle={() => {
                                                    setBackuptitledata((backuptitledata) => {
                                                        setTitledata((titledata) => {
                                                            let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                            new_titledata['title'][device]['style']['arc'] = backuptitledata['title'][device]['style']['arc']
                                                            new_titledata['title'][device]['style']['normaltext'] = backuptitledata['title'][device]['style']['normaltext']
                                                            new_titledata['title']['text'] = backuptitledata['title']['text']
                                                            return new_titledata
                                                        })
                                                        return {}
                                                    })
                                                    setOwnergridtitletopbool(false)
                                                }}
                                                cancelsubtitle={() => {
                                                    setBackupsubtitledata((backupsubtitledata) => {
                                                        setTitledata((titledata) => {
                                                            let new_titledata = JSON.parse(JSON.stringify(titledata))
                                                            new_titledata['subtitle'][device]['style']['arc'] = backupsubtitledata['subtitle'][device]['style']['arc']
                                                            new_titledata['subtitle']['text'] = backupsubtitledata['subtitle']['text']
                                                            return new_titledata
                                                        })
                                                        return {}
                                                    })
                                                    setOwnergridsubtitletopbool(false)
                                                }}
                                                savetitle={() => {
                                                    setOwnersavebool(true)
                                                    setSavefrom('OWNER_SAVE_GRID_ANYDEVICE_TITLE')
                                                }}
                                                savesubtitle={() => {
                                                    setOwnersavebool(true)
                                                    setSavefrom('OWNER_SAVE_GRID_SUBTITLE')
                                                }}
                                            />
                                        </g> : null}

                                        {/* GRID */}
                                        <g
                                            transform={`translate( 0, ${150} )`}
                                            onClick={(e) => {
                                                updatePanelAppearPosition(e);
                                                setBackupproperties((backupproperties) => {
                                                    backupproperties = JSON.parse(JSON.stringify(properties))
                                                    return backupproperties
                                                })
                                                setOwnergridspriterootbool(true);
                                            }}
                                        >
                                            <DrawbookeditGridSVG
                                                titleactive={titleactive}
                                                placeholderactive={placeholderactive}
                                                properties={properties}
                                                bgcolor={bgcolor}
                                                device={device}
                                                default_svg_properties={default_svg_properties}
                                                title_svg_properties={title_svg_properties}
                                                guestdataaddr={guestdataaddr}
                                                guestdata={guestdata}
                                                maxguestnum={maxguestnum}
                                                downloadtransparent={downloadtransparent}
                                                updateDisplay={(id) => {
                                                    const curr_item = JSON.parse(JSON.stringify(guestdata[id]))
                                                    setDisplaydata({ ...curr_item, id: id })
                                                }}
                                            />
                                        </g>

                                        {/* Bleed Rectangle */}
                                        {gridactive
                                            ? <rect
                                                x={A3_BLEED} // 3mm bleed (negative to extend left)
                                                y={A3_BLEED} // 3mm bleed (negative to extend top)
                                                width={default_svg_properties[device].width - (2 * A3_BLEED)} // 1748 + 2*17.72 for 3mm bleed on both sides
                                                height={default_svg_properties[device].height - (2 * A3_BLEED)} // 2480 + 2*17.72 for 3mm bleed on both sides
                                                fill="none"
                                                stroke="red" // Visible color for bleed line
                                                strokeWidth="1"
                                                strokeDasharray="5,5" // Dashed line for clarity
                                            />
                                            : null}

                                        {qrdom}

                                    </svg>
                                </div>
                            </div>,
                            'GUESTBOOK': downloadablesegmentRefs
                                ? <LoooongGuestbook
                                    guestdata={guestdata}
                                    guestdataaddr={guestdataaddr}
                                    canvasRefs={canvasRefs}
                                    zoomGroupRef={zoomGroupRef}
                                    resetposition={resetposition}
                                    cancelpanel={cancelpanel}
                                    device={device}
                                    bgcolor={bgcolor}
                                    svgRef={svgRef}
                                    mainscale={gridmainscale}
                                    downloadablesegmentRefs={downloadablesegmentRefs}
                                    warpwidthpx={warpwidthpx}
                                /> : null
                        }[currentprint]}


                        <div className='Drawbookedit_mainscaleroot'>
                            {inputdescribe_dom('Main Canva Scale : ' + gridmainscale, { fontSize: 12, color: 'var(--maindark)' })}
                            <Slider
                                min={0}
                                max={2}
                                step={0.01}
                                value={gridmainscale}
                                onChange={(value) => {
                                    setGridmainscale(value)
                                }}
                            />
                        </div>

                        {PRINT_SELECTION}

                        {/* {LONGGUESTBOOK_EDITBTN} */}

                    </div>,
                    'SCATTER': <div
                        className={`Drawbookedit_active_left_${SYSTEM_DEVICE} sketchbg`}
                        style={{ width: '100%', }}
                    >

                        {DEVICE_SELECTION_DOM}

                        {{
                            'SPRITE': <div
                                className='Drawbookedit_spriteroot'
                                style={{
                                    'WEB': {
                                        transform: `scale(${scattermainscale})`,
                                        display: 'flex', position: 'relative', placeItems: 'center', flexDirection: 'column', width: { 'WEB': '100%', 'TABLET': default_svg_properties[device].width }[SYSTEM_DEVICE]
                                    },
                                    'TABLET': {
                                        transform: `scale(${scattermainscale})`,
                                        display: 'flex', position: 'relative', placeContent: 'flex-start', flexDirection: 'column', width: { 'WEB': '100%', 'TABLET': default_svg_properties[device].width }[SYSTEM_DEVICE]
                                    },
                                }[SYSTEM_DEVICE]}
                            >
                                <div
                                    onMouseOver={(e) => updatePanelAppearPosition(e)}
                                    style={{ display: 'flex', position: 'relative', marginTop: 140, marginBottom: 70, boxShadow: 'rgba(0, 0, 0, 0.15) 1px 5px 15px 0px', width: 'max-content' }}
                                >
                                    <svg
                                        ref={svgRef}
                                        width={default_svg_properties[device].width}
                                        height={default_svg_properties[device].height}
                                        viewBox={`0 0 ${default_svg_properties[device].width} ${default_svg_properties[device].height}`}
                                        style={{ backgroundColor: bgcolor, position: 'relative' }}
                                    >
                                        {sharedproperties && sharedproperties['SCATTER'] && sharedproperties['SCATTER'].allowimg
                                            ? <DrawbookeditScatterPrintable_withcenterimage
                                                guestdata={guestdata}
                                                guestdataaddr={guestdataaddr}
                                                maxguestnum={maxguestnum}
                                                canvasRefs={canvasRefs}
                                                zoomGroupRef={zoomGroupRef}
                                                resetposition={resetposition}
                                                cancelpanel={cancelpanel}

                                                scatterallowimgcounter={scatterallowimgcounter}

                                                dim={properties['PRINT']['SCATTER']['sprite_dim']}
                                                scale={properties['PRINT']['SCATTER']['scale']}

                                                scattercenterimg={S3CLOUD_CLOUDFRONT + sharedproperties['SCATTER'].img} // bear
                                                scatterallowimg={sharedproperties['SCATTER'].allowimg}
                                                scatterredirectlinks={sharedproperties['SCATTER'].redirects}

                                                mainimgsize={properties['PRINT']['SCATTER']['mainimgsize']}
                                                forcecenter_x={properties['PRINT']['SCATTER']['forcecenter_x']}
                                                forcecenter_y={properties['PRINT']['SCATTER']['forcecenter_y']}
                                                forcecollideradius={properties['PRINT']['SCATTER']['forcecollideradius']}
                                                forcecharge={properties['PRINT']['SCATTER']['forcecharge']}
                                                coord_x={properties['PRINT']['SCATTER']['coord_x']}
                                                coord_y={properties['PRINT']['SCATTER']['coord_y']}

                                                setCoord_x={(val) => {
                                                    setProperties((prev_properties) => {
                                                        let new_properties = JSON.parse(JSON.stringify(prev_properties))
                                                        new_properties['PRINT']['SCATTER']['coord_x'] = val
                                                        return new_properties
                                                    })
                                                }}
                                                setCoord_y={(val) => {
                                                    setProperties((prev_properties) => {
                                                        let new_properties = JSON.parse(JSON.stringify(prev_properties))
                                                        new_properties['PRINT']['SCATTER']['coord_y'] = val
                                                        return new_properties
                                                    })
                                                }}
                                                setCancelpanel={setCancelpanel}
                                                setResetposition={setResetposition}
                                                updateDisplay={(id) => setDisplaydata({ ...JSON.parse(JSON.stringify(guestdata[id])), id: id })}
                                                showpanel={(e) => {
                                                    updatePanelAppearPosition(e);
                                                    setBackupproperties(JSON.parse(JSON.stringify(properties)))
                                                    setBackupsharedproperties(JSON.parse(JSON.stringify(sharedproperties)))
                                                    setOwnerscatterprintbool(true);
                                                }}
                                            />
                                            : <DrawbookeditScatterPrintable_withoutcenterimage
                                                guestdata={guestdata}
                                                guestdataaddr={guestdataaddr}
                                                maxguestnum={maxguestnum}
                                                canvasRefs={canvasRefs}
                                                zoomGroupRef={zoomGroupRef}
                                                resetposition={resetposition}
                                                cancelpanel={cancelpanel}

                                                scatterallowimgcounter={scatterallowimgcounter}

                                                dim={properties['PRINT']['SCATTER']['sprite_dim']}
                                                scale={properties['PRINT']['SCATTER']['scale']}

                                                forcecenter_x={properties['PRINT']['SCATTER']['forcecenter_x']}
                                                forcecenter_y={properties['PRINT']['SCATTER']['forcecenter_y']}
                                                forcecollideradius={properties['PRINT']['SCATTER']['forcecollideradius']}
                                                forcecharge={properties['PRINT']['SCATTER']['forcecharge']}
                                                coord_x={properties['PRINT']['SCATTER']['coord_x']}
                                                coord_y={properties['PRINT']['SCATTER']['coord_y']}

                                                setCoord_x={(val) => {
                                                    setProperties((prev_properties) => {
                                                        let new_properties = JSON.parse(JSON.stringify(prev_properties))
                                                        new_properties['PRINT']['SCATTER']['coord_x'] = val
                                                        return new_properties
                                                    })
                                                }}
                                                setCoord_y={(val) => {
                                                    setProperties((prev_properties) => {
                                                        let new_properties = JSON.parse(JSON.stringify(prev_properties))
                                                        new_properties['PRINT']['SCATTER']['coord_y'] = val
                                                        return new_properties
                                                    })
                                                }}
                                                setCancelpanel={setCancelpanel}
                                                setResetposition={setResetposition}
                                                updateDisplay={(id) => setDisplaydata({ ...JSON.parse(JSON.stringify(guestdata[id])), id: id })}
                                                showpanel={(e) => {
                                                    updatePanelAppearPosition(e);
                                                    setBackupproperties(JSON.parse(JSON.stringify(properties)))
                                                    setBackupsharedproperties(JSON.parse(JSON.stringify(sharedproperties)))
                                                    setOwnerscatterprintbool(true);
                                                }}
                                            />}


                                        {/* Cross grid lines */}
                                        {gridactive
                                            ? (
                                                <>
                                                    {/* Vertical line */}
                                                    <line
                                                        x1={default_svg_properties[device].width / 2}
                                                        y1="0"
                                                        x2={default_svg_properties[device].width / 2}
                                                        y2={default_svg_properties[device].height}
                                                        stroke="red"
                                                        strokeWidth="1"
                                                        strokeDasharray="4,4"
                                                    />
                                                    {/* Horizontal line */}
                                                    <line
                                                        x1="0"
                                                        y1={default_svg_properties[device].height / 2}
                                                        x2={default_svg_properties[device].width}
                                                        y2={default_svg_properties[device].height / 2}
                                                        stroke="red"
                                                        strokeWidth="1"
                                                        strokeDasharray="4,4"
                                                    />
                                                </>
                                            ) : null}

                                        {/* Bleed Rectangle */}
                                        {gridactive
                                            ? <rect
                                                x={A3_BLEED} // 3mm bleed (negative to extend left)
                                                y={A3_BLEED} // 3mm bleed (negative to extend top)
                                                width={default_svg_properties[device].width - (2 * A3_BLEED)} // 1748 + 2*17.72 for 3mm bleed on both sides
                                                height={default_svg_properties[device].height - (2 * A3_BLEED)} // 2480 + 2*17.72 for 3mm bleed on both sides
                                                fill="none"
                                                stroke="red" // Visible color for bleed line
                                                strokeWidth="1"
                                                strokeDasharray="5,5" // Dashed line for clarity
                                            />
                                            : null}

                                        {/* Bottom-left title */}
                                        {titleactive
                                            ? <text
                                                onClick={() => {

                                                    setBackuptitledata((curr_backuptitledata) => {
                                                        if (!curr_backuptitledata || Object.keys(curr_backuptitledata).length === 0) {
                                                            let new_backuptitledata = JSON.parse(JSON.stringify(titledata))
                                                            new_backuptitledata['title'][device]['style']['normaltext'] = titledata['title'][device]['style']['normaltext']
                                                            new_backuptitledata['title']['text']
                                                            return new_backuptitledata
                                                        }
                                                        else {
                                                            let new_backuptitledata = JSON.parse(JSON.stringify(curr_backuptitledata))
                                                            new_backuptitledata['title'][device]['style']['normaltext'] = titledata['title'][device]['style']['normaltext']
                                                            new_backuptitledata['title']['text']
                                                            return new_backuptitledata
                                                        }
                                                    })

                                                    setOwnerscattertitletopbool(true)

                                                }}
                                                x={A3_BLEED + 20} // distance from the left edge
                                                y={default_svg_properties[device].height - 125 - A3_BLEED - 20 + (48 * 2.5)} // distance from bottom edge
                                                fontSize={titledata.title[device].style.normaltext.fontSize}
                                                fill={titledata.title[device].style.normaltext.color}
                                                fontFamily="Lato"
                                            >
                                                {titledata.title.text}
                                            </text>
                                            : null}

                                        {qrdom}

                                    </svg>
                                </div>
                            </div>,
                            'GUESTBOOK': downloadablesegmentRefs
                                ? <LoooongGuestbook
                                    guestdata={guestdata}
                                    guestdataaddr={guestdataaddr}
                                    canvasRefs={canvasRefs}
                                    zoomGroupRef={zoomGroupRef}
                                    resetposition={resetposition}
                                    cancelpanel={cancelpanel}
                                    device={device}
                                    bgcolor={bgcolor}
                                    svgRef={svgRef}
                                    mainscale={scattermainscale}
                                    downloadablesegmentRefs={downloadablesegmentRefs}
                                    warpwidthpx={warpwidthpx}
                                /> : null
                        }[currentprint]}


                        <div className='Drawbookedit_mainscaleroot'>
                            {inputdescribe_dom('Main Canva Scale : ' + scattermainscale, { fontSize: 12, color: 'var(--maindark)' })}
                            <Slider
                                min={0}
                                max={2}
                                step={0.01}
                                value={scattermainscale}
                                onChange={(value) => {
                                    setScattermainscale(value);
                                }}
                            />
                        </div>

                        {PRINT_SELECTION}

                    </div>
                }[lookuptype]
                : null}

            {ownerscatterprintbool
                ? <DraggablePanel initialPosition={panelPosition} >
                    <div className='Drawbookedit_dragpanelcontent'>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

                            {inputdescribe_dom(`Scale : ${properties['PRINT']['SCATTER']['scale']}`, {})}
                            <Slider
                                min={0} max={3} step={0.01}
                                value={properties['PRINT']['SCATTER']['scale']}
                                onChange={(value) => {
                                    setProperties((properties) => {
                                        let new_properties = JSON.parse(JSON.stringify(properties))
                                        new_properties['PRINT']['SCATTER']['scale'] = value
                                        return new_properties
                                    })
                                }}
                            />

                            {inputdescribe_dom(`Coordinates : ( ${Math.floor(properties['PRINT']['SCATTER']['coord_x'])}, ${Math.floor(properties['PRINT']['SCATTER']['coord_y'])} )`, {})}
                            <button style={{ height: 25 }} onClick={() => { setResetposition(true) }}>Reset</button>

                            {inputdescribe_dom(`Sprite Size : ${properties['PRINT']['SCATTER']['sprite_dim']} `, {})}
                            <Slider
                                min={0} max={150} step={1}
                                value={properties['PRINT']['SCATTER']['sprite_dim']}
                                onChange={(value) => {
                                    setProperties((properties) => {
                                        let new_properties = JSON.parse(JSON.stringify(properties))
                                        new_properties['PRINT']['SCATTER']['sprite_dim'] = value
                                        return new_properties
                                    })
                                }}
                            />

                            {inputdescribe_dom('Collide Radius : ' + properties['PRINT']['SCATTER']['forcecollideradius'], {})}
                            <Slider
                                min={-25} max={25} step={0.01}
                                value={properties['PRINT']['SCATTER']['forcecollideradius']}
                                onChange={(value) => {
                                    setProperties((properties) => {
                                        let new_properties = JSON.parse(JSON.stringify(properties))
                                        new_properties['PRINT']['SCATTER']['forcecollideradius'] = value
                                        return new_properties
                                    })
                                }}
                            />

                            {inputdescribe_dom('Force Charge : ' + properties['PRINT']['SCATTER']['forcecharge'], {})}
                            <Slider
                                min={-25} max={25} step={0.01}
                                value={properties['PRINT']['SCATTER']['forcecharge']}
                                onChange={(value) => {
                                    setProperties((properties) => {
                                        let new_properties = JSON.parse(JSON.stringify(properties))
                                        new_properties['PRINT']['SCATTER']['forcecharge'] = value
                                        return new_properties
                                    })
                                }}
                            />

                            {inputdescribe_dom('Enable Image : ', {})}
                            {radiobtn_dom(
                                sharedproperties['SCATTER'].allowimg ? true : false,
                                () => {
                                    setSharedproperties((sharedproperties) => {
                                        let new_sharedproperties = JSON.parse(JSON.stringify(sharedproperties))
                                        new_sharedproperties['SCATTER']['allowimg'] = !new_sharedproperties['SCATTER']['allowimg']
                                        return new_sharedproperties
                                    })
                                    setScatterallowimgcounter(scatterallowimgcounter + 1)
                                },
                                sharedproperties['SCATTER'].allowimg ? `Click To Disable` : `Click To Enable`,
                                { margin: 0, fontSize: 12 }
                            )}

                            {sharedproperties['SCATTER'].allowimg
                                ? <>
                                    {inputdescribe_dom('Main Image Upload', {})}
                                    <button
                                        className='Drawbookedit_scatterimgupload'
                                        style={{
                                            backgroundImage: 'url(' + S3CLOUD_CLOUDFRONT + sharedproperties['SCATTER']['img'] + ')',
                                            backgroundSize: 'contain'
                                        }}
                                        onClick={() => {
                                            imginputref.current.click()
                                        }}
                                    />

                                    <input
                                        ref={imginputref}
                                        accept="image/*"
                                        className="Template_imginput"
                                        id="formControlsFile"
                                        type='file'
                                        name="input-file"
                                        onChange={async (e) => {
                                            var reader = new FileReader()
                                            let file = e.target.files[0]
                                            reader.onload = (e) => {
                                                var img = document.createElement("img");
                                                img.onload = () => {
                                                    if (file.size < 20000000) { // 2MB : 2097152, 20MB : 20000000
                                                        const { name, type } = file
                                                        const width = img.naturalWidth;
                                                        const height = img.naturalHeight;
                                                        const aspectRatio = width / height;

                                                        setTempmainimgaspectratio(aspectRatio)
                                                        setTempmainimg([img.src])
                                                        setTempmainimginfo(JSON.parse(JSON.stringify({ name: [name], type: [type] })))
                                                        setNeededit(true) // activate Cropper
                                                    }
                                                    else {
                                                        setError(`Image size must be less than 10MB`);
                                                        setTimeout(() => setError(''), 3000)
                                                    }
                                                }
                                                img.src = e.target.result;
                                            }
                                            reader.readAsDataURL(file);
                                        }}
                                    />

                                    {inputdescribe_dom('Main Image Size : ' + properties['PRINT']['SCATTER']['mainimgsize'], {})}
                                    <Slider
                                        min={0} max={150} step={1}
                                        value={properties['PRINT']['SCATTER']['mainimgsize']}
                                        onChange={(value) => {
                                            setProperties((properties) => {
                                                let new_properties = JSON.parse(JSON.stringify(properties))
                                                new_properties['PRINT']['SCATTER']['mainimgsize'] = value
                                                return new_properties
                                            })
                                        }}
                                    />
                                    {inputdescribe_dom('Redirect Link', {})}
                                    <input
                                        value={sharedproperties['SCATTER']['redirects'][0]}
                                        onChange={(e) => {
                                            const { value } = e.target
                                            setSharedproperties((sharedproperties) => {
                                                let new_sharedproperties = JSON.parse(JSON.stringify(sharedproperties))
                                                new_sharedproperties['SCATTER']['redirects'][0] = value
                                                return new_sharedproperties
                                            })
                                        }}
                                    />
                                </>
                                : null}

                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                            <button
                                className='Drawbookedit_cross'
                                onClick={() => {
                                    setBackupproperties((backupproperties) => {
                                        setProperties(() => {
                                            let new_backupproperties = JSON.parse(JSON.stringify(backupproperties));
                                            return new_backupproperties;
                                        })
                                        return {}
                                    })
                                    setBackupsharedproperties((backupsharedproperties) => {
                                        setSharedproperties((sharedproperties) => {
                                            let new_sharedproperties = JSON.parse(JSON.stringify(backupsharedproperties));
                                            new_sharedproperties['SCATTER'].img = sharedproperties['SCATTER'].img // if img is uploaded new one, the new one will stay.
                                            return new_sharedproperties;
                                        })
                                        return {}
                                    })

                                    setOwnerscatterprintbool(false)
                                }}
                            >
                                ✗
                            </button>

                            <button className='Drawbookedit_tick' onClick={() => { setSavefrom('OWNER_PRINT_SCATTER_PROPERTY_SAVE'); setOwnersavebool(true); }}>✓</button>
                        </div>

                    </div>
                </DraggablePanel>
                : null}

            {/* bear */}
            {ownerscatterotherdevicebool
                ? <DraggablePanel initialPosition={panelPosition} >
                    <div className='Drawbookedit_dragpanelcontent'>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

                            {inputdescribe_dom('Enable Image : ', {})}
                            {radiobtn_dom(
                                sharedproperties['SCATTER'].allowimg ? true : false,
                                () => {
                                    setSharedproperties((sharedproperties) => {
                                        let new_sharedproperties = JSON.parse(JSON.stringify(sharedproperties))
                                        new_sharedproperties['SCATTER']['allowimg'] = !new_sharedproperties['SCATTER']['allowimg']
                                        return new_sharedproperties
                                    })
                                    setScatterallowimgcounter(scatterallowimgcounter + 1)
                                    setResetposition(true)
                                },
                                sharedproperties['SCATTER'].allowimg ? `Click To Disable` : `Click To Enable`,
                                { margin: 0, fontSize: 12 }
                            )}

                            {sharedproperties['SCATTER'].allowimg
                                ? <>
                                    {inputdescribe_dom('Main Image Upload', {})}
                                    <button
                                        className='Drawbookedit_scatterimgupload'
                                        style={{
                                            backgroundImage: 'url(' + S3CLOUD_CLOUDFRONT + sharedproperties['SCATTER']['img'] + ')',
                                            backgroundSize: 'contain'
                                        }}
                                        onClick={() => {
                                            imginputref.current.click()
                                        }}
                                    />

                                    <input
                                        ref={imginputref}
                                        accept="image/*"
                                        className="Template_imginput"
                                        id="formControlsFile"
                                        type='file'
                                        name="input-file"
                                        onChange={async (e) => {
                                            var reader = new FileReader()
                                            let file = e.target.files[0]
                                            reader.onload = (e) => {
                                                var img = document.createElement("img");
                                                img.onload = () => {
                                                    if (file.size < 20000000) { // 2MB : 2097152, 20MB : 20000000
                                                        const { name, type } = file
                                                        const width = img.naturalWidth;
                                                        const height = img.naturalHeight;
                                                        const aspectRatio = width / height;

                                                        setTempmainimgaspectratio(aspectRatio)
                                                        setTempmainimg([img.src])
                                                        setTempmainimginfo(JSON.parse(JSON.stringify({ name: [name], type: [type] })))
                                                        setNeededit(true) // activate Cropper
                                                    }
                                                    else {
                                                        setError(`Image size must be less than 10MB`);
                                                        setTimeout(() => setError(''), 3000)
                                                    }
                                                }
                                                img.src = e.target.result;
                                            }
                                            reader.readAsDataURL(file);
                                        }}
                                    />

                                    {inputdescribe_dom('Redirect Link', {})}
                                    <input
                                        value={sharedproperties['SCATTER']['redirects'][0]}
                                        onChange={(e) => {
                                            const { value } = e.target
                                            setSharedproperties((sharedproperties) => {
                                                let new_sharedproperties = JSON.parse(JSON.stringify(sharedproperties))
                                                new_sharedproperties['SCATTER']['redirects'][0] = value
                                                return new_sharedproperties
                                            })
                                        }}
                                    />
                                </>
                                : null}

                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                            <button
                                className='Drawbookedit_cross'
                                onClick={() => {
                                    setBackupproperties((backupproperties) => {
                                        setProperties(() => {
                                            let new_backupproperties = JSON.parse(JSON.stringify(backupproperties));
                                            return new_backupproperties;
                                        })
                                        return {}
                                    })
                                    setBackupsharedproperties((backupsharedproperties) => {
                                        setSharedproperties((sharedproperties) => {
                                            let new_sharedproperties = JSON.parse(JSON.stringify(backupsharedproperties));
                                            new_sharedproperties['SCATTER'].img = sharedproperties['SCATTER'].img
                                            return new_sharedproperties;
                                        })
                                        return {}
                                    })

                                    setOwnerscatterotherdevicebool(false)
                                }}
                            >
                                ✗
                            </button>
                            <button className='Drawbookedit_tick' onClick={() => { setSavefrom('OWNER_PRINT_SCATTER_PROPERTY_SAVE'); setOwnersavebool(true); }}>✓</button>
                        </div>

                    </div>
                </DraggablePanel>
                : null}

            {neededit
                ? <div className="Imageic_croproot">
                    <div className="Imageic_cropcontainer">
                        <Cropper
                            image={tempmainimg}
                            crop={crop}
                            zoom={zoom}
                            aspect={1}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={cropcomplete}
                        />
                        <div className="Imageic_btnsrow">
                            {uploadstate === 'WAITING'
                                ? <button key={'imgs_cancel_' + uploadstate} className="Imageic_btn" onClick={cropcancel}>
                                    Cancel
                                </button>
                                : null}
                            {uploadstate === 'UPLOADING'
                                ? <div className="Imageic_uploading" >
                                    ...
                                </div>
                                : null}
                            {uploadstate === 'WAITING'
                                ? <button
                                    key={'imgs_upload_' + uploadstate}
                                    className="Imageic_btn"
                                    style={{ marginRight: 5 }}
                                    disabled={uploadstate === 'UPLOADING'}
                                    onClick={async () => {
                                        setUploadstate('UPLOADING');

                                        const croppedImage = await getCroppedImg(tempmainimg, tempcroppedimg);

                                        if (croppedImage) {

                                            const blobToImage = (blob) => {
                                                return new Promise((resolve) => {
                                                    const url = URL.createObjectURL(blob);
                                                    const img = new Image();
                                                    img.onload = () => {
                                                        URL.revokeObjectURL(url);
                                                        resolve(img);
                                                    };
                                                    img.src = url;
                                                });
                                            };

                                            const Imagedownsize3x = (img) => {
                                                const scale = 1 / 3;

                                                const width = Math.round(img.width * scale);
                                                const height = Math.round(img.height * scale);

                                                const canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;

                                                const ctx = canvas.getContext('2d');
                                                ctx.drawImage(img, 0, 0, width, height);

                                                return canvas.toDataURL('image/jpeg'); // You can change to 'image/png' if needed
                                            };

                                            const dataURLToBlob = function (dataURL) {
                                                const BASE64_MARKER = ';base64,';

                                                if (!dataURL || typeof dataURL !== 'string') {
                                                    console.error("Invalid dataURL: not a string", dataURL);
                                                    return undefined;
                                                }

                                                if (dataURL.indexOf(BASE64_MARKER) === -1) {
                                                    const parts1 = dataURL.split(',');
                                                    if (parts1.length !== 2) {
                                                        console.error("Invalid non-base64 dataURL format", dataURL);
                                                        return undefined;
                                                    }

                                                    const contentType1 = parts1[0].split(':')[1];
                                                    const raw1 = decodeURIComponent(parts1[1]);
                                                    return new Blob([raw1], { type: contentType1 });
                                                }

                                                const parts = dataURL.split(BASE64_MARKER);
                                                if (parts.length !== 2) {
                                                    console.error("Malformed base64 dataURL:", dataURL);
                                                    return undefined;
                                                }

                                                const contentType = parts[0].split(':')[1];
                                                try {
                                                    const raw = window.atob(parts[1]);
                                                    const rawLength = raw.length;
                                                    const uInt8Array = new Uint8Array(rawLength);

                                                    for (let i = 0; i < rawLength; ++i) {
                                                        uInt8Array[i] = raw.charCodeAt(i);
                                                    }

                                                    return new Blob([uInt8Array], { type: contentType });
                                                } catch (e) {
                                                    console.error("Failed to decode base64:", e, dataURL);
                                                    return undefined;
                                                }
                                            };

                                            const uploadtobackend = async (data) => {

                                                const { token } = Retrieve_personal_info()
                                                const { img, urlhandler, id } = data

                                                const { key, uploadURL } = await getPresignedUrlsWithTokenWithLoad(token, { urlhandler }, UPDATE_DRAWBOOKMAINIMGTOKEN);

                                                await uploadToS3(img, uploadURL);

                                                const { message, loc } = await notifyBackendUpload(token, { key: key, urlhandler, id, lookuptype }, UPDATE_DRAWBOOKMAINIMGCFMSAVED);

                                                if (message === 'SUCCESS') {

                                                    setStatus('Uploading ' + tempmainimginfo['name'][0])

                                                    setTimeout(() => {
                                                        setTempmainimg(null)
                                                        setTempmainimginfo(null)
                                                        setTempcroppedimg(null)
                                                        setStatus('')
                                                        setNeededit(false)
                                                        setUploadstate('WAITING')

                                                        // bull
                                                        setSharedproperties((sharedproperties) => {
                                                            let new_sharedproperties = JSON.parse(JSON.stringify(sharedproperties))
                                                            new_sharedproperties[lookuptype]['img'] = key
                                                            return new_sharedproperties
                                                        })

                                                    }, 1000)

                                                }
                                                else if (message === 'INCORRECTFILETYPE') {
                                                    setStatus('Incorrect File Type.')
                                                    setTimeout(() => { setStatus('') }, 1000)
                                                }


                                            }

                                            croppedImage.toBlob(async (blob) => {
                                                // Convert blob to image for resizing
                                                const image = await blobToImage(blob); // Helper function below
                                                const downsizedDataUrl = Imagedownsize3x(image); // Shrink by 3x

                                                const curr_img = new File(
                                                    [blob],
                                                    `${urlhandler}.jpg`, // 🔧 force extension to .jpg
                                                    { type: 'image/jpeg' } // 🔧 force MIME type to image/jpeg
                                                );

                                                uploadtobackend({
                                                    img: curr_img,
                                                    urlhandler,
                                                    id: drawbookid,
                                                });

                                            }, 'image/jpeg');
                                        }
                                    }}
                                >
                                    Upload
                                </button>
                                : null}
                        </div>
                    </div>
                </div>
                : null
            }

            <Noti noti={status} />

            {entrydeletecmodal
                ? <Modcfm
                    onHide={() => { setEntrydeletecmodal(false) }}
                    onOk={() => { deleteentry(displaydata); }}
                    onNo={() => { setEntrydeletecmodal(false) }}
                    txt={'Once you delete this, there is no going back. Please be certain.'}
                />
                : null}

            {ownergridspriterootbool && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent'>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

                        {/* {inputdescribe_dom('Scale : ' + properties['PRINT'][lookuptype]['style']['sprite_root_scalefactor'], {})} */}
                        {inputdescribe_dom('Scale : ' + properties['PRINT'][lookuptype]['sprite_root_scalefactor'], {})}
                        {properties && properties['PRINT'][lookuptype]
                            ? <Slider
                                min={0}
                                max={1}
                                step={0.01}
                                value={properties['PRINT'][lookuptype]['sprite_root_scalefactor']}
                                onChange={(value) => {
                                    setProperties((properties) => {
                                        let new_properties = JSON.parse(JSON.stringify(properties))
                                        new_properties['PRINT'][lookuptype]['sprite_root_scalefactor'] = value
                                        return new_properties
                                    })
                                }}
                            />
                            : null}


                        {inputdescribe_dom('Y-Axis : ' + properties['PRINT'][lookuptype]['sprite_root_y'], {})}
                        {properties && properties['PRINT'][lookuptype]
                            ? <Slider
                                min={-5000}
                                max={1000}
                                step={1}
                                value={properties['PRINT'][lookuptype]['sprite_root_y']}
                                onChange={(value) => {
                                    setProperties((properties) => {
                                        let new_properties = JSON.parse(JSON.stringify(properties))
                                        new_properties['PRINT'][lookuptype]['sprite_root_y'] = value
                                        return new_properties
                                    })
                                }}
                            />
                            : null}

                        {inputdescribe_dom('Sprite Dimension : ' + properties['PRINT'][lookuptype]['sprite_dim'], {})}
                        {properties && properties['PRINT'][lookuptype]
                            ? <Slider
                                min={0}
                                max={500}
                                step={1}
                                value={properties['PRINT'][lookuptype]['sprite_dim']}
                                onChange={(value) => {
                                    setProperties((properties) => {
                                        let new_properties = JSON.parse(JSON.stringify(properties))
                                        new_properties['PRINT'][lookuptype]['sprite_dim'] = value
                                        return new_properties
                                    })
                                }}
                            />
                            : null}

                    </div>

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button
                            className='Drawbookedit_cross'
                            onClick={() => {
                                setBackupproperties((backupproperties) => {
                                    setProperties(() => {
                                        let local_backupproperties = JSON.parse(JSON.stringify(backupproperties));
                                        return local_backupproperties;
                                    })
                                })
                                setBackupsharedproperties((backupsharedproperties) => {
                                    setSharedproperties(() => {
                                        let local_sharedproperties = JSON.parse(JSON.stringify(backupsharedproperties));
                                        return local_sharedproperties;
                                    })
                                })
                                setOwnergridspriterootbool(false)
                            }}
                        >
                            ✗
                        </button>
                        <button
                            className='Drawbookedit_tick'
                            onClick={() => {
                                setOwnergridspriterootbool(false)
                                setOwnersavebool(true);
                                setSavefrom('OWNER_SAVE_PROPERTIES');
                            }}
                        >
                            ✓
                        </button>
                    </div>

                </div>
            </DraggablePanel>)}

            {ownergridtitletopbool && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent' style={{ maxHeight: 500, overflowY: 'scroll' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

                        {/* Font Size Slider */}
                        {inputdescribe_dom('Font Size :' + titledata['title'][device]['style']['arc'].fontSize, {})}
                        <Slider
                            min={8}
                            max={100}
                            step={1}
                            value={titledata['title'][device]['style']['arc']['fontSize']}
                            onChange={(value) => { updatetitledata('fontSize', value) }}
                        />

                        {/* Radius Slider (rx and ry) */}
                        {inputdescribe_dom('rx : ' + titledata['title'][device]['style']['arc'].rx + ' ry : ' + titledata['title'][device]['style']['arc'].ry, {})}
                        <Slider
                            min={0}
                            max={1000}
                            step={1}
                            value={titledata['title'][device]['style']['arc'].rx}
                            onChange={(value) => { updatetitledata('rx', value) }}
                        />

                        {/* X-Axis (startX & endX) */}
                        {inputdescribe_dom('startX : ' + titledata['title'][device]['style']['arc'].startX + ' endX : ' + titledata['title'][device]['style']['arc'].endX, {})}
                        <Slider
                            min={-500}
                            max={1500}
                            step={1}
                            value={titledata['title'][device]['style']['arc'].startX}
                            onChange={(value) => { updatetitledata('startX', value) }}

                        />

                        {/* Y-Axis (startY & endY) */}
                        {inputdescribe_dom('startY : ' + titledata['title'][device]['style']['arc'].startY + ' endY : ' + titledata['title'][device]['style']['arc'].endY, {})}
                        <Slider
                            min={-500}
                            max={1500}
                            step={1}
                            value={titledata['title'][device]['style']['arc'].startY}
                            onChange={(value) => { updatetitledata('startY', value) }}
                        />

                        {/* dy */}
                        {inputdescribe_dom('dy : ' + titledata['title'][device]['style']['arc'].dy, {})}
                        <Slider
                            min={-500}
                            max={1500}
                            step={1}
                            value={titledata['title'][device]['style']['arc'].dy}
                            onChange={(value) => { updatetitledata('dy', value) }}
                        />

                        {/* scale */}
                        {inputdescribe_dom('Scale : ' + titledata['title'][device]['style']['arc'].scale, {})}
                        <Slider
                            min={-500}
                            max={1500}
                            step={0.1}
                            value={titledata['title'][device]['style']['arc'].scale}
                            onChange={(value) => { updatetitledata('scale', value) }}
                        />

                    </div>

                    {/* Title Input */}
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={titledata['title'].text}
                        onChange={(e) => { updateTitletext(e.target.value) }}
                    />


                    <>
                        <HexColorPicker
                            style={{ height: 150, minHeight: 150, width: '100%', marginTop: 20 }}
                            color={titledata['title'][device]['style']['arc'].color}
                            onChange={(c) => {
                                updatetitledata('color', c)
                            }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: '100%' }}>
                            <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                            <HexColorInput
                                style={{ width: '100%', borderRadius: 8, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                color={titledata['title'][device]['style']['arc'].color}
                                onChange={(c) => {
                                    updatetitledata('color', c)

                                }}
                            />
                        </div>
                    </>


                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button className='Drawbookedit_cross' onClick={crosstitle}>✗</button>
                        <button className='Drawbookedit_tick' onClick={savetitle}>✓</button>
                    </div>

                </div>
            </DraggablePanel>)}

            {ownergridsubtitletopbool && (<DraggablePanel initialPosition={panelPosition}>
                <div className='Drawbookedit_dragpanelcontent' style={{ maxHeight: 500, overflowY: 'scroll' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

                        {/* Font Size Slider */}
                        {inputdescribe_dom('Font Size :' + titledata['subtitle'][device]['style']['arc'].fontSize, {})}
                        <Slider
                            min={8}
                            max={100}
                            step={1}
                            value={titledata['subtitle'][device]['style']['arc']['fontSize']}
                            onChange={(value) => { updatesubtitledata('fontSize', value) }}
                        />

                        {/* Radius Slider (rx and ry) */}
                        {inputdescribe_dom('rx : ' + titledata['subtitle'][device]['style']['arc'].rx + ' ry : ' + titledata['subtitle'][device]['style']['arc'].ry, {})}
                        <Slider
                            min={0}
                            max={1000}
                            step={1}
                            value={titledata['subtitle'][device]['style']['arc'].rx}
                            onChange={(value) => { updatesubtitledata('rx', value) }}
                        />

                        {/* X-Axis (startX & endX) */}
                        {inputdescribe_dom('startX : ' + titledata['subtitle'][device]['style']['arc'].startX + ' endX : ' + titledata['subtitle'][device]['style']['arc'].endX, {})}
                        <Slider
                            min={-500}
                            max={1500} step={1}
                            value={titledata['subtitle'][device]['style']['arc'].startX}
                            onChange={(value) => { updatesubtitledata('startX', value) }}

                        />

                        {/* Y-Axis (startY & endY) */}
                        {inputdescribe_dom('startY : ' + titledata['subtitle'][device]['style']['arc'].startY + ' endY : ' + titledata['subtitle'][device]['style']['arc'].endY, {})}
                        <Slider
                            min={-500}
                            max={1500} step={1}
                            value={titledata['subtitle'][device]['style']['arc'].startY}
                            onChange={(value) => { updatesubtitledata('startY', value) }}
                        />


                        {/* dy */}
                        {inputdescribe_dom('dy : ' + titledata['subtitle'][device]['style']['arc'].dy, {})}
                        <Slider
                            min={-500}
                            max={1500}
                            step={1}
                            value={titledata['subtitle'][device]['style']['arc'].dy}
                            onChange={(value) => { updatesubtitledata('dy', value) }}
                        />

                        {/* scale */}
                        {inputdescribe_dom('Scale : ' + titledata['subtitle'][device]['style']['arc'].scale, {})}
                        <Slider
                            min={-500}
                            max={1500}
                            step={0.1}
                            value={titledata['subtitle'][device]['style']['arc'].scale}
                            onChange={(value) => { updatesubtitledata('scale', value) }}
                        />

                    </div>

                    {/* Title Input */}
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={titledata['subtitle'].text}
                        onChange={(e) => { updateSubtitletext(e.target.value) }}
                    />

                    <>
                        <HexColorPicker
                            style={{ height: 150, minHeight: 150, width: '100%', marginTop: 20 }}
                            color={titledata['subtitle'][device]['style']['arc'].color}
                            onChange={(c) => {
                                updatesubtitledata('color', c)
                            }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: '100%' }}>
                            <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                            <HexColorInput
                                style={{ width: '100%', borderRadius: 8, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                color={titledata['subtitle'][device]['style']['arc'].color}
                                onChange={(c) => {
                                    updatesubtitledata('color', c)

                                }}
                            />
                        </div>
                    </>

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button className='Drawbookedit_cross' onClick={crosssubtitle}>✗</button>
                        <button className='Drawbookedit_tick' onClick={savesubtitle}>✓</button>
                    </div>

                </div>
            </DraggablePanel>)}

            {ownerscattertitletopbool && (<DraggablePanel initialPosition={panelPosition}>
                <div className='Drawbookedit_dragpanelcontent' style={{ maxHeight: 500, overflowY: 'scroll' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

                        {/* Font Size Slider */}
                        {inputdescribe_dom('Font Size :' + titledata['title'][device]['style']['normaltext']['fontSize'], {})}
                        <Slider
                            min={8}
                            max={100}
                            step={1}
                            value={titledata['title'][device]['style']['normaltext']['fontSize']}
                            onChange={(value) => { updatetitledata('fontSize', value, 'normaltext') }}
                        />

                        {/* Title Input */}
                        <input
                            className='Drawbookedit_dragtextinputroot'
                            value={titledata['title'].text}
                            onChange={(e) => { updateTitletext(e.target.value) }}
                        />

                        <>
                            <HexColorPicker
                                style={{ height: 150, minHeight: 150, width: '100%', marginTop: 20 }}
                                color={titledata['title'][device]['style']['normaltext']['color']}
                                onChange={(c) => {

                                    updatetitledata('color', c, 'normaltext')
                                }}
                            />
                            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: '100%' }}>
                                <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                                <HexColorInput
                                    style={{ width: '100%', borderRadius: 8, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                    color={titledata['title'][device]['style']['normaltext']['color']}
                                    onChange={(c) => {

                                        updatetitledata('color', c, 'normaltext')

                                    }}
                                />
                            </div>
                        </>

                    </div>

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button className='Drawbookedit_cross' onClick={() => {
                            setTitledata((titledata) => {
                                let new_titledata = JSON.parse(JSON.stringify(titledata))
                                new_titledata['title'][device]['style']['normaltext'] = backuptitledata['title'][device]['style']['normaltext']
                                return new_titledata
                            })
                            setOwnerscattertitletopbool(false)
                        }}>✗</button>
                        <button className='Drawbookedit_tick' onClick={saveprintscattertitle}>✓</button>
                    </div>

                </div>
            </DraggablePanel>)}

            {ownerprintqrbool && (<DraggablePanel initialPosition={panelPosition}>
                <div className='Drawbookedit_dragpanelcontent' style={{ maxHeight: 500, overflowY: 'scroll' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

                        {/* Title Input */}
                        <input
                            className='Drawbookedit_dragtextinputroot'
                            value={titledata['qr']['url']}
                            onChange={(e) => {
                                const { value } = e.target
                                setTitledata((titledata) => {
                                    let new_titledata = JSON.parse(JSON.stringify(titledata))
                                    new_titledata['qr']['url'] = value
                                    return new_titledata
                                })
                            }}
                        />

                        {/* Font Size Slider */}
                        {inputdescribe_dom('QR Size :' + titledata['qr'][device]['style'].size, {})}
                        <Slider
                            min={100}
                            max={400}
                            step={1}
                            value={titledata['qr'][device]['style'].size}
                            onChange={(value) => { updateQr('size', value) }}
                        />

                    </div>

                    <>
                        <HexColorPicker
                            style={{ height: 150, minHeight: 150, width: '100%', marginTop: 20 }}
                            color={titledata['qr'][device]['style'].fgColor}
                            onChange={(c) => {

                                updateQr('fgColor', c)
                            }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: '100%' }}>
                            <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                            <HexColorInput
                                style={{ width: '100%', borderRadius: 8, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                color={titledata['qr'][device]['style'].fgColor}
                                onChange={(c) => {

                                    updateQr('fgColor', c)

                                }}
                            />
                        </div>
                    </>

                    <>
                        <HexColorPicker
                            style={{ height: 150, minHeight: 150, width: '100%', marginTop: 20 }}
                            color={titledata['qr'][device]['style'].bgColor}
                            onChange={(c) => {

                                updateQr('bgColor', c)
                            }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: '100%' }}>
                            <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                            <HexColorInput
                                style={{ width: '100%', borderRadius: 8, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                color={titledata['qr'][device]['style'].bgColor}
                                onChange={(c) => {

                                    updateQr('bgColor', c)

                                }}
                            />
                        </div>
                    </>

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'space-between' }}>
                        <button
                            style={{ width: 55, backgroundColor: '#ffffff', color: 'var(--maindark)', border: '1px solid var(--maindark)' }}
                            onClick={() => {
                                updateQr('fgColor', '#000000')
                                updateQr('bgColor', '#ffffff')
                                updateQr('size', 125)
                            }}
                        >
                            Reset
                        </button>
                        <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                            <button
                                className='Drawbookedit_cross'
                                onClick={() => {
                                    setTitledata((titledata) => {
                                        let new_titledata = JSON.parse(JSON.stringify(titledata))
                                        new_titledata['qr'][device] = backuptitledata['qr'][device]
                                        new_titledata['qr']['url'] = backuptitledata['qr']['url']
                                        return new_titledata
                                    })
                                    setOwnerprintqrbool(false)
                                }}>✗</button>
                            <button className='Drawbookedit_tick' onClick={saveprintqr}>✓</button>
                        </div>
                    </div>


                </div>
            </DraggablePanel>)}

        </div>
        : null

    const OWNER_POV_MOBILE = titledata && Object.keys(titledata).length > 0
        ? <div className="Drawbookedit_active" style={{ minHeight: 'calc( 100vh - 61px )' }}>

        </div>
        : null

    // OWNER POINT OF VIEW - END --------------------------------------------------------------------







    // GUEST POINT OF VIEW - START --------------------------------------------------------------------
    const DEVICE_SELECTION_DOM_GUEST = <div className={`itineraryedit_devicebtns${SYSTEM_DEVICE}`} style={{ zIndex: 2, width: 'calc(100% - 35px )' }}>

        {GUEST_OWNER_BTN}

        <div className='Drawbookedit_active_side'>
            <button
                className='Drawbookedit_settingbtn'
                style={{ width: 40, height: 40, backgroundColor: bgcolor }}
                onClick={() => {
                    setColorbackup(bgcolor)
                    setColorbool(true)
                }}
            />
            <button className='Drawbookedit_settingbtn' onClick={() => { setSettingbool(true); }}>
                {iconwrapper(SETTING_ICON, { width: 25, height: 25 })}
            </button>
            {/* <div className='Drawbookedit_numberlabel'>{guestdataaddr.length + ' / ' + maxguestnum}</div> */}
        </div>

    </div>

    const GUEST_POV = (titledata && Object.keys(titledata).length > 0) && (guestpages && Object.keys(guestpages).length > 0)
        ? <div className="Drawbookedit_active" style={{ minHeight: 'calc( 100vh - 61px )' }}>

            <div className={`Drawbookedit_active_left_${SYSTEM_DEVICE} sketchbg`} style={{ overflowX: 'hidden', width: '100%' }}>

                {/* Device Selection */}
                {DEVICE_SELECTION_DOM_GUEST}

                <div style={{ display: 'flex', flexDirection: 'column', margin: '60px 1px 1px', placeContent: 'center', width: '100%', position: 'relative', placeItems: 'center', marginBottom: 60 }}>

                    {/* ENTRY PAGE : TITLE, SUBTITLE, MORE INFO */}
                    <div
                        className={`Drawbookedit_guestpage ${selectedguestpage === 0 ? 'Drawbookedit_guestpageselected' : ''}`}
                        onClick={(e) => { setSelectedguestpage(0); }}
                    >
                        <div className='Drawbookedit_lbl'>Entry Page</div>
                        <div className='Drawbookedit_selectguestnumcontent' onClick={(e) => updatePanelAppearPosition(e)} style={{ height: 473, width: 322, backgroundColor: bgcolor }}>

                            {{
                                // "ARC": <CircularTextInteractive
                                //     width={default_svg_properties['MOBILE'].width}
                                //     height={default_svg_properties['MOBILE'].height}
                                // />,
                                'ARC': <div
                                    style={{
                                        display: 'flex', placeContent: 'flex-start', position: 'relative', flexDirection: 'column',
                                        height: default_svg_properties['MOBILE'].height,
                                        width: default_svg_properties['MOBILE'].width,
                                    }}
                                >
                                    <svg
                                        width={default_svg_properties['MOBILE'].width}
                                        height={default_svg_properties['MOBILE'].height}
                                        viewBox={"0 0 " + default_svg_properties['MOBILE'].width + " " + default_svg_properties['MOBILE'].height}
                                    >
                                        <defs>
                                            <path
                                                id="topArc"
                                                fill="transparent"
                                                d={`
                                                M 
                                                ${guestpages[_0_instruction_page]['title']['style']['arc'].startX}, 
                                                ${guestpages[_0_instruction_page]['title']['style']['arc'].startY} 
                                                A 
                                                ${guestpages[_0_instruction_page]['title']['style']['arc'].rx}, 
                                                ${guestpages[_0_instruction_page]['title']['style']['arc'].ry} 
                                                ${guestpages[_0_instruction_page]['title']['style']['arc']['x-axis-rotation']} 
                                                ${guestpages[_0_instruction_page]['title']['style']['arc']['large-arc-flag']} 
                                                ${guestpages[_0_instruction_page]['title']['style']['arc']['sweep-flag']} 
                                                ${guestpages[_0_instruction_page]['title']['style']['arc'].endX}, 
                                                ${guestpages[_0_instruction_page]['title']['style']['arc'].endY}
                                                `}
                                            />
                                            <path
                                                id="bottomArc"
                                                d={`
                                                M
                                                ${guestpages[_0_instruction_page]['subtitle']['style']['arc'].startX},  
                                                ${guestpages[_0_instruction_page]['subtitle']['style']['arc'].startY} 
                                                A 
                                                ${guestpages[_0_instruction_page]['subtitle']['style']['arc'].rx}, 
                                                ${guestpages[_0_instruction_page]['subtitle']['style']['arc'].ry} 
                                                ${guestpages[_0_instruction_page]['subtitle']['style']['arc']['x-axis-rotation']} 
                                                ${guestpages[_0_instruction_page]['subtitle']['style']['arc']['large-arc-flag']} 
                                                ${guestpages[_0_instruction_page]['subtitle']['style']['arc']['sweep-flag']} 
                                                ${guestpages[_0_instruction_page]['subtitle']['style']['arc'].endX}, 
                                                ${guestpages[_0_instruction_page]['subtitle']['style']['arc'].endY}
                                            `}
                                                fill="transparent"
                                            />
                                        </defs>

                                        <text
                                            fontSize={guestpages[_0_instruction_page]['title']['style']['arc'].fontSize}
                                            fill={guestpages[_0_instruction_page]['title']['style']['arc'].color}
                                            fontFamily={guestpages[_0_instruction_page]['title']['style']['arc'].fontFamily}
                                            dy={guestpages[_0_instruction_page]['title']['style']['arc'].dy}
                                            onClick={(e) => {
                                                // need backup
                                                setEditentrytitletop(true)
                                                setGuestinputbackup((guestinputbackup) => {
                                                    let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                                    new_guestinputbackup['GUEST_ARC_TITLE'] = guestpages[_0_instruction_page]['title']
                                                    return new_guestinputbackup
                                                })
                                            }}
                                            style={{ cursor: 'pointer', width: guestpages[_0_instruction_page]['title']['style']['arc'].width }}

                                        >
                                            <textPath href="#topArc" startOffset="50%" textAnchor="middle">
                                                {guestpages[_0_instruction_page]['title']['text']}
                                            </textPath>
                                        </text>

                                        <text
                                            fontSize={guestpages[_0_instruction_page]['subtitle']['style']['arc'].fontSize}
                                            fill={guestpages[_0_instruction_page]['subtitle']['style']['arc'].color}
                                            fontFamily={guestpages[_0_instruction_page]['subtitle']['style']['arc'].fontFamily}
                                            dy={guestpages[_0_instruction_page]['subtitle']['style']['arc'].dy}
                                            onClick={(e) => {
                                                // need backup
                                                setEditentrytitlebtm(true)
                                                setGuestinputbackup((guestinputbackup) => {
                                                    let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                                    new_guestinputbackup['GUEST_ARC_SUBTITLE'] = guestpages[_0_instruction_page]['subtitle']
                                                    return new_guestinputbackup
                                                })
                                            }}
                                            style={{ cursor: 'pointer', width: guestpages[_0_instruction_page]['subtitle']['style']['arc'].width }}
                                        >
                                            <textPath href="#bottomArc" startOffset="50%" textAnchor="middle">
                                                {guestpages[_0_instruction_page]['subtitle']['text']}
                                            </textPath>
                                        </text>

                                        {/* Vertical center line */}
                                        {gridactive && <line
                                            x1={default_svg_properties['MOBILE'].width / 2}
                                            y1={0}
                                            x2={default_svg_properties['MOBILE'].width / 2}
                                            y2={default_svg_properties['MOBILE'].height}
                                            stroke="#7c7c7c"
                                            strokeWidth={1}
                                            strokeDasharray="4 2"  // ← makes it dashed
                                        />}

                                        {/* Horizontal center line */}
                                        {gridactive && <line
                                            x1={0}
                                            y1={default_svg_properties['MOBILE'].height / 2}
                                            x2={default_svg_properties['MOBILE'].width}
                                            y2={default_svg_properties['MOBILE'].height / 2}
                                            stroke="#7c7c7c"
                                            strokeWidth={1}
                                            strokeDasharray="4 2"  // ← makes it dashed
                                        />}

                                        {/* SVG Border */}
                                        {gridactive && <rect
                                            x={0}
                                            y={0}
                                            width={default_svg_properties['MOBILE'].width}
                                            height={default_svg_properties['MOBILE'].height}
                                            fill="none"
                                            stroke="#7c7c7c"
                                            strokeWidth={1}
                                            strokeDasharray="4 2"  // ← makes it dashed
                                        />}

                                    </svg>

                                </div>,
                                'TEXT': <div>TEXT</div>
                            }[guestpages[_0_instruction_page]['type']]}

                            <div
                                style={{ display: 'flex', flexDirection: 'column' }}
                                onClick={() => {
                                    // need backup
                                    setEditentrytextarea(true)
                                    setGuestinputbackup((guestinputbackup) => {
                                        let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                        new_guestinputbackup['GUEST_THREE_TEXTS'] = guestpages[_0_instruction_page]['guide']
                                        return new_guestinputbackup
                                    })
                                }}>
                                <div className='Drawbookedit_entrytext'>{guestpages[_0_instruction_page]['guide'].text1}</div>
                                <div className='Drawbookedit_entrytext'>{guestpages[_0_instruction_page]['guide'].text2}</div>
                                <div className='Drawbookedit_entrytext'>{guestpages[_0_instruction_page]['guide'].text3}</div>
                            </div>

                            <button
                                className='Drawbookedit_next'
                                style={{ width: 300, height: 40, marginTop: 10, backgroundColor: bgcolor }}
                            >
                                {mode === 'BROADCASTNFT' ? 'Sign In with Base' : 'Next'}
                            </button>

                        </div>

                    </div>

                    {/* SKETCH PAGE : CHOOSE COLOR */}
                    <div
                        className={`Drawbookedit_guestpage ${selectedguestpage === 1 ? 'Drawbookedit_guestpageselected' : ''}`}
                        onClick={() => { setSelectedguestpage(1) }}
                    >
                        <div className='Drawbookedit_lbl'>Sketch Page</div>
                        <div className='Drawbookedit_selectguestnumcontent' style={{ height: 473, width: 322, placeContent: 'space-between', backgroundColor: bgcolor }}>
                            <div>
                                <div className='Drawbookedit_drawingpageclear' >
                                    <button className='Drawbookedit_drawingpagebackbtn'>BACK</button>
                                    <button className='Drawbookedit_drawingpageclearbtn'>CLEAR</button>
                                </div>

                                <div style={{ width: 300, height: 300, border: '1px solid var(--maindark)', backgroundColor: '#ffffff' }}>

                                </div>
                                <div
                                    className='color-picker'
                                    onClick={updatePanelAppearPosition}
                                    style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', overflowX: 'auto' }}
                                >
                                    {guestpages[_1_drawing_page].colors.map((color, i) => {
                                        return <button
                                            value={color}
                                            key={color + '_' + i}
                                            style={{ backgroundColor: color }}
                                            onClick={(e) => {
                                                setEditcolorbool(true)
                                                setGuestinputbackup((guestinputbackup) => {
                                                    let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                                    new_guestinputbackup['GUEST_PALETTE'] = guestpages[_1_drawing_page]['colors']
                                                    new_guestinputbackup['GUEST_AVAILABLE_COLORS'] = availablecolors.slice()
                                                    return new_guestinputbackup
                                                })

                                            }}
                                        />
                                    })}
                                    <button
                                        style={{ border: '1px dashed var(--maindark)', backgroundColor: '#ffffff' }}
                                        onClick={(e) => {
                                            setEditcolorbool(true)
                                            setGuestinputbackup((guestinputbackup) => {
                                                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                                new_guestinputbackup['GUEST_PALETTE'] = guestpages[_1_drawing_page]['colors']
                                                new_guestinputbackup['GUEST_AVAILABLE_COLORS'] = availablecolors.slice()
                                                return new_guestinputbackup
                                            })
                                        }}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>

                            {guestpages[_1_drawing_page]['drawguide'][0].length > 0 && guestpages[_1_drawing_page]['drawguide'][1].length > 0
                                ? <button
                                    className='Drawbookedit_next'
                                    onClick={(e) => {
                                        updatePanelAppearPosition(e)
                                        setEditdrawguidebool(true)
                                        setGuestinputbackup((guestinputbackup) => {
                                            let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                            new_guestinputbackup['DRAW_GUIDE'] = guestpages[_1_drawing_page]['drawguide']
                                            return new_guestinputbackup
                                        })
                                    }}
                                    style={{ width: 300, height: 40, marginTop: 10, backgroundColor: bgcolor }}
                                >
                                    {guestpages[_1_drawing_page]['drawguide'][0]}
                                </button>
                                : <button
                                    className='Drawbookedit_next'
                                    onClick={(e) => {
                                        updatePanelAppearPosition(e)
                                        setEditdrawguidebool(true)
                                        setGuestinputbackup((guestinputbackup) => {
                                            let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                            new_guestinputbackup['DRAW_GUIDE'] = guestpages[_1_drawing_page]['drawguide']
                                            return new_guestinputbackup
                                        })
                                    }}
                                    style={{ width: 300, height: 40, marginTop: 10, backgroundColor: bgcolor }}
                                >
                                    Next
                                </button>}






                        </div>
                    </div>

                    {/* MESSAGE PAGE  */}
                    <div
                        className={`Drawbookedit_guestpage ${selectedguestpage === 2 ? 'Drawbookedit_guestpageselected' : ''}`}
                        onClick={(e) => { updatePanelAppearPosition(e); setSelectedguestpage(2) }}
                    >
                        <div className='Drawbookedit_lbl'>Message Page</div>
                        <div className='Drawbookedit_selectguestnumcontent' style={{ height: 473, width: 322, backgroundColor: bgcolor }}>
                            <input
                                className='Draw_input'
                                style={{ height: 40, width: 300, padding: 5, border: '1px solid var(--maindark)', backgroundColor: 'inherit', marginBottom: 10 }}
                                // placeholder='Your name'
                                placeholder={guestpages[_2_writesomething_page]['nameplaceholder']}
                                onClick={() => {
                                    setEditmessagebool(true)
                                    setGuestinputbackup((guestinputbackup) => {
                                        let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                        new_guestinputbackup['GUEST_DETAILS_NAME_PLACEHOLDER'] = guestpages[_2_writesomething_page]['nameplaceholder']
                                        new_guestinputbackup['GUEST_DETAILS_MSG_PLACEHOLDER'] = guestpages[_2_writesomething_page]['messageplaceholder']
                                        return new_guestinputbackup
                                    })
                                }}
                            />
                            <textarea
                                className='Drawbook_textarearoot'
                                // placeholder='Toast, roast, or advice — leave your mark!'
                                placeholder={guestpages[_2_writesomething_page]['messageplaceholder']}
                                style={{
                                    width: 300,
                                    height: 300,
                                    padding: 5,
                                    border: '1px solid var(--maindark)',
                                    resize: 'vertical', // allow only y-axis resizing
                                    backgroundColor: bgcolor
                                }}
                                onClick={() => {
                                    setEditmessagebool(true)
                                    setGuestinputbackup((guestinputbackup) => {
                                        let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                        new_guestinputbackup['GUEST_DETAILS_NAME_PLACEHOLDER'] = guestpages[_2_writesomething_page]['nameplaceholder']
                                        new_guestinputbackup['GUEST_DETAILS_MSG_PLACEHOLDER'] = guestpages[_2_writesomething_page]['messageplaceholder']
                                        return new_guestinputbackup
                                    })

                                }}
                            />
                            <button className='Drawbookedit_next' style={{ width: 300, height: 40, minHeight: 40, marginTop: 10, backgroundColor: bgcolor }}>Send</button>
                        </div>
                    </div>

                    {/* SUCCESS PAGE : edit placeholder */}
                    <div
                        className={`Drawbookedit_guestpage ${selectedguestpage === 3 ? 'Drawbookedit_guestpageselected' : ''}`}
                        onClick={(e) => {
                            updatePanelAppearPosition(e); setSelectedguestpage(3); setEditsuccessdrawingbool(true)
                            setGuestinputbackup((guestinputbackup) => {
                                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                new_guestinputbackup['GUEST_DETAILS_SUCCESS_UPLOAD_DRAWINGANDMSG'] = guestpages[_3_success_page]['messageplaceholder']
                                return new_guestinputbackup
                            })
                        }}

                    >
                        <div className='Drawbookedit_lbl'>Success Message Page</div>
                        <div className='Drawbookedit_selectguestnumcontent' style={{ height: 473, width: 322, backgroundColor: bgcolor, display: 'flex', placeContent: 'center', textAlign: 'center', textWrap: 'wrap', whiteSpace: 'pre' }}>
                            {/* <>Sealed with love 💕</>
                            <>your message has made it to the guestbook!</> */}
                            {guestpages[3].messageplaceholder}
                        </div>
                    </div>

                    <div className='Drawbookedit_guestpage' style={{ color: '#ffffff', border: 'none' }}>
                        <div className='Drawbookedit_selectguestnumcontent' style={{ width: 322, height: 'max-content', padding: 25, placeItems: 'start', backgroundColor: 'var(--maindark)' }}

                        >

                            {partialtitle_dom(
                                <div style={{ display: 'flex', placeItems: 'center', textAlign: 'center', overflow: 'hidden' }}>
                                    {iconwrapper(IMAGES_ICON, { width: 25, height: 25, marginRight: 5 })}
                                    <div>{'Image Upload'}</div>
                                </div>,
                                { color: '#ffffff' }
                            )}
                            {inputdescribe_dom(`Enable or disable image uploads from your guests`, { color: '#ffffff', marginBottom: 5 })}
                            {radiobtn_dom(
                                allowimgupload ? true : false,
                                () => {
                                    const local_allowimgupload = !allowimgupload
                                    var id = props.match.params.id

                                    axios({
                                        method: 'POST',
                                        url: SAVE_DRAWBOOKSETTING,
                                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                                        data: { _id: id, urlhandler, passcode, maxguestnum, bgcolor, allowimgupload: local_allowimgupload }
                                    })
                                        .then((item) => {
                                            const { message } = item.data
                                            if (message === 'SUCCESS') {
                                                setAllowimgupload(local_allowimgupload)
                                                setSavetxt('Saved!')
                                                setTimeout(() => {
                                                    setSavetxt('')
                                                    setGuestsavebool(false)
                                                }, 1000)
                                            }
                                        }).catch((e) => {
                                            // props.history.push('/') 
                                        })
                                },
                                allowimgupload ? `Enable Guest Image Upload` : `Disable Guest Image Upload`,
                                { margin: 0 }
                            )}
                        </div>
                    </div>

                    {allowimgupload
                        ? <>
                            {/* WANT TO ADD IMAGE PAGE : nothing yet */}
                            <div
                                className={`Drawbookedit_guestpage ${selectedguestpage === _4_addimageornot_page ? 'Drawbookedit_guestpageselected' : ''}`}
                                onClick={(e) => {
                                    updatePanelAppearPosition(e); setSelectedguestpage(_4_addimageornot_page); setEdituploadimageornotbool(true)
                                    setGuestinputbackup((guestinputbackup) => {
                                        let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                        new_guestinputbackup['GUEST_DETAILS_UPLOADIMGORNOT_PLACEHOLDER'] = guestpages[_4_addimageornot_page]['messageplaceholder']
                                        return new_guestinputbackup
                                    })
                                }}
                            >
                                <div className='Drawbookedit_lbl'>Add Image? Page</div>
                                <div className='Drawbookedit_selectguestnumcontent' style={{ height: 473, width: 322, backgroundColor: bgcolor, display: 'flex', placeContent: 'center', textAlign: 'center', flexDirection: 'column', whiteSpace: 'pre-wrap' }}>
                                    {/* <>Would you also like to add an image to the guestbook?</> */}
                                    {guestpages[_4_addimageornot_page].messageplaceholder}
                                    <button style={{ width: 300, height: 40, minHeight: 40, marginTop: 10, backgroundColor: bgcolor, border: '1px solid var(--maindark)', fontSize: 16 }}>Yes</button>
                                    <button style={{ width: 300, height: 40, minHeight: 40, marginTop: 10, backgroundColor: bgcolor, border: '1px solid var(--maindark)', fontSize: 16 }}>No</button>
                                </div>
                            </div>

                            {/* UPLOAD IMAGE PAGE : nothing yet */}
                            <div
                                className={`Drawbookedit_guestpage ${selectedguestpage === 5 ? 'Drawbookedit_guestpageselected' : ''}`}
                                onClick={() => { setSelectedguestpage(5) }}
                            >
                                <div className='Drawbookedit_lbl'>Add Image Page</div>
                                <div className='Drawbookedit_selectguestnumcontent' style={{ height: 473, width: 322, backgroundColor: bgcolor }}>
                                    <div className='Drawbookedit_drawingpageclear' >
                                        <button className='Drawbookedit_drawingpagebackbtn'>BACK</button>
                                    </div>
                                    <div
                                        style={{
                                            width: 300,
                                            height: 300,
                                            padding: 5,
                                            border: '1px dashed var(--maindark)',
                                            resize: 'vertical', // allow only y-axis resizing
                                            backgroundColor: bgcolor,
                                            textAlign: 'center',
                                            placeContent: 'center',
                                            display: 'flex',
                                            placeItems: 'center'
                                        }}
                                    >
                                        {iconwrapper(IMAGES_ICON, { display: 'flex', placeContent: 'center', height: 40, width: 40 })}
                                    </div>
                                    <button className='Drawbookedit_next' style={{ width: 300, height: 40, minHeight: 40, marginTop: 10, backgroundColor: bgcolor }}>Send</button>
                                </div>
                            </div>

                            {/* SUCCESS PAGE : nothing yet */}
                            <div
                                className={`Drawbookedit_guestpage ${selectedguestpage === 6 ? 'Drawbookedit_guestpageselected' : ''}`}
                                onClick={(e) => {
                                    updatePanelAppearPosition(e); setSelectedguestpage(6); setEditsuccessuploadimagebool(true)
                                    setGuestinputbackup((guestinputbackup) => {
                                        let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                        new_guestinputbackup['GUEST_DETAILS_SUCCESS_UPLOAD_IMG'] = guestpages[_6_success_page]['messageplaceholder']
                                        return new_guestinputbackup
                                    })
                                }}
                            >
                                <div className='Drawbookedit_lbl'>Success Image Page</div>
                                <div className='Drawbookedit_selectguestnumcontent' style={{ height: 473, width: 322, backgroundColor: bgcolor, display: 'flex', placeContent: 'center', textAlign: 'center' }}>
                                    {/* Thanks for sharing your love! ❤️ Your photo has been added to the guestbook. */}
                                    {guestpages[6].messageplaceholder}
                                </div>
                            </div>




                        </>
                        : null}

                    {/* FINAL PAGE : Redirect Page */}
                    <div
                        className={`Drawbookedit_guestpage ${selectedguestpage === 7 ? 'Drawbookedit_guestpageselected' : ''}`}
                        onClick={() => {
                            setSelectedguestpage(7);
                            setEditredirectbool(true);
                            setGuestinputbackup((guestinputbackup) => {
                                let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                new_guestinputbackup['GUEST_REDIRECT_PAGE'] = guestpages[_7_redirect_page]
                                return new_guestinputbackup
                            })
                        }}
                    >
                        <div className='Drawbookedit_lbl' style={{ fontSize: 14 }}>{`Redirect Page ( Final Page )`}</div>
                        <div className='Drawbookedit_selectguestnumcontent' style={{ height: 473, width: 322, backgroundColor: bgcolor, display: 'flex', placeContent: 'center', textAlign: 'center', flexDirection: 'column' }}>
                            <div >{guestpages[_7_redirect_page]['title']}</div>
                            {guestpages[_7_redirect_page]['redirectbtns']
                                .map((item, index) => {
                                    if (item[0].length === 0 && item[1].length === 0) return
                                    return <button
                                        key={index}
                                        style={{
                                            width: 300,
                                            height: 40,
                                            minHeight: 40,
                                            marginTop: 10,
                                            fontSize: 16,
                                            backgroundColor: bgcolor,
                                            border: index === guestpages[_7_redirect_page]['redirectbtns'].length - 1 ? 'none' : '1px solid var(--maindark)',
                                        }}
                                    >
                                        {item[0]}
                                    </button>
                                })}
                        </div>
                    </div>

                </div>

            </div>

            {editentrytitletop && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent'>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

                        {/* Font Size Slider */}
                        {inputdescribe_dom('Font Size :' + guestpages[_0_instruction_page]['title']['style']['arc'].fontSize, {})}
                        <Slider
                            min={8}
                            max={100}
                            step={1}
                            value={guestpages[_0_instruction_page]['title']['style']['arc']['fontSize']}
                            onChange={(value) => {
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                    new_guestpages[0]['title']['style']['arc'].fontSize = value
                                    return new_guestpages
                                })
                            }}
                        />

                        {/* Radius Slider (rx and ry) */}
                        {inputdescribe_dom('rx : ' + guestpages[_0_instruction_page]['title']['style']['arc'].rx + ' ry : ' + guestpages[_0_instruction_page]['title']['style']['arc'].ry, {})}
                        <Slider
                            min={0}
                            max={1000}
                            step={1}
                            value={guestpages[_0_instruction_page]['title']['style']['arc'].rx}
                            onChange={(value) => {
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                    new_guestpages[0]['title']['style']['arc'].rx = value
                                    new_guestpages[0]['title']['style']['arc'].ry = value
                                    return new_guestpages
                                })
                            }}
                        />

                        {/* X-Axis (startX & endX) */}
                        {inputdescribe_dom('startX : ' + guestpages[_0_instruction_page]['title']['style']['arc'].startX + ' endX : ' + guestpages[_0_instruction_page]['title']['style']['arc'].endX, {})}
                        <Slider
                            min={-500}
                            max={1500}
                            step={1}
                            value={guestpages[_0_instruction_page]['title']['style']['arc'].startX}
                            onChange={(value) => {
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                    let delta = value - new_guestpages[0]['title']['style']['arc'].startX
                                    new_guestpages[0]['title']['style']['arc'].startX = value
                                    new_guestpages[0]['title']['style']['arc'].endX += delta
                                    return new_guestpages
                                })
                            }}
                        />

                        {/* Y-Axis (startY & endY) */}
                        {inputdescribe_dom('startY : ' + guestpages[_0_instruction_page]['title']['style']['arc'].startY + ' endY : ' + guestpages[_0_instruction_page]['title']['style']['arc'].endY, {})}
                        <Slider
                            min={-500}
                            max={1500}
                            step={1}
                            value={guestpages[_0_instruction_page]['title']['style']['arc'].startY}
                            onChange={(value) => {
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                    let delta = value - new_guestpages[0]['title']['style']['arc'].startY
                                    new_guestpages[0]['title']['style']['arc'].startY = value
                                    new_guestpages[0]['title']['style']['arc'].endY += delta
                                    return new_guestpages
                                })
                            }}
                        />

                    </div>

                    {/* Title Input */}
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_0_instruction_page]['title'].text}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[0]['title'].text = value
                                return new_guestpages
                            })
                        }}
                    />

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button
                            className='Drawbookedit_cross'
                            onClick={() => {
                                setEditentrytitletop(false)
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                    new_guestpages[0]['title'] = guestinputbackup['GUEST_ARC_TITLE']
                                    return new_guestpages
                                })
                            }}>
                            ✗
                        </button>
                        <button
                            className='Drawbookedit_tick'
                            onClick={() => {
                                setEditentrytitletop(false); setGuestsavebool(true); setSavefrom('GUEST_SAVE_TITLE');
                            }}
                        >
                            ✓
                        </button>
                    </div>

                </div>
            </DraggablePanel>
            )}

            {editentrytitlebtm && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent'>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

                        {/* Font Size Slider */}
                        {inputdescribe_dom('Font Size :' + guestpages[_0_instruction_page]['subtitle']['style']['arc'].fontSize, {})}
                        <Slider
                            min={8}
                            max={100}
                            step={1}
                            value={guestpages[_0_instruction_page]['subtitle']['style']['arc']['fontSize']}
                            onChange={(value) => {
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                    new_guestpages[0]['subtitle']['style']['arc'].fontSize = value
                                    return new_guestpages
                                })
                            }}
                        />

                        {/* Radius Slider (rx and ry) */}
                        {inputdescribe_dom('rx : ' + guestpages[_0_instruction_page]['subtitle']['style']['arc'].rx + ' ry : ' + guestpages[_0_instruction_page]['subtitle']['style']['arc'].ry, {})}
                        <Slider
                            min={0}
                            max={1000}
                            step={1}
                            value={guestpages[_0_instruction_page]['subtitle']['style']['arc'].rx}
                            onChange={(value) => {
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                    new_guestpages[0]['subtitle']['style']['arc'].rx = value
                                    new_guestpages[0]['subtitle']['style']['arc'].ry = value
                                    return new_guestpages
                                })
                            }}
                        />

                        {/* X-Axis (startX & endX) */}
                        {inputdescribe_dom('startX : ' + guestpages[_0_instruction_page]['subtitle']['style']['arc'].startX + ' endX : ' + guestpages[_0_instruction_page]['subtitle']['style']['arc'].endX, {})}
                        <Slider
                            min={-500}
                            max={1500}
                            step={1}
                            value={guestpages[_0_instruction_page]['subtitle']['style']['arc'].startX}
                            onChange={(value) => {
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                    let delta = value - new_guestpages[0]['subtitle']['style']['arc'].startX
                                    new_guestpages[0]['subtitle']['style']['arc'].startX = value
                                    new_guestpages[0]['subtitle']['style']['arc'].endX += delta
                                    return new_guestpages
                                })
                            }}
                        />

                        {/* Y-Axis (startY & endY) */}
                        {inputdescribe_dom('startY : ' + guestpages[_0_instruction_page]['subtitle']['style']['arc'].startY + ' endY : ' + guestpages[_0_instruction_page]['subtitle']['style']['arc'].endY, {})}
                        <Slider
                            min={-500}
                            max={1500}
                            step={1}
                            value={guestpages[_0_instruction_page]['subtitle']['style']['arc'].startY}
                            onChange={(value) => {
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                    let delta = value - new_guestpages[0]['subtitle']['style']['arc'].startY
                                    new_guestpages[0]['subtitle']['style']['arc'].startY = value
                                    new_guestpages[0]['subtitle']['style']['arc'].endY += delta
                                    return new_guestpages
                                })
                            }}
                        />

                    </div>

                    {/* Title Input */}
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_0_instruction_page]['subtitle'].text}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[0]['subtitle'].text = value
                                return new_guestpages
                            })
                        }}
                    />

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button
                            className='Drawbookedit_cross'
                            onClick={() => {
                                setEditentrytitlebtm(false)
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                    new_guestpages[0]['subtitle'] = guestinputbackup['GUEST_ARC_SUBTITLE']
                                    return new_guestpages
                                })
                            }}
                        >
                            ✗
                        </button>
                        <button
                            className='Drawbookedit_tick'
                            onClick={() => { setEditentrytitlebtm(false); setGuestsavebool(true); setSavefrom('GUEST_SAVE_SUBTITLE') }}
                        >
                            ✓
                        </button>

                    </div>

                </div>
            </DraggablePanel>
            )}

            {editentrytextarea && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent'>

                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_0_instruction_page]['guide'].text1}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[0]['guide'].text1 = value
                                return new_guestpages
                            })
                        }}
                    />

                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_0_instruction_page]['guide'].text2}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[0]['guide'].text2 = value
                                return new_guestpages
                            })
                        }}
                    />

                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_0_instruction_page]['guide'].text3}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[0]['guide'].text3 = value
                                return new_guestpages
                            })
                        }}
                    />

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button className='Drawbookedit_cross' onClick={() => {
                            setEditentrytextarea(false)
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                new_guestpages[_0_instruction_page]['guide'] = guestinputbackup['GUEST_THREE_TEXTS']
                                return new_guestpages
                            })
                        }}>✗</button>
                        <button className='Drawbookedit_tick' onClick={() => { setEditentrytextarea(false); setGuestsavebool(true); }}>✓</button>
                    </div>
                </div>
            </DraggablePanel>)}

            {/* _2_writesomething_page */}
            {editmessagebool && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent'>

                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_2_writesomething_page]['nameplaceholder']}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[_2_writesomething_page]['nameplaceholder'] = value
                                return new_guestpages
                            })
                        }}
                    />

                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_2_writesomething_page]['messageplaceholder']}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[_2_writesomething_page]['messageplaceholder'] = value
                                return new_guestpages
                            })
                        }}
                    />

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button
                            className='Drawbookedit_cross'
                            onClick={() => {
                                setEditmessagebool(false)
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                    console.log('', guestinputbackup)
                                    new_guestpages[_2_writesomething_page]['nameplaceholder'] = guestinputbackup['GUEST_DETAILS_NAME_PLACEHOLDER']
                                    new_guestpages[_2_writesomething_page]['messageplaceholder'] = guestinputbackup['GUEST_DETAILS_MSG_PLACEHOLDER']
                                    return new_guestpages
                                })
                            }}>
                            ✗
                        </button>
                        <button
                            className='Drawbookedit_tick'
                            onClick={() => {
                                setEditmessagebool(false);
                                setGuestsavebool(true);
                            }}
                        >
                            ✓
                        </button>
                    </div>
                </div>
            </DraggablePanel>)}

            {/* _3_success_page */}
            {editsuccessdrawingbool && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent'>
                    <textarea
                        className='Drawbook_textarearoot'
                        // placeholder='Toast, roast, or advice — leave your mark!'
                        placeholder={guestpages[_3_success_page]['messageplaceholder']}
                        style={{
                            width: '100%',
                            height: 150,
                            border: '1px solid var(--maindark)',
                            resize: 'vertical', // allow only y-axis resizing
                        }}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[_3_success_page]['messageplaceholder'] = value
                                return new_guestpages
                            })
                        }}
                        onClick={() => {
                            if (!editsuccessdrawingbool) {
                                setEditsuccessdrawingbool(true)
                                setGuestinputbackup((guestinputbackup) => {
                                    let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                    new_guestinputbackup['GUEST_DETAILS_SUCCESS_UPLOAD_DRAWINGANDMSG'] = guestpages[_3_success_page]['messageplaceholder']
                                    return new_guestinputbackup
                                })
                            }
                        }}
                    />

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button
                            className='Drawbookedit_cross'
                            onClick={() => {
                                setEditsuccessdrawingbool(false)
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                    new_guestpages[_3_success_page]['messageplaceholder'] = guestinputbackup['GUEST_DETAILS_SUCCESS_UPLOAD_DRAWINGANDMSG']
                                    return new_guestpages
                                })
                            }}
                        >
                            ✗
                        </button>
                        <button
                            className='Drawbookedit_tick'
                            onClick={() => { setEditsuccessdrawingbool(false); setGuestsavebool(true); }}
                        >
                            ✓
                        </button>
                    </div>
                </div>
            </DraggablePanel>)}

            {/* _6_success_page */}
            {editsuccessuploadimagebool && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent'>

                    <textarea
                        className='Drawbook_textarearoot'
                        placeholder={guestpages[_6_success_page]['messageplaceholder']}
                        style={{
                            width: '100%',
                            height: 150,
                            border: '1px solid var(--maindark)',
                            resize: 'vertical', // allow only y-axis resizing
                        }}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[_6_success_page]['messageplaceholder'] = value
                                return new_guestpages
                            })
                        }}
                        onClick={() => {
                            if (!editsuccessuploadimagebool) {
                                setEditsuccessuploadimagebool(true)
                                setGuestinputbackup((guestinputbackup) => {
                                    let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                    new_guestinputbackup['GUEST_DETAILS_SUCCESS_UPLOAD_IMG'] = guestpages[_6_success_page]['messageplaceholder']
                                    return new_guestinputbackup
                                })
                            }
                        }}
                    />

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button
                            className='Drawbookedit_cross'
                            onClick={() => {
                                setEditsuccessuploadimagebool(false)
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                    new_guestpages[_6_success_page]['messageplaceholder'] = guestinputbackup['GUEST_DETAILS_SUCCESS_UPLOAD_IMG']
                                    return new_guestpages
                                })
                            }}
                        >
                            ✗
                        </button>
                        <button
                            className='Drawbookedit_tick'
                            onClick={() => { setEditentrytextarea(false); setGuestsavebool(true); }}
                        >
                            ✓
                        </button>
                    </div>
                </div>
            </DraggablePanel>)}

            {edituploadimageornotbool && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent'>

                    <textarea
                        className='Drawbook_textarearoot'
                        placeholder={guestpages[_4_addimageornot_page]['messageplaceholder']}
                        style={{
                            width: '100%',
                            height: 150,
                            border: '1px solid var(--maindark)',
                            resize: 'vertical', // allow only y-axis resizing
                        }}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[_4_addimageornot_page]['messageplaceholder'] = value
                                return new_guestpages
                            })
                        }}
                        onClick={() => {
                            if (!edituploadimageornotbool) {
                                setEdituploadimageornotbool(true)
                                setGuestinputbackup((guestinputbackup) => {
                                    let new_guestinputbackup = JSON.parse(JSON.stringify(guestinputbackup))
                                    new_guestinputbackup['GUEST_DETAILS_UPLOADIMGORNOT_PLACEHOLDER'] = guestpages[_4_addimageornot_page]['messageplaceholder']
                                    return new_guestinputbackup
                                })
                            }
                        }}
                    />

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button
                            className='Drawbookedit_cross'
                            onClick={() => {
                                setEdituploadimageornotbool(false)
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                    new_guestpages[_4_addimageornot_page]['messageplaceholder'] = guestinputbackup['GUEST_DETAILS_UPLOADIMGORNOT_PLACEHOLDER']
                                    return new_guestpages
                                })
                            }}
                        >
                            ✗
                        </button>
                        <button
                            className='Drawbookedit_tick'
                            onClick={() => { setEdituploadimageornotbool(false); setGuestsavebool(true); }}
                        >
                            ✓
                        </button>
                    </div>
                </div>
            </DraggablePanel>)}

            {editcolorbool && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent'>
                    <div
                        style={{ flexDirection: 'row', display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}
                    >
                        {purchase.status === 'BOUGHT'
                            ? <>
                                {partialtitle_dom('Palette', {})}
                                {inputdescribe_dom(`Add color to your current palette.`)}
                                <HexColorPicker
                                    style={{ height: 175, width: '100%', marginTop: 20 }}
                                    color={currhexcolor}
                                    onChange={(c) => {
                                        if (!availablecolors.includes(c)) { setCurrhexcolor(c) }
                                    }}
                                />
                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center', width: '100%' }}>
                                    <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                                    <HexColorInput
                                        style={{ width: '100%', borderRadius: 8, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                        color={currhexcolor}
                                        onChange={(c) => {
                                            if (!availablecolors.includes(c)) { setCurrhexcolor(c) }
                                        }}
                                    />
                                </div>
                                <button
                                    className='Guestbook_addcolorbtn'
                                    style={{ margin: 0, marginTop: 5, padding: 0, fontSize: 13, borderRadius: 8 }}
                                    onClick={() => {
                                        setAvailablecolors((old_availablecolors) => {
                                            let new_result = old_availablecolors.slice()
                                            if (!old_availablecolors.includes(currhexcolor)) {
                                                new_result.push(currhexcolor)
                                            }
                                            return new_result
                                        })
                                    }}>
                                    Add Color
                                </button>
                            </>
                            : null}

                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10, width: '100%' }}>
                            {partialtitle_dom('Select colors', {})}
                            {inputdescribe_dom(`Select colors your users can use.`)}
                            <div style={{ display: 'flex', flexDirection: 'row', overflowX: 'auto', width: '100%' }}>
                                {[...DEFAULT_COLORS, ...availablecolors].map((color, i) => <div
                                    key={color + '_' + i}
                                    style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', placeContent: 'center', fontSize: 12 }}
                                >
                                    <div style={{ border: guestpages[1].colors.includes(color) ? '1px solid var(--mainpink)' : '1px solid white', display: 'flex', placeContent: 'center', placeItems: 'center', padding: 2, borderRadius: '100%', margin: '0px 2px' }}>
                                        <button
                                            className='Guestbook_userselectioncolor'
                                            key={i + color}
                                            value={color}
                                            style={{
                                                backgroundColor: color,
                                                color: '#ffffff',
                                                display: 'flex',
                                                textAlign: 'center',
                                                placeContent: 'center',
                                                margin: 0,
                                                padding: 0
                                            }}
                                            onClick={(e) => {
                                                const { value } = e.target
                                                setGuestpages((guestpages) => {
                                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                                    if (!new_guestpages[1].colors.includes(value)) {
                                                        new_guestpages[1].colors.push(value)
                                                    }
                                                    else {
                                                        new_guestpages[1].colors.splice(new_guestpages[1].colors.indexOf(value), 1)
                                                    }
                                                    return new_guestpages
                                                })
                                            }}
                                        />
                                    </div>
                                    {!DEFAULT_COLORS.includes(color)
                                        ? <button
                                            onClick={() => {

                                                setAvailablecolors((availablecolors) => {
                                                    let new_availablecolors = availablecolors.slice()
                                                    new_availablecolors.splice(new_availablecolors.indexOf(color), 1)
                                                    return new_availablecolors
                                                })

                                                setGuestpages((guestpages) => {
                                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                                    if (new_guestpages[1].colors.includes(color)) {
                                                        new_guestpages[1].colors.splice(new_guestpages[1].colors.indexOf(color), 1)
                                                    }
                                                    return new_guestpages
                                                })


                                            }}
                                            style={{
                                                fontSize: 12, display: 'flex', width: '100%', placeContent: 'center',
                                                textAlign: 'center', backgroundColor: '#ffffff', border: 'none',
                                                padding: 0, margin: 0
                                            }}
                                        >
                                            x
                                        </button>
                                        : <button
                                            onClick={() => { }}
                                            style={{
                                                fontSize: 12, display: 'flex', width: '100%', placeContent: 'center',
                                                textAlign: 'center', backgroundColor: '#ffffff', border: 'none',
                                                padding: 0, margin: 0, color: 'transparent'
                                            }}
                                        >
                                            x
                                        </button>}
                                </div>
                                )}
                            </div>

                        </div>


                    </div>

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button
                            className='Drawbookedit_cross'
                            onClick={() => {
                                setEditcolorbool(false)
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                    new_guestpages[1]['colors'] = guestinputbackup['GUEST_AVAILABLE_COLORS']
                                    return new_guestpages
                                })
                                setAvailablecolors(guestinputbackup['GUEST_AVAILABLE_COLORS'].slice())
                            }}>
                            ✗
                        </button>
                        <button className='Drawbookedit_tick' onClick={() => { setEditcolorbool(false); setGuestsavebool(true); setSavefrom('GUEST_SAVE_COLOR_PALETTE'); }}>
                            ✓
                        </button>
                    </div>
                </div>
            </DraggablePanel>)}

            {/* drawguide */}
            {editdrawguidebool && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent' style={{ gap: 0 }}>

                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_1_drawing_page]['drawguide'][0]}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[_1_drawing_page]['drawguide'][0] = value
                                return new_guestpages
                            })
                        }}
                    />
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        style={{ borderTop: 'none', marginBottom: 10 }}
                        value={guestpages[_1_drawing_page]['drawguide'][1]}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[_1_drawing_page]['drawguide'][1] = value
                                return new_guestpages
                            })
                        }}
                    />

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end' }}>
                        <button
                            className='Drawbookedit_cross'
                            onClick={(e) => {
                                setEditdrawguidebool(false)
                                setGuestpages((guestpages) => {
                                    let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                    new_guestpages[_1_drawing_page]['drawguide'] = guestinputbackup['DRAW_GUIDE'].slice()
                                    return new_guestpages
                                })
                            }}>
                            ✗
                        </button>
                        <button
                            className='Drawbookedit_tick'
                            onClick={() => {
                                setEditdrawguidebool(false);
                                setGuestsavebool(true);
                                setSavefrom('GUEST_SAVE_COLOR_PALETTE');
                            }}
                        >
                            ✓
                        </button>
                    </div>
                </div>
            </DraggablePanel>)}

            {/* redirect */}
            {editredirectbool && (<DraggablePanel initialPosition={panelPosition} >
                <div className='Drawbookedit_dragpanelcontent' style={{ gap: 0 }}>
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_7_redirect_page]['title']}
                        style={{ marginBottom: 10 }}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((prev) => {
                                const new_guestpages = JSON.parse(JSON.stringify(prev));
                                new_guestpages[_7_redirect_page].title = value;   // ✅ mutate clone
                                return new_guestpages;
                            });

                        }}
                    />
                    {/* 1 */}
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_7_redirect_page]['redirectbtns'][0][0]}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[_7_redirect_page]['redirectbtns'][0][0] = value
                                return new_guestpages
                            })
                        }}
                    />
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        style={{ borderTop: 'none', marginBottom: 10 }}
                        value={guestpages[_7_redirect_page]['redirectbtns'][0][1]}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[_7_redirect_page]['redirectbtns'][0][1] = value
                                return new_guestpages
                            })
                        }}
                    />


                    {/* 2 */}
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_7_redirect_page]['redirectbtns'][1][0]}
                        onChange={(e) => {
                            const { value } = e.target;
                            console.log('value', value)
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[_7_redirect_page]['redirectbtns'][1][0] = value
                                return new_guestpages
                            })
                        }}
                    />
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        style={{ borderTop: 'none', marginBottom: 10 }}
                        value={guestpages[_7_redirect_page]['redirectbtns'][1][1]}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[7]['redirectbtns'][1][1] = value
                                return new_guestpages
                            })
                        }}
                    />

                    {/* 3 */}
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_7_redirect_page]['redirectbtns'][2][0]}
                        onChange={(e) => {
                            const { value } = e.target;
                            console.log('value', value)
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[7]['redirectbtns'][2][0] = value
                                return new_guestpages
                            })
                        }}
                    />
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        style={{ borderTop: 'none', marginBottom: 10 }}
                        value={guestpages[_7_redirect_page]['redirectbtns'][2][1]}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[7]['redirectbtns'][2][1] = value
                                return new_guestpages
                            })
                        }}
                    />


                    {/* 4 */}
                    <input
                        className='Drawbookedit_dragtextinputroot'
                        value={guestpages[_7_redirect_page]['redirectbtns'][3][0]}
                        onChange={(e) => {
                            const { value } = e.target;
                            console.log('value', value)
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[7]['redirectbtns'][3][0] = value
                                return new_guestpages
                            })
                        }}
                    />
                    <div className='Drawbookedit_dragtextinputroot' style={{ backgroundColor: 'var(--maindark)', color: '#ffffff', placeItems: 'center', display: 'flex', padding: 1 }}>
                        Submit New Entry
                    </div>
                    {/* <input
                        className='Drawbookedit_dragtextinputroot'
                        style={{ borderTop: 'none', marginBottom: 10 }}
                        value={guestpages[_7_redirect_page]['redirectbtns'][3][1]}
                        onChange={(e) => {
                            const { value } = e.target;
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages));
                                new_guestpages[7]['redirectbtns'][3][1] = value
                                return new_guestpages
                            })
                        }}
                    /> */}

                    {/* Buttons */}
                    <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end', marginTop: 10 }}>
                        <button className='Drawbookedit_cross' onClick={() => {
                            // editredirectbool
                            setEditredirectbool(false)
                            setGuestpages((guestpages) => {
                                let new_guestpages = JSON.parse(JSON.stringify(guestpages))
                                new_guestpages[7] = guestinputbackup['GUEST_REDIRECT_PAGE']
                                return new_guestpages
                            })
                        }}>✗</button>
                        <button className='Drawbookedit_tick'
                            onClick={() => {
                                setEditredirectbool(false);
                                setGuestsavebool(true);
                            }}>
                            ✓
                        </button>
                    </div>
                </div>
            </DraggablePanel>)}

        </div>
        : null
    // GUEST POINT OF VIEW - END --------------------------------------------------------------------



    // for the segmented guestbook

    const downloadSVGAsPNG_SEGMENTS_old = async (svgElement, scaleFactor = 4) => {

        if (!svgElement) {
            console.error("SVG element not found");
            return;
        }

        // ✅ Step 1: inline all images
        await embedExternalImages(svgElement);

        // ✅ Step 2: serialize
        const serializer = new XMLSerializer();
        let svgString = serializer.serializeToString(svgElement);

        // ✅ Step 3: inject font
        const fontStyle = `
          <style>
            @font-face {
              font-family: 'Lato';
              src: url('https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wWA.woff2') format('woff2');
            }
            * { font-family: 'Lato', sans-serif; }
            ${downloadtransparent
                ? `svg {
                background: none !important; /* Ensure transparent background */
              }`
                : ``}
          </style>
        `;


        if (!svgString.includes("xmlns=\"http://www.w3.org/2000/svg\"")) {
            svgString = svgString.replace(
                "<svg",
                "<svg xmlns=\"http://www.w3.org/2000/svg\""
            );
        }
        svgString = svgString.replace("</svg>", `${fontStyle}</svg>`);

        // ✅ Step 4: turn into blob & canvas
        const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
        const url = URL.createObjectURL(svgBlob);

        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
            const canvas = document.createElement("canvas");
            const width = svgElement.clientWidth;
            const height = svgElement.clientHeight;
            canvas.width = width * scaleFactor;
            canvas.height = height * scaleFactor;

            const ctx = canvas.getContext("2d");
            ctx.setTransform(scaleFactor, 0, 0, scaleFactor, 0, 0);
            ctx.drawImage(img, 0, 0);

            URL.revokeObjectURL(url);

            const imgURI = canvas.toDataURL("image/png");
            const link = document.createElement("a");
            link.download = "guestbook.png";
            link.href = imgURI;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
        img.onerror = (e) => console.error("Image failed to load", e);

        img.src = url;
    };

    const downloadSVGAsPNG_SEGMENTS = async (svgElement, scaleFactor = 4) => {

        async function embedExternalImages(svgElement) {
            const images = svgElement.querySelectorAll("image");
            for (let img of images) {
                const href = img.getAttribute("xlink:href") || img.getAttribute("href");
                if (!href || href.startsWith("data:")) continue; // already embedded

                try {
                    const res = await fetch(href, { mode: "cors" });
                    const blob = await res.blob();
                    const reader = new FileReader();

                    await new Promise((resolve) => {
                        reader.onloadend = () => {
                            img.setAttribute("xlink:href", reader.result); // replace with base64
                            img.removeAttribute("href"); // Clean up the href attribute
                            resolve();
                        };
                        reader.readAsDataURL(blob);
                    });
                } catch (e) {
                    console.error("Failed to inline image:", href, e);
                }
            }
        }


        // Function 2: Fetches the font file and encodes it as a Base64 Data URI
        async function getFontBase64(fontUrl) {
            try {
                const response = await fetch(fontUrl);
                const blob = await response.blob();

                return await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        // Returns the Base64 string: "data:application/font-woff2;base64,..."
                        resolve(reader.result);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
            } catch (e) {
                console.error("Failed to fetch and encode font:", fontUrl, e);
                return null;
            }
        }


        if (!svgElement) {
            console.error("SVG element not found");
            return;
        }


        // const latoFontUrl = 'https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wWA.woff2';
        const latoFontUrl = 'https://fonts.gstatic.com/s/lato/v23/S6uyw4BMUTPHjxAwXiWtFCfQ7A.woff2';


        // ✅ Step 1: Inline all external images
        await embedExternalImages(svgElement);

        // ✅ Step 2: Fetch and embed the font data (Must succeed for the fontStyle to be correct)
        const latoBase64 = await getFontBase64(latoFontUrl);

        // ✅ Step 3: Serialize the SVG element
        const serializer = new XMLSerializer();
        let svgString = serializer.serializeToString(svgElement);

        // ✅ Step 4: Inject font styles and background settings
        const fontStyle = `
          <style>
            @font-face {
              font-family: 'Lato';
              /* This should now point to the data URI from the successful fetch */
              src: ${latoBase64 ? `url('${latoBase64}') format('woff2');` : `/* FONT EMBEDDING FAILED! */`}
              /* Add font-display: swap; as a fallback, though less relevant for base64 */
              font-display: swap; 
            }
            * { font-family: 'Lato', sans-serif; }
            ${downloadtransparent
                ? `svg {
                background: none !important; /* Ensure transparent background */
              }`
                : ``}
          </style>
        `;

        // Ensure xmlns is included and inject the style block
        if (!svgString.includes("xmlns=\"http://www.w3.org/2000/svg\"")) {
            svgString = svgString.replace(
                "<svg",
                "<svg xmlns=\"http://www.w3.org/2000/svg\""
            );
        }
        svgString = svgString.replace("</svg>", `${fontStyle}</svg>`);

        // 🌟 ✅ Step 5: Convert the SVG string to a Base64 Data URI (REVISED for reliability)
        const utf8Bytes = new TextEncoder().encode(svgString);
        const charCodes = Array.from(utf8Bytes, byte => String.fromCharCode(byte));
        const svgBase64 = btoa(charCodes.join(''));
        const url = `data:image/svg+xml;base64,${svgBase64}`;

        const img = new Image();

        img.onload = () => {
            const canvas = document.createElement("canvas");
            const width = svgElement.clientWidth;
            const height = svgElement.clientHeight;
            canvas.width = width * scaleFactor;
            canvas.height = height * scaleFactor;

            const ctx = canvas.getContext("2d");
            ctx.setTransform(scaleFactor, 0, 0, scaleFactor, 0, 0);
            ctx.drawImage(img, 0, 0);

            try {
                const imgURI = canvas.toDataURL("image/png");

                // ✅ Step 6: Trigger Download
                const link = document.createElement("a");
                link.download = "guestbook.png";
                link.href = imgURI;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (e) {
                console.error("Failed to export canvas:", e);
            }
        };

        img.onerror = (e) => console.error("Image failed to load", e);

        // Start the loading process
        img.src = url;


    };

    const downloadSVGAsPNG_SEGMENTS_asdfasfdf = (svgElement, scaleFactor = 4) => {
        console.log('svgElement', svgElement)
        if (!svgElement) {
            console.error("SVG element not found");
            return;
        }

        const serializer = new XMLSerializer();
        let svgString = serializer.serializeToString(svgElement);

        // Inject Google Font (Lato) into the SVG
        const fontStyle = `
            <style>
              @font-face {
                font-family: 'Lato';
                src: url('https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wWA.woff2') format('woff2');
                font-weight: normal;
                font-style: normal;
              }
              * { font-family: 'Lato', sans-serif; }
              ${downloadtransparent
                ? `svg {
                background: none !important; /* Ensure transparent background */
              }`
                : ``}
            </style>
          `;

        setTimeout(() => {
            // Ensure xmlns is included for proper rendering
            if (!svgString.includes("xmlns=\"http://www.w3.org/2000/svg\"")) {
                svgString = svgString.replace(
                    "<svg",
                    "<svg xmlns=\"http://www.w3.org/2000/svg\""
                );
            }

            svgString = svgString.replace("</svg>", `${fontStyle}</svg>`);

            const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
            const url = URL.createObjectURL(svgBlob);

            const img = new Image();
            img.crossOrigin = "anonymous";

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const width = svgElement.clientWidth;
                const height = svgElement.clientHeight;
                canvas.width = width * scaleFactor;
                canvas.height = height * scaleFactor;

                const ctx = canvas.getContext("2d");
                ctx.setTransform(scaleFactor, 0, 0, scaleFactor, 0, 0);
                ctx.drawImage(img, 0, 0);

                try {
                    const imgURI = canvas.toDataURL("image/png");

                    // ✅ Step 6: Trigger Download
                    const link = document.createElement("a");
                    link.download = "guestbook.png";
                    link.href = imgURI;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                } catch (e) {
                    console.error("Failed to export canvas:", e);
                }
            };

            img.onerror = (e) => console.error("Image failed to load", e);

            // Start the loading process
            img.src = url;
        }, 1000)

    };

    const downloadSVGAsPNG_NORMAL = (scaleFactor = 4) => {

        const svgElement = svgRef.current;

        if (!svgElement) {
            console.error("SVG element not found");
            return;
        }

        const serializer = new XMLSerializer();
        let svgString = serializer.serializeToString(svgElement);

        // Inject Google Font (Lato) into the SVG
        const fontStyle = `
            <style>
              @font-face {
                font-family: 'Lato';
                src: url('https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHjx4wWA.woff2') format('woff2');
                font-weight: normal;
                font-style: normal;
              }
              * { font-family: 'Lato', sans-serif; }
              ${downloadtransparent
                ? `svg {
                background: none !important; /* Ensure transparent background */
              }`
                : ``}
            </style>
          `;

        setTimeout(() => {
            // Ensure xmlns is included for proper rendering
            if (!svgString.includes("xmlns=\"http://www.w3.org/2000/svg\"")) {
                svgString = svgString.replace(
                    "<svg",
                    "<svg xmlns=\"http://www.w3.org/2000/svg\""
                );
            }

            svgString = svgString.replace("</svg>", `${fontStyle}</svg>`);

            const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
            const url = URL.createObjectURL(svgBlob);

            const img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const width = svgElement.clientWidth;
                const height = svgElement.clientHeight;

                canvas.width = width * scaleFactor;
                canvas.height = height * scaleFactor;

                const ctx = canvas.getContext("2d");
                ctx.setTransform(scaleFactor, 0, 0, scaleFactor, 0, 0);
                ctx.drawImage(img, 0, 0);

                URL.revokeObjectURL(url);

                const imgURI = canvas.toDataURL("image/png");

                const link = document.createElement("a");
                link.download = "guestbook.png";
                link.href = imgURI;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            };

            img.onerror = (e) => {
                console.error("Image failed to load", e);
            };

            img.src = url;
        }, 1000)
    };

    const portalmidcss = { width: { 'WEB': 500, 'TABLET': 473, 'MOBILE': '100%' }[SYSTEM_DEVICE], height: { 'WEB': 500, 'TABLET': 400, 'MOBILE': '100%' }[SYSTEM_DEVICE], backgroundColor: 'white', top: '50%', left: '50%', right: '', transform: 'translate(-50%,-50%)' }


    return <div className="Drawbookedit_root">


        {{
            'GUESTACTIVE': <Etsydummypanel>
                Customise what your guests will see during the event.
                Choose a drawing theme and customise the text and background colours to match your event style.
            </Etsydummypanel>,
            'OWNERACTIVE': device === 'PRINT'
                ? <Etsydummypanel>
                    Edit and download a printable version of your guestbook, along with all the doodles created by your guests.
                </Etsydummypanel>
                : <Etsydummypanel>
                    Customise and manage the content of your guestbook.
                </Etsydummypanel>
        }[page]}

        {topbar}
        {/* <CircularTextInteractive width={500} height={500} /> */}
        {SYSTEM_DEVICE !== 'MOBILE'
            ? {
                '': (
                    <div className="Drawbookedit_col" style={{ height: 'calc( 100vh - 61px )', backgroundColor: bgcolor }}>

                    </div>
                ),
                'SELECTGUESTNUM': (
                    <div className="Drawbookedit_col" style={{ height: 'calc( 100vh - 61px )', backgroundColor: bgcolor }}>
                        <div className='Drawbookedit_selectguestnumcontent'>
                            {setting_dom}
                            <button
                                className='Drawbookedit_next'
                                onClick={() => {
                                    var id = props.match.params.id
                                    axios({
                                        method: 'POST',
                                        url: SAVE_DRAWBOOKSETTING,
                                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                                        data: { _id: id, urlhandler, passcode, bgcolor, allowimgupload: allowimgupload }
                                        // data: { _id: id, urlhandler, passcode, maxguestnum, bgcolor, allowimgupload: allowimgupload }
                                    })
                                        .then((item) => {
                                            const { message } = item.data
                                            if (message === 'SUCCESS') {
                                                setPage('GUESTACTIVE')
                                            }
                                        })
                                        .catch((e) => {
                                            // props.history.push('/') 
                                        })
                                }}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                ),
                'OWNERACTIVE': {
                    'WEB': OWNER_POV_WEBTABLET,
                    'TABLET': OWNER_POV_WEBTABLET,
                    'MOBILE': OWNER_POV_MOBILE,
                }[SYSTEM_DEVICE],
                'GUESTACTIVE': GUEST_POV
            }[page]
            : <div className="Drawbookedit_col" style={{ height: 'calc( 100vh - 61px )' }}>
                <div id='itineraryedit_mobilebtm'>
                    <div style={{ padding: 10, display: 'flex', textAlign: 'center' }}>Sorry, this feature is currently only supported on a desktop or laptop and is not available on mobile devices.</div>
                    <button id='itineraryedit_mobilebtmbtn' onClick={() => props.history.push('/')}>Home</button>
                </div>
            </div>}

        {home_mod}

        {(savetxt && savetxt.length > 0) ? <Noti noti={savetxt} /> : null}

        <Portalmodal /* setting */
            portaltype={'commonportal'}
            open={settingbool}
            onClose={() => {
                setSettingbool(false)
                setBackupactive((backupactive) => {
                    setGridactive(backupactive.gridactive)
                    setPlayactive(backupactive.playactive)
                    setQractive(backupactive.qractive)
                    setTitleactive(backupactive.titleactive)
                    setPlaceholderactive(backupactive.placeholderactive)
                    setMode(backupactive.mode)
                    return backupactive
                })
            }}
            floatingclose={false}
            backdropvisible={true}
            modalstyle={portalmidcss}
            closestyle={{ right: 0 }}
            title={'Settings'}
            floatingclosecolor='#333333'
        >
            <div className={SYSTEM_DEVICE === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >

                <div className="inviteedit_helproot" style={{ paddingBottom: 100, height: 'calc( 100% - 60px)', overflowY: 'scroll' }}>

                    <div className='Details_grp'>
                        {partialtitle_dom('Grid', {})}
                        {inputdescribe_dom(`Display grid lines on the page while editing.`)}
                        {radiobtn_dom(
                            gridactive ? true : false,
                            () => { setGridactive(!gridactive) },
                            gridactive ? `Grid Enabled` : `Grid Disabled`,
                            { margin: 0 }
                        )}
                    </div>

                    <div className='Details_grp'>
                        {partialtitle_dom('Path Auto Play', {})}
                        {inputdescribe_dom(`Path will be show directly instead of showing the path drawn`)}
                        {radiobtn_dom(
                            playactive ? true : false,
                            () => {
                                setPlayactive(!playactive)
                            },
                            playactive ? `Auto-Play Enabled` : `Auto-Play Disabled`,
                            { margin: 0 }
                        )}
                    </div>

                    <div className='Details_grp'>
                        {partialtitle_dom('QR code ( Print Mode Only )', {})}
                        {inputdescribe_dom(`Click to generate the QR code at the bottom-right of the canvas.`)}
                        {radiobtn_dom(
                            qractive ? true : false,
                            () => {
                                setQractive(!qractive)
                            },
                            qractive ? `QR Enabled` : `QR disabled`,
                            { margin: 0 }
                        )}
                    </div>

                    <div className='Details_grp'>
                        {partialtitle_dom('Title ( Print Mode Only )', {})}
                        {inputdescribe_dom(`Click to enable or disable title.`)}
                        {radiobtn_dom(
                            titleactive ? true : false,
                            () => {
                                setTitleactive(!titleactive)
                            },
                            titleactive ? `Title Enabled` : `Title disabled`,
                            { margin: 0 }
                        )}
                    </div>

                    <div className='Details_grp'>
                        {partialtitle_dom('Placeholder ( Print Mode Only )', {})}
                        {inputdescribe_dom(`Click to show or hide the placeholder for empty entries in Grid mode.`)}
                        {radiobtn_dom(
                            placeholderactive ? true : false,
                            () => {
                                setPlaceholderactive(!placeholderactive)
                            },
                            placeholderactive ? `Placeholder Enabled` : `Placeholder disabled`,
                            { margin: 0 }
                        )}
                    </div>

                    {shownftcounter === 20
                        ? <div className='Details_grp'>
                            {partialtitle_dom('Guestbook Mode', {})}
                            {inputdescribe_dom(`Pick a guestbook mode that suits your preference.`)}
                            <div className='Drawbookedit_moderowroot'>
                                <button
                                    className='Drawbookedit_moderowbtnrootleft'
                                    onClick={(e) => { setMode('DEFAULT') }}
                                    style={mode === 'DEFAULT'
                                        ? { backgroundColor: 'var(--mainpink)', color: '#ffffff' }
                                        : { backgroundColor: '#ffffff', color: 'var(--maindark)' }}
                                >
                                    <div className='Drawbookedit_moderowrootmaincontent'>Normal</div>
                                    <div className='Drawbookedit_moderowrootsubcontent'>Default</div>
                                </button>
                                <button
                                    className='Drawbookedit_moderowbtnrootright'
                                    onClick={(e) => { setMode('BROADCASTNFT') }}
                                    style={mode === 'BROADCASTNFT'
                                        ? { backgroundColor: 'var(--mainpink)', color: '#ffffff' }
                                        : { backgroundColor: '#ffffff', color: 'var(--maindark)' }}
                                >
                                    <div className='Drawbookedit_moderowrootmaincontent'>{`NFT ( BASE )`}</div>
                                    <div className='Drawbookedit_moderowrootsubcontent'>Collect Crypto Address</div>
                                </button>
                                {/* "both" coming soon.... */}
                                {/* <button onClick={()=>{ setMode(e.target.value)}} value={'DEFAULT_AND_BROADCASTNFT'}>Both</button> */}
                            </div>
                        </div>

                        :
                        <button
                            style={{ width: '100%', height: 50, border: 'none', backgroundColor: 'transparent' }}
                            onClick={() => {
                                setShownftcounter(shownftcounter + 1)
                            }}
                        >
                        </button>
                    }

                </div>

                <div className='Drawbookedit_savebgcolorroot'>
                    <button
                        className='Drawbookedit_savebgcolor'

                        onClick={() => {
                            var id = props.match.params.id
                            axios({
                                method: 'POST',
                                url: SAVE_DRAWBOOKGENERALSETTING,
                                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                                data: { _id: id, urlhandler, passcode, gridactive, playactive, qractive, titleactive, placeholderactive, mode }
                            })
                                .then((item) => {
                                    const { message } = item.data
                                    if (message === 'SUCCESS') {
                                        setSavetxt('Saved!')
                                        setTimeout(() => {
                                            setBackupactive({
                                                qractive: qractive,
                                                gridactive: gridactive,
                                                playactive: playactive,
                                                titleactive: titleactive,
                                                placeholderactive: placeholderactive,
                                                mode: mode
                                            })
                                            setSavetxt('')
                                            setSettingbool(false)
                                        }, 1000)

                                    }
                                }).catch((e) => {
                                    // props.history.push('/') 
                                })
                        }}
                    >
                        Save
                    </button>
                </div>


            </div>

        </Portalmodal>

        <Portalmodal /* color */
            portaltype={'commonportal'}
            open={colorbool}
            onClose={() => { setColorbool(false); setBgcolor(colorbackup) }}
            floatingclose={false}
            backdropvisible={true}
            modalstyle={portalmidcss}
            closestyle={{ right: 0 }}
            title={'Color'}
            floatingclosecolor='#333333'
        >
            <div className={SYSTEM_DEVICE === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
                <div className="inviteedit_helproot" >
                    {color_content}
                    {/* <button
                        className='Drawbookedit_savebgcolor'
                        onClick={() => {
                            var id = props.match.params.id
                            axios({
                                method: 'POST',
                                url: SAVE_DRAWBOOKSETTING,
                                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                                data: { _id: id, urlhandler, passcode, maxguestnum, bgcolor, allowimgupload }
                            })
                                .then((item) => {
                                    const { message } = item.data
                                    if (message === 'SUCCESS') {
                                        setSavetxt('Saved!')
                                        setTimeout(() => {
                                            setSavetxt('')
                                            setColorbool(false);
                                        }, 1000)
                                    }
                                }).catch((e) => {
                                    // props.history.push('/') 
                                })
                        }}
                    >
                        Save
                    </button> */}



                </div>

                <div className='Drawbookedit_savebgcolorroot'>
                    <button
                        className='Drawbookedit_savebgcolor'
                        onClick={() => {
                            var id = props.match.params.id
                            axios({
                                method: 'POST',
                                url: SAVE_DRAWBOOKSETTING,
                                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                                data: { _id: id, urlhandler, passcode, maxguestnum, bgcolor, allowimgupload }
                            })
                                .then((item) => {
                                    const { message } = item.data
                                    if (message === 'SUCCESS') {
                                        setSavetxt('Saved!')
                                        setTimeout(() => {
                                            setSavetxt('')
                                            setColorbool(false);
                                        }, 1000)
                                    }
                                }).catch((e) => {
                                    // props.history.push('/') 
                                })
                        }}
                    >
                        Save
                    </button>

                </div>
            </div>

        </Portalmodal>

        <Portalmodal /* download */
            portaltype={'commonportal'}
            open={printbool}
            onClose={() => {
                setPrintbool(false);
                setDownloadtransparent(!downloadtransparent);
            }}
            floatingclose={false}
            backdropvisible={true}
            modalstyle={portalmidcss}
            closestyle={{ right: 0 }}
            title={'Download'}
            floatingclosecolor='#333333'
        >
            <div className={SYSTEM_DEVICE === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
                <div className="inviteedit_helproot">

                    <div className="Details_grp" >
                        {partialtitle_dom('Background', {})}
                        <div className="Scdesign_portalrow">
                            {checkbox_dom(
                                downloadtransparent,
                                () => {
                                    const txt = document.querySelector(".ce_checkboxtxt");
                                    const checkbox = document.querySelector(".ce_checkbox");
                                    checkbox.checked = !checkbox.checked;
                                    setDownloadtransparent(!downloadtransparent)
                                },
                                'Transparent Background',
                            )}
                        </div>
                    </div>



                    {currentprint === 'SPRITE'
                        ? <button
                            style={{ height: 40, width: '100%', backgroundColor: '#ffffff', color: 'var(--maindark)', border: '1px solid var(--maindark)' }}
                            onClick={() => downloadSVGAsPNG_NORMAL(4)}
                        >
                            {`Download As ${currentprint + '/' + lookuptype} Image (A2)`}
                        </button>
                        : downloadablesegmentRefs
                            ? downloadablesegmentRefs.current.map((item, index) => {

                                return <button
                                    key={'download' + index}
                                    style={{ height: 40, width: '100%', backgroundColor: '#ffffff', color: 'var(--maindark)', border: '1px solid var(--maindark)', marginBottom: 10 }}
                                    onClick={() => downloadSVGAsPNG_SEGMENTS(item, 4)}
                                >
                                    {`${index + 1} Download As Image (A2)`}
                                </button>
                            })
                            : null}

                </div>
            </div>

        </Portalmodal>

        <Portalmodal /* purchase */
            portaltype={'commonportal'}
            open={purchasemodal}
            onClose={() => setPurchasemodal(false)}
            floatingclose={false}
            backdropvisible={true}
            modalstyle={portalmidcss}
            closestyle={{ right: 0 }}
            title={'Purchase'}
            floatingclosecolor='#333333'
        >
            <div className={SYSTEM_DEVICE === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
                <div className="inviteedit_helproot">

                    <div className='Details_grp'>
                        {partialtitle_dom('Plans', {})}
                        <div className='Guestbookedit_purchaseroot'>
                            <div className='Guestbookedit_purchasepackage1' style={{ border: purchase && purchase.status === '' ? '1px solid var(--maindark)' : '1px solid var(--lightdark)' }}>
                                <div
                                    className='Guestbookedit_purchasetitle'
                                    style={{ borderBottom: purchase && purchase.status === '' ? '1px solid var(--maindark)' : '1px solid var(--lightdark)' }}
                                >
                                    {`Lite - FREE`}
                                </div>
                                <div>Up to 30 guests</div>
                                <div>Basic Downloadables</div>
                            </div>
                            <div className='Guestbookedit_purchasepackage2' style={{ border: purchase && purchase.status === 'BOUGHT' ? '1px solid var(--maindark)' : '1px solid var(--lightdark)' }}>
                                <div
                                    className='Guestbookedit_purchasetitle'
                                    style={{ borderBottom: purchase && purchase.status === 'BOUGHT' ? '1px solid var(--maindark)' : '1px solid var(--lightdark)', color:'var(--mainpink)' }}
                                    onClick={() => window.open('https://www.etsy.com/sg-en/shop/WeaveBlissStudio', '_blank')}
                                >
                                    {/* {`Premium — 35 USD` + (purchase && purchase.status === 'BOUGHT' ? ' (Bought)' : '')} */}
                                    Visit Etsy Shop
                                </div>
                                <div>Up to 350 guests</div>
                                <div>Customize colors</div>
                                <div>Customize display mode</div>
                                <div>Enable Scatter mode</div>
                                <div>Download all data</div>
                                <div>and more...visit our Etsy shop for more details.</div>
                            </div>
                        </div>
                    </div>

                    {purchase && purchase.status === 'BOUGHT'
                        ? <div className='Details_grp'>
                            {partialtitle_dom('Activate premium features ( ETSY )', {})}
                            {inputdescribe_dom(`Enter the code to unlock premium features.`)}
                            <div className='Guestbookedit_purchasesendroot' style={{ fontWeight: 'bold', backgroundColor: 'var(--maindark)', padding: 5, color: '#ffffff' }}>
                                Premium Bought
                            </div>

                        </div>
                        : <div className='Details_grp'>
                            {partialtitle_dom('Activate premium features ( ETSY )', {})}
                            {inputdescribe_dom(`Enter the code to unlock premium features.`)}
                            <div className='Guestbookedit_purchasesendroot'>
                                <input
                                    className='Guestbookedit_purchaseinput'
                                    onChange={(e) => { setPurchasecode(e.target.value) }}

                                />
                                <button
                                    className='Guestbookedit_purchasesend'
                                    style={{ border: '1px solid var(--maindark)', width: 80, borderRadius: 0, borderLeft: 'none', backgroundColor: '#ffffff', height: 40 }}
                                    onClick={() => {

                                        axios({
                                            method: 'POST',
                                            url: ACTIVATE_GUESTBOOKPREMIUM,
                                            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                                            data: { _id: drawbookid, urlhandler, passcode, purchasecode, }
                                        })
                                            .then((item) => {
                                                const { message, } = item.data
                                                if (message === 'SUCCESS') {
                                                    const { result } = item.data
                                                    const { purchase, newprintproperties,maxguestnum } = result
                                                    setPurchase(JSON.parse(JSON.stringify(purchase)))
                                                    setMaxguestnum(maxguestnum)
                                                    setProperties((properties) => {
                                                        let local_properties = JSON.parse(JSON.stringify(properties))
                                                        local_properties['PRINT']['GRID'] = newprintproperties
                                                        return local_properties
                                                    })
                                                }
                                            })
                                            .catch((e) => { })
                                    }}
                                >
                                    Send
                                </button>
                            </div>

                        </div>
                    }




                </div>
            </div>

        </Portalmodal>



        {/* <Portalmodal
            portaltype={'commonportal'}
            open={questionmarkmodal}
            onClose={() => setQuestionmarkmodal(false)}
            floatingclose={false}
            backdropvisible={true}
            modalstyle={portalmidcss}
            closestyle={{ right: 0 }}
            title={'Help'}
            floatingclosecolor='#333333'
        >
            <div className={SYSTEM_DEVICE === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
                <div className="inviteedit_helproot">

                    <div className='Details_grp'>
                        {partialtitle_dom('1) Edit Your Guestbook Settings', {})}

                        <h4>Start Here</h4>
                        <p>
                            Begin by customizing your <b>Guestbook Settings</b>.
                            This is the page your guests will interact with.
                        </p>
                        <p>
                            When guests visit your guestbook, they will see the series of pages you’ve designed.
                            Adjust the layout, wording, prompts, and overall style to match your preference.
                        </p>
                        <p>
                            Take your time here — this is the experience your guests will enjoy on your special day.
                        </p>
                    </div>


                    <div className='Details_grp'>
                        {partialtitle_dom('2) Collect Entries on Your Wedding Day', {})}

                        <h4>On The Big Day</h4>
                        <p>
                            Once your Guestbook Settings are ready, you’re all set.
                        </p>
                        <p>
                            On your wedding day, guests can doodle, write messages, and upload photos.
                        </p>
                        <p>
                            No additional setup is required — simply collect the love, laughter,
                            and memories shared by your guests.
                        </p>
                    </div>


                    <div className='Details_grp'>
                        {partialtitle_dom('3) Customize Your Final Guestbook (Lookup Settings)', {})}

                        <h4>After Your Wedding</h4>
                        <p>
                            Head to <b>Lookup Settings</b> to customise how your final guestbook will appear.
                        </p>
                        <p>
                            You can adjust the display style for different devices
                            (mobile, tablet, desktop).
                        </p>
                        <p>
                            Once finalized, your guestbook becomes downloadable —
                            transforming all the beautiful entries into a polished keepsake
                            you can treasure forever.
                        </p>
                    </div>

                </div>
            </div>
        </Portalmodal> */}


        <Portalmodal /* questionmark */
            portaltype={'commonportal'}
            open={questionmarkmodal}
            onClose={() => setQuestionmarkmodal(false)}
            floatingclose={false}
            backdropvisible={true}
            modalstyle={portalmidcss}
            closestyle={{ right: 0 }}
            title={'Help'}
            floatingclosecolor='#333333'
        >
            <div className={SYSTEM_DEVICE === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
                <div className="inviteedit_helproot">
                    <div className="Details_grp">
                        <h4>1. Edit Your Guestbook Settings</h4>
                        <p>
                            Start by customizing your <b>Guestbook Settings</b>.
                            This is the page your guests will interact with.
                        </p>
                        <p>
                            When guests visit your guestbook, they will see the series of pages you have designed.
                            Make sure to adjust the layout, wording, prompts, and overall style to match your preference.
                        </p>
                        <p>
                            Take your time here - this is the experience your guests will enjoy on your special day.
                        </p>
                    </div>

                    <div className="Details_grp">
                        <h4>2. Collect Entries on Your Wedding Day</h4>
                        <p>
                            Once your Guestbook Settings are ready, you're all set for the big day.
                        </p>
                        <p>
                            On your wedding day, guests can doodle, write messages, and upload photos.
                            Simply let the memories roll in and enjoy the moment.
                        </p>
                        <p>
                            No additional setup is required during the event — just collect the love and well wishes from your guests.
                        </p>
                    </div>

                    <div className="Details_grp">
                        <h4>3. Customize Your Final Guestbook (Lookup Settings)</h4>
                        <p>
                            After your wedding, head to <b>Lookup Settings</b>.
                        </p>
                        <p>
                            This section allows you to customise how your final guestbook will look across different devices
                            (mobile, tablet, desktop).
                        </p>
                        <p>
                            Once finalized, your guestbook will be available for download — turning all those beautiful
                            entries into a polished keepsake you can treasure forever.
                        </p>
                    </div>

                </div>
            </div>
        </Portalmodal>


    </div>



}

export default Guestbookedit;